/* eslint-disable */
/*************************************************
 * This File is autogenerated do not directly edit
 * Run yarn graphql:codegen to regenerate
 *************************************************/

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  EmailAddress: any;
  JSONObject: any;
  PhoneNumber: any;
};

export type ActivityLogOrderConnection = {
  __typename?: 'ActivityLogOrderConnection';
  edges?: Maybe<Array<Maybe<ActivityLogOrderEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ActivityLogOrderEdge = {
  __typename?: 'ActivityLogOrderEdge';
  node?: Maybe<OrderChangelog>;
};

export type AddBuyerInput = {
  buyer?: InputMaybe<CreateBuyerInput>;
  orderId: Scalars['ID'];
};

export type AddNoteInput = {
  appliesTo?: InputMaybe<AppliesTo>;
  appliesToId?: InputMaybe<Scalars['String']>;
  attributions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  body: Scalars['String'];
  entityId: Scalars['String'];
  entityType: NoteEntityType;
};

/** These are the fields that will be stored on the new OrderParty - deprecated (Use CreateOrderPartyInput instead) */
export type AddPartyToOrderPayload = {
  /** When directoryContactId has a value, this field must also have a value. Otherwise, this field is optional. */
  directoryCompanyId?: InputMaybe<Scalars['String']>;
  directoryContactId?: InputMaybe<Scalars['String']>;
  isSettlementUseOnly?: InputMaybe<Scalars['Boolean']>;
  refSectionId?: InputMaybe<Scalars['String']>;
  refSectionLabel?: InputMaybe<Scalars['String']>;
  roleId: Scalars['String'];
};

/** This is the result of adding the party to the order */
export type AddPartyToOrderResult = {
  __typename?: 'AddPartyToOrderResult';
  party?: Maybe<OrderParty>;
};

export type AddSellerInput = {
  orderId: Scalars['ID'];
  seller?: InputMaybe<CreateSellerInput>;
};

export type AddSequenceInput = {
  currentSequenceNumber?: InputMaybe<Scalars['Int']>;
  numberOfDigitsInSequence: Scalars['Int'];
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sequenceName: Scalars['String'];
  template: Scalars['String'];
};

export type AddUserRecentOrderInput = {
  id: Scalars['ID'];
};

export type AddUserRecentOrderPayload = {
  __typename?: 'AddUserRecentOrderPayload';
  user: User;
};

export type AdditionalQuestion = {
  __typename?: 'AdditionalQuestion';
  answer?: Maybe<Scalars['String']>;
  answerType?: Maybe<Scalars['String']>;
  defaultAnswer?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inputType: Scalars['String'];
  options: Array<AdditionalQuestionAnswerOption>;
  question: Scalars['String'];
};

export type AdditionalQuestionAnswerOption = {
  __typename?: 'AdditionalQuestionAnswerOption';
  description: Scalars['String'];
  id: Scalars['String'];
};

export type AdditionalQuestionInput = {
  answer: Scalars['String'];
  answerType: Scalars['String'];
  defaultAnswer?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  inputType: Scalars['String'];
  options?: InputMaybe<Array<AdditionalQuestionOptionInput>>;
  question: Scalars['String'];
};

export type AdditionalQuestionOptionInput = {
  description: Scalars['String'];
  id: Scalars['String'];
};

export type AdditionalQuestionsRateRequest = {
  answer: Scalars['String'];
  answerType: Scalars['String'];
  id: Scalars['String'];
};

export type AdditionalQuestionsRateValidationRequest = {
  answer?: InputMaybe<Scalars['String']>;
  answerType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']>;
  address1AndAddress2?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressType?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  countyFips?: Maybe<Scalars['String']>;
  countyName?: Maybe<Scalars['String']>;
  fullDomesticAddress?: Maybe<Scalars['String']>;
  fullDomesticMailingAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  stateOrProvince?: Maybe<Scalars['String']>;
  stateOrProvinceDetail?: Maybe<StateDetail>;
  usePrimaryAddress?: Maybe<Scalars['Boolean']>;
};

export type AddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countyFips?: InputMaybe<Scalars['String']>;
  countyName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  stateOrProvince?: InputMaybe<Scalars['String']>;
  usePrimaryAddress?: InputMaybe<Scalars['Boolean']>;
};

export type AdjustableInterestRateTable = {
  __typename?: 'AdjustableInterestRateTable';
  firstChange?: Maybe<Scalars['Float']>;
  firstChangeFrequency?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['String']>;
  initialInterestRate?: Maybe<Scalars['Float']>;
  margin?: Maybe<Scalars['Float']>;
  maximumInterestRate?: Maybe<Scalars['Float']>;
  minimumInterestRate?: Maybe<Scalars['Float']>;
  subsequentChange?: Maybe<Scalars['Float']>;
  subsequentChangeFrequency?: Maybe<Scalars['String']>;
};

export type AdjustableInterestRateTableInput = {
  firstChange?: InputMaybe<Scalars['Float']>;
  firstChangeFrequency?: InputMaybe<Scalars['String']>;
  index?: InputMaybe<Scalars['String']>;
  initialInterestRate?: InputMaybe<Scalars['Float']>;
  margin?: InputMaybe<Scalars['Float']>;
  maximumInterestRate?: InputMaybe<Scalars['Float']>;
  minimumInterestRate?: InputMaybe<Scalars['Float']>;
  subsequentChange?: InputMaybe<Scalars['Float']>;
  subsequentChangeFrequency?: InputMaybe<Scalars['String']>;
};

export type AdjustablePaymentsTable = {
  __typename?: 'AdjustablePaymentsTable';
  firstChange?: Maybe<Scalars['String']>;
  firstChangeAt?: Maybe<Scalars['String']>;
  interestOnlyPayments?: Maybe<Scalars['Boolean']>;
  maximumPayment?: Maybe<Scalars['Float']>;
  maximumPaymentStartsAt?: Maybe<Scalars['String']>;
  numInterestOnlyPayments?: Maybe<Scalars['Int']>;
  numOptionalPayments?: Maybe<Scalars['Int']>;
  numStepPayments?: Maybe<Scalars['Int']>;
  optionalPayments?: Maybe<Scalars['Boolean']>;
  seasonalPayments?: Maybe<Scalars['Boolean']>;
  seasonalPaymentsFrom?: Maybe<Scalars['String']>;
  seasonalPaymentsTo?: Maybe<Scalars['String']>;
  stepPayments?: Maybe<Scalars['Boolean']>;
  subsequentChangesEvery?: Maybe<Scalars['String']>;
};

export type AdjustablePaymentsTableInput = {
  firstChange?: InputMaybe<Scalars['String']>;
  firstChangeAt?: InputMaybe<Scalars['String']>;
  interestOnlyPayments?: InputMaybe<Scalars['Boolean']>;
  maximumPayment?: InputMaybe<Scalars['Float']>;
  maximumPaymentStartsAt?: InputMaybe<Scalars['String']>;
  numInterestOnlyPayments?: InputMaybe<Scalars['Int']>;
  numOptionalPayments?: InputMaybe<Scalars['Int']>;
  numStepPayments?: InputMaybe<Scalars['Int']>;
  optionalPayments?: InputMaybe<Scalars['Boolean']>;
  seasonalPayments?: InputMaybe<Scalars['Boolean']>;
  seasonalPaymentsFrom?: InputMaybe<Scalars['String']>;
  seasonalPaymentsTo?: InputMaybe<Scalars['String']>;
  stepPayments?: InputMaybe<Scalars['Boolean']>;
  subsequentChangesEvery?: InputMaybe<Scalars['String']>;
};

export type Adjustment = {
  __typename?: 'Adjustment';
  amount?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  dcLineMapping?: Maybe<AdjustmentLineMappings>;
  dcSectionMapping?: Maybe<AdjustmentSectionMapping>;
  defaultLineMapping: DefaultLineMapping;
  description: Scalars['String'];
  externalItemId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDebitCredit: Scalars['Boolean'];
  lineMapping: AdjustmentLineMappings;
  lineType: Scalars['String'];
  orderId: Scalars['String'];
  payeePayorId?: Maybe<Scalars['String']>;
  sectionMapping: AdjustmentSectionMapping;
  tenantId: Scalars['String'];
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type AdjustmentLineMapping = {
  __typename?: 'AdjustmentLineMapping';
  addendumLineNumber?: Maybe<Scalars['Int']>;
  lineNumber: Scalars['Int'];
};

export type AdjustmentLineMappings = {
  __typename?: 'AdjustmentLineMappings';
  alta?: Maybe<AdjustmentLineMapping>;
  cd?: Maybe<AdjustmentLineMapping>;
  hud1986?: Maybe<AdjustmentLineMapping>;
  hud2010?: Maybe<AdjustmentLineMapping>;
};

export type AdjustmentResponseWithMirror = {
  __typename?: 'AdjustmentResponseWithMirror';
  adjustment: Adjustment;
  mirrorAdjustment?: Maybe<Adjustment>;
};

export type AdjustmentSectionMapping = {
  __typename?: 'AdjustmentSectionMapping';
  alta?: Maybe<Scalars['String']>;
  cd?: Maybe<Scalars['String']>;
  hud1986?: Maybe<Scalars['String']>;
  hud2010?: Maybe<Scalars['String']>;
};

export type AdminCredentialAgentNetStatus = {
  __typename?: 'AdminCredentialAgentNetStatus';
  active: Scalars['Boolean'];
};

export type AdminDomain = {
  __typename?: 'AdminDomain';
  permissionsRuleSets?: Maybe<PermissionsRuleSets>;
  title?: Maybe<AdminTitleDomain>;
};

export type AdminMilestone = {
  __typename?: 'AdminMilestone';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sortIndex: Scalars['Int'];
  tasks?: Maybe<Array<Maybe<AdminTask>>>;
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
  workflowId: Scalars['ID'];
};

export type AdminMilestoneInput = {
  name: Scalars['String'];
};

export type AdminSetAgentNetOffices = {
  mapping: Array<InputMaybe<AgentNetOfficeMapItem>>;
};

export type AdminSetCredentialAgentNet = {
  personalAccessToken: Scalars['String'];
};

export type AdminTask = {
  __typename?: 'AdminTask';
  active: Scalars['Boolean'];
  assignedTo?: Maybe<Scalars['String']>;
  assignment: TaskAssignment;
  createdBy?: Maybe<User>;
  createdById: Scalars['ID'];
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  departmentDependency?: Maybe<Scalars['String']>;
  due: TaskDue;
  id: Scalars['ID'];
  milestoneId: Scalars['ID'];
  name: Scalars['String'];
  sortIndex: Scalars['Int'];
  start: TaskStart;
  type?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp: Scalars['DateTime'];
  workflowId: Scalars['ID'];
};

export type AdminTaskInput = {
  active: Scalars['Boolean'];
  assignment: TaskAssignmentInput;
  departmentDependency?: InputMaybe<Scalars['String']>;
  due: TaskDueInput;
  name: Scalars['String'];
  sortIndex: Scalars['Int'];
  start: TaskStartInput;
  type: Scalars['String'];
};

export type AdminTitleDomain = {
  __typename?: 'AdminTitleDomain';
  _empty?: Maybe<Scalars['String']>;
  buyerSellerSplit?: Maybe<BuyerSellerSplit>;
  clausePackages?: Maybe<ClausePackageDomain>;
  clauseTemplates?: Maybe<ClauseTemplateDomain>;
};

export type AdminWorkflow = {
  __typename?: 'AdminWorkflow';
  active?: Maybe<Scalars['Boolean']>;
  companies?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  milestones?: Maybe<Array<Maybe<AdminMilestone>>>;
  name: Scalars['String'];
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  transactionPurpose?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['ID']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type AdminWorkflowInput = {
  active: Scalars['Boolean'];
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionPurpose?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AgentDisclosureFeeAdditionalData = {
  __typename?: 'AgentDisclosureFeeAdditionalData';
  externalLenderPremiumId?: Maybe<Scalars['String']>;
  externalOwnerPremiumId?: Maybe<Scalars['String']>;
  overallAgentRetainedAmount?: Maybe<Scalars['Float']>;
};

export type AgentNetAdminOfficesResponse = {
  __typename?: 'AgentNetAdminOfficesResponse';
  firms: Array<Maybe<AgentNetFirm>>;
  mapping: Array<Maybe<AgentNetOfficeMapping>>;
};

export type AgentNetAdminSetOfficesResponse = {
  __typename?: 'AgentNetAdminSetOfficesResponse';
  mapping: Array<Maybe<AgentNetOfficeMapping>>;
};

export type AgentNetFirm = {
  __typename?: 'AgentNetFirm';
  id: Scalars['Int'];
  name: Scalars['String'];
  offices: Array<Maybe<AgentNetOffice>>;
};

export type AgentNetOffice = {
  __typename?: 'AgentNetOffice';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type AgentNetOfficeMapItem = {
  agentNetFirm: Scalars['Int'];
  agentNetOffice: Scalars['Int'];
  fluentBranch: Scalars['String'];
};

export type AgentNetOfficeMapping = {
  __typename?: 'AgentNetOfficeMapping';
  agentNetFirm: Scalars['Int'];
  agentNetOffice: Scalars['Int'];
  fluentBranch: Scalars['String'];
};

export type AltaSectionSummaryTotals = {
  __typename?: 'AltaSectionSummaryTotals';
  creditBorrower: Scalars['Float'];
  creditSeller?: Maybe<Scalars['Float']>;
  debitBorrower: Scalars['Float'];
  debitSeller?: Maybe<Scalars['Float']>;
  toFromBorrower: Scalars['Float'];
  toFromSeller?: Maybe<Scalars['Float']>;
  totalBorrowerCredit: Scalars['Float'];
  totalBorrowerDebit: Scalars['Float'];
  totalSellerCredit?: Maybe<Scalars['Float']>;
  totalSellerDebit?: Maybe<Scalars['Float']>;
};

export type AltaStatement = {
  __typename?: 'AltaStatement';
  costSections?: Maybe<Array<Maybe<AltaStatementCostSection>>>;
  header?: Maybe<AltaStatementHeader>;
  signatures?: Maybe<Array<Maybe<AltaStatementSignature>>>;
  totals?: Maybe<AltaStatementTotals>;
};

export type AltaStatementCostSection = {
  __typename?: 'AltaStatementCostSection';
  items?: Maybe<Array<Maybe<AltaStatementCostSectionItem>>>;
  title?: Maybe<Scalars['String']>;
};

export type AltaStatementCostSectionItem = {
  __typename?: 'AltaStatementCostSectionItem';
  buyerCredit?: Maybe<Scalars['Float']>;
  buyerDebit?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  sellerCredit?: Maybe<Scalars['Float']>;
  sellerDebit?: Maybe<Scalars['Float']>;
};

export type AltaStatementHeader = {
  __typename?: 'AltaStatementHeader';
  additionalDates?: Maybe<Array<Maybe<AltaStatementHeaderAdditionalDates>>>;
  altaId?: Maybe<Scalars['String']>;
  buyerAllNames?: Maybe<Scalars['String']>;
  companyLogo?: Maybe<Scalars['String']>;
  disbursementDate?: Maybe<Scalars['String']>;
  escrowOfficer?: Maybe<Scalars['String']>;
  lenderName?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  sellerAllNames?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  settlementLocation?: Maybe<Scalars['String']>;
  timeSettlement?: Maybe<Scalars['String']>;
  titleCompanyAddress?: Maybe<Scalars['String']>;
  titleCompanyName?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
};

export type AltaStatementHeaderAdditionalDates = {
  __typename?: 'AltaStatementHeaderAdditionalDates';
  date?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type AltaStatementSignature = {
  __typename?: 'AltaStatementSignature';
  entityName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerofAttorneySigningName?: Maybe<Scalars['String']>;
};

export type AltaStatementTotals = {
  __typename?: 'AltaStatementTotals';
  borrowerDue?: Maybe<AltaStatementTotalsBorrowerDue>;
  sellerDue?: Maybe<AltaStatementTotalsSellerDue>;
  subtotal?: Maybe<AltaStatementTotalsSubtotal>;
  total?: Maybe<AltaStatementTotalsTotal>;
};

export type AltaStatementTotalsBorrowerDue = {
  __typename?: 'AltaStatementTotalsBorrowerDue';
  buyerCredit?: Maybe<Scalars['Float']>;
  buyerDebit?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type AltaStatementTotalsSellerDue = {
  __typename?: 'AltaStatementTotalsSellerDue';
  description?: Maybe<Scalars['String']>;
  sellerCredit?: Maybe<Scalars['Float']>;
  sellerDebit?: Maybe<Scalars['Float']>;
};

export type AltaStatementTotalsSubtotal = {
  __typename?: 'AltaStatementTotalsSubtotal';
  buyerCredit?: Maybe<Scalars['Float']>;
  buyerDebit?: Maybe<Scalars['Float']>;
  sellerCredit?: Maybe<Scalars['Float']>;
  sellerDebit?: Maybe<Scalars['Float']>;
};

export type AltaStatementTotalsTotal = {
  __typename?: 'AltaStatementTotalsTotal';
  buyerCredit?: Maybe<Scalars['Float']>;
  buyerDebit?: Maybe<Scalars['Float']>;
  sellerCredit?: Maybe<Scalars['Float']>;
  sellerDebit?: Maybe<Scalars['Float']>;
};

export type AmountIncreaseAfterClosingQuestion = {
  __typename?: 'AmountIncreaseAfterClosingQuestion';
  asHighAsAmount?: Maybe<Scalars['Float']>;
  canIncreaseUntilIncrement?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type AmountIncreaseAfterClosingQuestionInput = {
  asHighAsAmount?: InputMaybe<Scalars['Float']>;
  canIncreaseUntilIncrement?: InputMaybe<Scalars['Float']>;
  response?: InputMaybe<Scalars['Boolean']>;
};

export enum ApiFilterOperator {
  Begins = 'begins',
  Contains = 'contains',
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte',
  Neq = 'neq',
  NotContains = 'notContains',
  Size = 'size'
}

export enum AppliesTo {
  Documents = 'documents',
  Funding = 'funding',
  Invoices = 'invoices',
  Order = 'order',
  Settlement = 'settlement',
  Title = 'title',
  Workflow = 'workflow'
}

export type ApprovedAttorney = {
  __typename?: 'ApprovedAttorney';
  address: Scalars['String'];
  attorneyId: Scalars['String'];
  attorneyName: Scalars['String'];
  city: Scalars['String'];
  isDefault: Scalars['Boolean'];
  state: Scalars['String'];
  underwriterId: Scalars['String'];
  zip: Scalars['String'];
};

export type AuthorizedSignatoryUser = {
  __typename?: 'AuthorizedSignatoryUser';
  firstName: Scalars['String'];
  isActive: Scalars['Boolean'];
  isUnderwriterAuthorizedSignatory: Scalars['Boolean'];
  lastName: Scalars['String'];
  userId: Scalars['String'];
};

export type AutoClearTotals = {
  __typename?: 'AutoClearTotals';
  disbursements: TransactionCategoryStatus;
  receipts: TransactionCategoryStatus;
};

export type AvailableWorkflow = {
  __typename?: 'AvailableWorkflow';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type Bai2TransactionSummary = {
  __typename?: 'BAI2TransactionSummary';
  additionalInformation: Scalars['String'];
  amount: Scalars['Float'];
  receiptOrDisbursement: Scalars['String'];
  referenceNumber: Scalars['String'];
  typeOfTransaction: Scalars['String'];
};

export type BalanceGridDisbursementSummaryForm = {
  __typename?: 'BalanceGridDisbursementSummaryForm';
  fundedBalance?: Maybe<Scalars['Float']>;
  fundedDisbursementBalance?: Maybe<Scalars['Float']>;
  fundedReceiptBalance?: Maybe<Scalars['Float']>;
  orderBalance?: Maybe<Scalars['Float']>;
  orderDisbursementBalance?: Maybe<Scalars['Float']>;
  orderReceiptBalance?: Maybe<Scalars['Float']>;
  remainingDisbursements?: Maybe<Scalars['Float']>;
  remainingReceipts?: Maybe<Scalars['Float']>;
};

export type BaseOrder = {
  __typename?: 'BaseOrder';
  address?: Maybe<Address>;
  branch?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Array<Maybe<BuyerSellerName>>>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lenders?: Maybe<Array<Maybe<Scalars['String']>>>;
  order?: Maybe<Order>;
  orderNumber?: Maybe<Scalars['String']>;
  sellerNames?: Maybe<Array<Maybe<BuyerSellerName>>>;
  settlementDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  transactionType?: Maybe<TransactionType>;
};

export type BaseOrderCommissionsLineItem = {
  agentType: Scalars['String'];
  id: Scalars['ID'];
  party?: Maybe<OrderParty>;
  partyId: Scalars['String'];
};

export type BeneficiaryBankInput = {
  address?: InputMaybe<AddressInput>;
  bankIdNumber?: InputMaybe<Scalars['String']>;
  bankIdType?: InputMaybe<Scalars['String']>;
  bbiLine1?: InputMaybe<Scalars['String']>;
  bbiLine2?: InputMaybe<Scalars['String']>;
  bbiLine3?: InputMaybe<Scalars['String']>;
  bbiLine4?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type BeneficiaryBankSchema = {
  __typename?: 'BeneficiaryBankSchema';
  address?: Maybe<Address>;
  bankIdNumber?: Maybe<Scalars['String']>;
  bankIdType?: Maybe<Scalars['String']>;
  bbiLine1?: Maybe<Scalars['String']>;
  bbiLine2?: Maybe<Scalars['String']>;
  bbiLine3?: Maybe<Scalars['String']>;
  bbiLine4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BookBalanceTransaction = {
  __typename?: 'BookBalanceTransaction';
  amount?: Maybe<Scalars['Float']>;
  orderNumber?: Maybe<Scalars['String']>;
  payorPayeeId?: Maybe<Scalars['String']>;
  payorPayeeName?: Maybe<Scalars['String']>;
  reconcileDate?: Maybe<Scalars['String']>;
  transactionCategory?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  typeOfFunds?: Maybe<Scalars['String']>;
};

export type Buyer = OrderBuyerSeller & {
  __typename?: 'Buyer';
  address?: Maybe<Address>;
  alias?: Maybe<Scalars['String']>;
  allFullNames?: Maybe<Scalars['String']>;
  buyerSellerId?: Maybe<Scalars['ID']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayNameMetadata?: Maybe<OverrideMetadataString>;
  emailAddresses?: Maybe<Array<Maybe<BuyerSellerEmailAddress>>>;
  entityDateOfAgreement?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  entityStateOfAgreement?: Maybe<Scalars['String']>;
  excludeFromLoan?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  forwardingAddress?: Maybe<Address>;
  forwardingAddressSameAsCurrentAddress?: Maybe<Scalars['Boolean']>;
  forwardingAddressSameAsPropertyAddress?: Maybe<Scalars['Boolean']>;
  forwardingRegion?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasPowerOfAttorney?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isForeignAddress?: Maybe<Scalars['Boolean']>;
  isForeignForwardingAddress?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  ownershipPercentage?: Maybe<Scalars['Float']>;
  ownershipPercentageMetadata?: Maybe<OverrideMetadataNumber>;
  phoneNumbers?: Maybe<Array<Maybe<BuyerSellerPhoneNumber>>>;
  powerOfAttorney?: Maybe<PowerOfAttorney>;
  recordName?: Maybe<BuyerSellerRecordName>;
  representatives?: Maybe<Array<OrderBuyerSellerSoRep>>;
  representativesAllNames?: Maybe<Scalars['String']>;
  representativesAllNamesWithCapacity?: Maybe<Scalars['String']>;
  sdnStatus?: Maybe<Scalars['String']>;
  sdnStatusDetails?: Maybe<SdnStatusDetails>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  signingName?: Maybe<Scalars['String']>;
  signingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  spouse?: Maybe<OrderBuyerSellerSoRep>;
  suffix?: Maybe<Scalars['String']>;
  taxIdFormatted?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  typeOfBuyerSeller?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type BuyerSellerCollectionPatchInput = {
  buyerSellerId: Scalars['String'];
  ownershipPercentage?: InputMaybe<Scalars['Float']>;
  sequenceNumber?: InputMaybe<Scalars['Float']>;
  updatedTimestamp: Scalars['String'];
};

export type BuyerSellerEmailAddress = {
  __typename?: 'BuyerSellerEmailAddress';
  emailAddress?: Maybe<Scalars['EmailAddress']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export type BuyerSellerEmailAddressInput = {
  emailAddress?: InputMaybe<Scalars['EmailAddress']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
};

export type BuyerSellerName = {
  __typename?: 'BuyerSellerName';
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleInitial?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
};

export type BuyerSellerPhoneNumber = {
  __typename?: 'BuyerSellerPhoneNumber';
  ext?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  phoneNumberFull?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BuyerSellerPhoneNumberInput = {
  ext?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  type?: InputMaybe<Scalars['String']>;
};

export enum BuyerSellerRecordName {
  Buyer = 'Buyer',
  Seller = 'Seller'
}

export type BuyerSellerSplit = {
  __typename?: 'BuyerSellerSplit';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  states: StateSplitConfiguration;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type BuyerSellerSplitConfiguration = {
  __typename?: 'BuyerSellerSplitConfiguration';
  buyer: Scalars['Int'];
  seller: Scalars['Int'];
};

export type BuyerSellerSplitInput = {
  states: StateSplitInput;
  updatedTimestamp: Scalars['String'];
};

export type BuyerSellerSplitValueInput = {
  buyer: Scalars['Int'];
  seller: Scalars['Int'];
};

export type CdStatement = {
  __typename?: 'CDStatement';
  addendum?: Maybe<CdStatementAddendum>;
  cashToClose?: Maybe<CdStatementCashToClose>;
  closingCosts?: Maybe<CdStatementClosingCosts>;
  closingInformation?: Maybe<StatementClosingInformation>;
  confirmReceipt?: Maybe<CdStatementConfirmReceipt>;
  contactInformation?: Maybe<CdStatementContactInformation>;
  estimatedTaxesInsuranceAndAssessments?: Maybe<CdStatementEstimatedTaxesInsuranceAssessments>;
  loanAndOtherCosts?: Maybe<CdStatementLoanCostsAndOther>;
  loanCalculationsDisclosures?: Maybe<CdStatementLoanCalculationsDisclosures>;
  loanDisclosures?: Maybe<CdStatementLoanDisclosures>;
  loanInformation?: Maybe<StatementLoanInformation>;
  loanTerms?: Maybe<StatementLoanTerms>;
  projectedPayments?: Maybe<CdStatementProjectedPayments>;
  transactionInformation?: Maybe<StatementTransactionInformation>;
  transactionSummary?: Maybe<CdStatementTransactionSummary>;
};

export type CdStatementAddendum = {
  __typename?: 'CDStatementAddendum';
  confirmReceipt?: Maybe<CdStatementAddendumConfirmReceipt>;
  contactInformation?: Maybe<CdStatementAddendumContactInformation>;
  transactionInformation?: Maybe<CdStatementAddendumTransactionInformation>;
  transactionSummary?: Maybe<CdStatementAddendumTransactionSummary>;
};

export type CdStatementAddendumConfirmReceipt = {
  __typename?: 'CDStatementAddendumConfirmReceipt';
  receiptConfirmed?: Maybe<Scalars['Boolean']>;
  showAddendum?: Maybe<Scalars['Boolean']>;
  signatures?: Maybe<CdStatementAddendumConfirmReceiptSignatures>;
};

export type CdStatementAddendumConfirmReceiptSignature = {
  __typename?: 'CDStatementAddendumConfirmReceiptSignature';
  entityName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerofAttorneySigningName?: Maybe<Scalars['String']>;
};

export type CdStatementAddendumConfirmReceiptSignatures = {
  __typename?: 'CDStatementAddendumConfirmReceiptSignatures';
  buyers?: Maybe<Array<Maybe<CdStatementAddendumConfirmReceiptSignature>>>;
  sellers?: Maybe<Array<Maybe<CdStatementAddendumConfirmReceiptSignature>>>;
};

export type CdStatementAddendumContactInformation = {
  __typename?: 'CDStatementAddendumContactInformation';
  contacts?: Maybe<Array<Maybe<CdStatementAddendumContactInformationContact>>>;
  state?: Maybe<Scalars['String']>;
};

export type CdStatementAddendumContactInformationContact = {
  __typename?: 'CDStatementAddendumContactInformationContact';
  address?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  contactLicenseId?: Maybe<Scalars['String']>;
  contactNmlsId?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nmlsId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type CdStatementAddendumTransactionInformation = {
  __typename?: 'CDStatementAddendumTransactionInformation';
  borrowers?: Maybe<Array<Maybe<CdStatementAddendumTransactionInformationContact>>>;
  sellers?: Maybe<Array<Maybe<CdStatementAddendumTransactionInformationContact>>>;
};

export type CdStatementAddendumTransactionInformationContact = {
  __typename?: 'CDStatementAddendumTransactionInformationContact';
  address?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CdStatementAddendumTransactionSummary = {
  __typename?: 'CDStatementAddendumTransactionSummary';
  sectionK?: Maybe<CdStatementAddendumTransactionSummarySection>;
  sectionL?: Maybe<CdStatementAddendumTransactionSummarySection>;
  sectionM?: Maybe<CdStatementAddendumTransactionSummarySection>;
  sectionN?: Maybe<CdStatementAddendumTransactionSummarySection>;
};

export type CdStatementAddendumTransactionSummarySection = {
  __typename?: 'CDStatementAddendumTransactionSummarySection';
  items?: Maybe<Array<Maybe<CdStatementAddendumTransactionSummarySectionItem>>>;
};

export type CdStatementAddendumTransactionSummarySectionItem = {
  __typename?: 'CDStatementAddendumTransactionSummarySectionItem';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
};

export type CdStatementCashToClose = {
  __typename?: 'CDStatementCashToClose';
  closingCostsFinanced?: Maybe<Scalars['Float']>;
  estimatedCashFromBorrower?: Maybe<Scalars['Boolean']>;
  finalCashFromBorrower?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<CdStatementCashToCloseItem>>>;
  totalEstimatedCashToClose?: Maybe<Scalars['Float']>;
  totalFinalCashToClose?: Maybe<Scalars['Float']>;
};

export type CdStatementCashToCloseItem = {
  __typename?: 'CDStatementCashToCloseItem';
  description?: Maybe<Scalars['String']>;
  didChange?: Maybe<Scalars['Boolean']>;
  estimatedAmount?: Maybe<Scalars['Float']>;
  finalAmount?: Maybe<Scalars['Float']>;
  sentences?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CdStatementClosingCosts = {
  __typename?: 'CDStatementClosingCosts';
  cashFromBorrower?: Maybe<Scalars['Boolean']>;
  cashToClose?: Maybe<Scalars['Float']>;
  closingCosts?: Maybe<Scalars['Float']>;
  lenderCredits?: Maybe<Scalars['Float']>;
  loanCosts?: Maybe<Scalars['Float']>;
  otherCosts?: Maybe<Scalars['Float']>;
};

export type CdStatementConfirmReceipt = {
  __typename?: 'CDStatementConfirmReceipt';
  applicant?: Maybe<CdStatementConfirmReceiptApplicant>;
  coapplicant?: Maybe<CdStatementConfirmReceiptApplicant>;
  receiptConfirmed?: Maybe<Scalars['Boolean']>;
};

export type CdStatementConfirmReceiptApplicant = {
  __typename?: 'CDStatementConfirmReceiptApplicant';
  entityName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerofAttorneySigningName?: Maybe<Scalars['String']>;
};

export type CdStatementContactInformation = {
  __typename?: 'CDStatementContactInformation';
  contacts?: Maybe<Array<Maybe<CdStatementContactInformationContact>>>;
  state?: Maybe<Scalars['String']>;
};

export type CdStatementContactInformationContact = {
  __typename?: 'CDStatementContactInformationContact';
  address?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  contactLicenseId?: Maybe<Scalars['String']>;
  contactNmlsId?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nmlsId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type CdStatementEstimatedTaxesInsuranceAssessments = {
  __typename?: 'CDStatementEstimatedTaxesInsuranceAssessments';
  amount?: Maybe<Scalars['Float']>;
  includes?: Maybe<Array<Maybe<CdStatementEstimatedTaxesInsuranceAssessmentsItem>>>;
};

export type CdStatementEstimatedTaxesInsuranceAssessmentsItem = {
  __typename?: 'CDStatementEstimatedTaxesInsuranceAssessmentsItem';
  description?: Maybe<Scalars['String']>;
  inEscrow?: Maybe<Scalars['String']>;
  includedInEstimate?: Maybe<Scalars['Boolean']>;
};

export type CdStatementLoanCalculationsDisclosures = {
  __typename?: 'CDStatementLoanCalculationsDisclosures';
  amountFinanced?: Maybe<Scalars['Float']>;
  annualPercentageRate?: Maybe<Scalars['Float']>;
  financeCharge?: Maybe<Scalars['Float']>;
  liabilityAfterForeclosure?: Maybe<Scalars['String']>;
  totalInterestPercentage?: Maybe<Scalars['Float']>;
  totalOfPayments?: Maybe<Scalars['Float']>;
};

export type CdStatementLoanCostsAndOther = {
  __typename?: 'CDStatementLoanCostsAndOther';
  isTwoPages?: Maybe<Scalars['Boolean']>;
  sectionA?: Maybe<StatementLineItemSection>;
  sectionB?: Maybe<StatementLineItemSection>;
  sectionC?: Maybe<StatementLineItemSection>;
  sectionD?: Maybe<StatementLineItemSection>;
  sectionE?: Maybe<StatementLineItemSection>;
  sectionF?: Maybe<StatementLineItemSection>;
  sectionG?: Maybe<StatementLineItemSection>;
  sectionH?: Maybe<StatementLineItemSection>;
  sectionI?: Maybe<StatementLineItemSection>;
  sectionJ?: Maybe<StatementLineItemSection>;
};

export type CdStatementLoanDisclosures = {
  __typename?: 'CDStatementLoanDisclosures';
  adjustableInterestRateTable?: Maybe<CdStatementLoanDisclosuresAdjustableInterestRateTable>;
  adjustablePaymentsTable?: Maybe<CdStatementLoanDisclosuresAdjustmentPaymentsTable>;
  escrowAccount?: Maybe<Scalars['String']>;
  escrowWaiverFee?: Maybe<Scalars['Float']>;
  escrowWaiverFeeDescription?: Maybe<Scalars['String']>;
  escrowedCostsFirstYear?: Maybe<Scalars['Float']>;
  escrowedCostsListing?: Maybe<Scalars['String']>;
  estimatedCostsOverFirstYear?: Maybe<Scalars['Float']>;
  initialEscrowPayment?: Maybe<Scalars['Float']>;
  latePaymentDays?: Maybe<Scalars['Float']>;
  latePaymentFeeDescription?: Maybe<Scalars['String']>;
  loanAssumptionPermitted?: Maybe<Scalars['String']>;
  loanHasDemandFeature?: Maybe<Scalars['String']>;
  monthlyEscrowAmount?: Maybe<Scalars['Float']>;
  negativeAmortization?: Maybe<Scalars['String']>;
  nonEscrowedCostFirstYear?: Maybe<Scalars['Float']>;
  nonEscrowedCostsListing?: Maybe<Scalars['String']>;
  partialPayments?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  showAirTable?: Maybe<Scalars['Boolean']>;
  showApTable?: Maybe<Scalars['Boolean']>;
};

export type CdStatementLoanDisclosuresAdjustableInterestRateTable = {
  __typename?: 'CDStatementLoanDisclosuresAdjustableInterestRateTable';
  firstChange?: Maybe<Scalars['Float']>;
  firstChangeFrequency?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['String']>;
  initialInterestRate?: Maybe<Scalars['Float']>;
  margin?: Maybe<Scalars['Float']>;
  maximumInterestRate?: Maybe<Scalars['Float']>;
  minimumInterestRate?: Maybe<Scalars['Float']>;
  subsequentChange?: Maybe<Scalars['Float']>;
  subsequentChangeFrequency?: Maybe<Scalars['String']>;
};

export type CdStatementLoanDisclosuresAdjustmentPaymentsTable = {
  __typename?: 'CDStatementLoanDisclosuresAdjustmentPaymentsTable';
  firstChange?: Maybe<Scalars['String']>;
  firstChangeAt?: Maybe<Scalars['String']>;
  interestOnlyPayments?: Maybe<Scalars['Boolean']>;
  maximumPayment?: Maybe<Scalars['Float']>;
  maximumPaymentStartsAt?: Maybe<Scalars['String']>;
  numInterestOnlyPayments?: Maybe<Scalars['Float']>;
  numOptionalPayments?: Maybe<Scalars['Float']>;
  numStepPayments?: Maybe<Scalars['Float']>;
  optionalPayments?: Maybe<Scalars['Boolean']>;
  seasonalPayments?: Maybe<Scalars['Boolean']>;
  seasonalPaymentsFrom?: Maybe<Scalars['String']>;
  seasonalPaymentsTo?: Maybe<Scalars['String']>;
  stepPayments?: Maybe<Scalars['Boolean']>;
  subsequentChangesEvery?: Maybe<Scalars['String']>;
};

export type CdStatementProjectedPayments = {
  __typename?: 'CDStatementProjectedPayments';
  paymentPeriod?: Maybe<Scalars['String']>;
  projections?: Maybe<Array<Maybe<CdStatementProjectedPaymentsProjection>>>;
};

export type CdStatementProjectedPaymentsProjection = {
  __typename?: 'CDStatementProjectedPaymentsProjection';
  estimatedEscrow?: Maybe<Scalars['Float']>;
  interestOnly?: Maybe<Scalars['Boolean']>;
  maxEstimatedPayment?: Maybe<Scalars['Float']>;
  maxPrincipalAndInterest?: Maybe<Scalars['Float']>;
  minEstimatedPayment?: Maybe<Scalars['Float']>;
  minPrincipalAndInterest?: Maybe<Scalars['Float']>;
  mortgageInsurance?: Maybe<Scalars['Float']>;
  period?: Maybe<Scalars['String']>;
};

export type CdStatementTransactionSummary = {
  __typename?: 'CDStatementTransactionSummary';
  borrowerCalcTotal?: Maybe<Scalars['Float']>;
  cashFromBorrower?: Maybe<Scalars['Boolean']>;
  cashFromSeller?: Maybe<Scalars['Boolean']>;
  sectionK?: Maybe<StatementLineItemAdjustmentSection>;
  sectionL?: Maybe<StatementLineItemAdjustmentSection>;
  sectionM?: Maybe<StatementLineItemAdjustmentSection>;
  sectionN?: Maybe<StatementLineItemAdjustmentSection>;
  sellerCalcTotal?: Maybe<Scalars['Float']>;
  totalDueFromBorrower?: Maybe<Scalars['Float']>;
  totalDueFromSeller?: Maybe<Scalars['Float']>;
  totalDueToSeller?: Maybe<Scalars['Float']>;
  totalPaidByBorrower?: Maybe<Scalars['Float']>;
};

export type CalculateCplRateItem = {
  active: Scalars['Boolean'];
  coveredParty: Scalars['String'];
  id: Scalars['String'];
  letterType: Scalars['String'];
};

export type CalculateCplRatePricing = {
  __typename?: 'CalculateCplRatePricing';
  active: Scalars['Boolean'];
  coveredParty: Scalars['String'];
  id: Scalars['String'];
  letterType: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
};

export type CalculateCplRateRequest = {
  cpls: Array<CalculateCplRateItem>;
};

export type CalculateCplRateResponse = {
  __typename?: 'CalculateCplRateResponse';
  cpls: Array<CalculateCplRatePricing>;
};

export type CalculatePremiumRateRequest = {
  lenderPolicy?: InputMaybe<PolicyRateRequest>;
  lenderPremium?: InputMaybe<UpdateTitlePremiumInput>;
  ownerPolicy?: InputMaybe<PolicyRateRequest>;
  ownerPremium?: InputMaybe<UpdateTitlePremiumInput>;
  priorPolicyAmount?: InputMaybe<Scalars['Float']>;
  priorPolicyCoverageType?: InputMaybe<Scalars['String']>;
  simultaneousIssue?: InputMaybe<Scalars['Boolean']>;
};

export type CalculatingCashToClose = {
  __typename?: 'CalculatingCashToClose';
  id: Scalars['ID'];
  lineItems: Array<CalculatingCashToCloseLineItem>;
  totalEstimatedCashToClose?: Maybe<Scalars['Float']>;
  totalFinalCashToClose?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type CalculatingCashToCloseInput = {
  lineItems: Array<CalculatingCashToCloseLineItemInput>;
  orderId: Scalars['ID'];
  updatedTimestamp: Scalars['DateTime'];
};

export type CalculatingCashToCloseLineItem = {
  __typename?: 'CalculatingCashToCloseLineItem';
  details?: Maybe<Scalars['String']>;
  didChange?: Maybe<Scalars['Boolean']>;
  estimatedAmount?: Maybe<Scalars['Float']>;
  finalAmount?: Maybe<Scalars['Float']>;
  finalAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type CalculatingCashToCloseLineItemInput = {
  details?: InputMaybe<Scalars['String']>;
  estimatedAmount?: InputMaybe<Scalars['Float']>;
  finalAmount?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
};

export type CanInterestRateIncreaseAfterClosingQuestion = {
  __typename?: 'CanInterestRateIncreaseAfterClosingQuestion';
  adjustsEveryAfterDate?: Maybe<Scalars['String']>;
  adjustsEveryIncrement?: Maybe<Scalars['Float']>;
  changePercentage?: Maybe<Scalars['Float']>;
  firstChangeDate?: Maybe<Scalars['String']>;
  firstChangeIncrement?: Maybe<Scalars['Float']>;
  maximumInterestPercentage?: Maybe<Scalars['Float']>;
  maximumPercentageIncrement?: Maybe<Scalars['Float']>;
  minimumInterestPercentage?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
  seeAIRTable?: Maybe<Scalars['Boolean']>;
};

export type CanInterestRateIncreaseAfterClosingQuestionInput = {
  adjustsEveryAfterDate?: InputMaybe<Scalars['String']>;
  adjustsEveryIncrement?: InputMaybe<Scalars['Float']>;
  changePercentage?: InputMaybe<Scalars['Float']>;
  firstChangeDate?: InputMaybe<Scalars['String']>;
  firstChangeIncrement?: InputMaybe<Scalars['Float']>;
  maximumInterestPercentage?: InputMaybe<Scalars['Float']>;
  maximumPercentageIncrement?: InputMaybe<Scalars['Float']>;
  minimumInterestPercentage?: InputMaybe<Scalars['Float']>;
  response?: InputMaybe<Scalars['Boolean']>;
  seeAIRTable?: InputMaybe<Scalars['Boolean']>;
};

export type CanMonthlyPrincipalAndInterestIncreaseQuestion = {
  __typename?: 'CanMonthlyPrincipalAndInterestIncreaseQuestion';
  adjustsEveryIncrement?: Maybe<Scalars['Float']>;
  adjustsStartIncrement?: Maybe<Scalars['Float']>;
  asHighAsAmount?: Maybe<Scalars['Float']>;
  asHighAsIncrement?: Maybe<Scalars['Float']>;
  firstChangeAsHighAsAmount?: Maybe<Scalars['Float']>;
  firstChangeDate?: Maybe<Scalars['String']>;
  interestOnlyIncrement?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
  seeAPTable?: Maybe<Scalars['Boolean']>;
};

export type CanMonthlyPrincipalAndInterestIncreaseQuestionInput = {
  adjustsEveryIncrement?: InputMaybe<Scalars['Float']>;
  adjustsStartIncrement?: InputMaybe<Scalars['Float']>;
  asHighAsAmount?: InputMaybe<Scalars['Float']>;
  asHighAsIncrement?: InputMaybe<Scalars['Float']>;
  firstChangeAsHighAsAmount?: InputMaybe<Scalars['Float']>;
  firstChangeDate?: InputMaybe<Scalars['String']>;
  interestOnlyIncrement?: InputMaybe<Scalars['Float']>;
  response?: InputMaybe<Scalars['Boolean']>;
  seeAPTable?: InputMaybe<Scalars['Boolean']>;
};

export type CheckPrinting = {
  __typename?: 'CheckPrinting';
  includeCompanyLogo?: Maybe<Scalars['Boolean']>;
  leftMarginAdjustment?: Maybe<Scalars['Float']>;
  micrLineStartPosition?: Maybe<Scalars['Int']>;
  numberLastUsed?: Maybe<Scalars['Int']>;
  numberStart?: Maybe<Scalars['Int']>;
  signatureLineCount?: Maybe<Scalars['Int']>;
  templateId?: Maybe<Scalars['String']>;
  topMarginAdjustment?: Maybe<Scalars['Float']>;
  voidAfterDays?: Maybe<Scalars['Int']>;
};

export type CheckPrintingData = {
  __typename?: 'CheckPrintingData';
  escrowAccount: EscrowAccount;
  fund: Fund;
  id: Scalars['ID'];
  micrLine: Array<Scalars['String']>;
  transaction: Transaction;
  transactionLineDetails: Array<LineDetail>;
};

export type CheckPrintingInput = {
  includeCompanyLogo?: InputMaybe<Scalars['Boolean']>;
  leftMarginAdjustment?: InputMaybe<Scalars['Float']>;
  micrLineStartPosition?: InputMaybe<Scalars['Int']>;
  numberLastUsed?: InputMaybe<Scalars['Int']>;
  numberStart?: InputMaybe<Scalars['Int']>;
  signatureLineCount?: InputMaybe<Scalars['Int']>;
  templateId?: InputMaybe<Scalars['String']>;
  topMarginAdjustment?: InputMaybe<Scalars['Float']>;
  voidAfterDays?: InputMaybe<Scalars['Int']>;
};

export type CheckPrintingTestInput = {
  escrowAccountId?: InputMaybe<Scalars['String']>;
  includeCompanyLogo?: InputMaybe<Scalars['Boolean']>;
  leftMarginAdjustment?: InputMaybe<Scalars['Float']>;
  micrLineStartPosition?: InputMaybe<Scalars['Int']>;
  numberLastUsed?: InputMaybe<Scalars['Int']>;
  numberStart?: InputMaybe<Scalars['Int']>;
  signatureLineCount?: InputMaybe<Scalars['Int']>;
  templateId?: InputMaybe<Scalars['String']>;
  topMarginAdjustment?: InputMaybe<Scalars['Float']>;
  voidAfterDays?: InputMaybe<Scalars['Int']>;
};

export type ClausePackage = Node & {
  __typename?: 'ClausePackage';
  active?: Maybe<Scalars['Boolean']>;
  adminNotes?: Maybe<Scalars['String']>;
  clauses?: Maybe<Array<Maybe<ClauseSummary>>>;
  companyIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
  underwriterIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type ClausePackageConnection = Connection & {
  __typename?: 'ClausePackageConnection';
  edges: Array<ClausePackageEdge>;
  pageInfo: PageInfo;
};

export type ClausePackageDomain = {
  __typename?: 'ClausePackageDomain';
  connection?: Maybe<ClausePackageConnection>;
  list?: Maybe<Array<ClausePackage>>;
};


export type ClausePackageDomainConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ClausePackageFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type ClausePackageDomainListArgs = {
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};

export type ClausePackageEdge = Edge & {
  __typename?: 'ClausePackageEdge';
  node: ClausePackage;
};

export enum ClausePackageField {
  Active = 'active',
  CompanyIds = 'companyIds',
  Name = 'name',
  States = 'states',
  Title = 'title',
  UnderwriterIds = 'underwriterIds',
  UpdatedBy = 'updatedBy',
  UpdatedByDisplayName = 'updatedByDisplayName',
  UpdatedTimestamp = 'updatedTimestamp'
}

export type ClausePackageFilter = {
  field: ClausePackageField;
  operator: ApiFilterOperator;
  value: Scalars['String'];
};

export type ClausePackageInput = {
  active: Scalars['Boolean'];
  adminNotes?: InputMaybe<Scalars['String']>;
  clauseIds: Array<InputMaybe<Scalars['String']>>;
  companyIds: Array<InputMaybe<Scalars['String']>>;
  name: Scalars['String'];
  states: Array<InputMaybe<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  underwriterIds: Array<InputMaybe<Scalars['String']>>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type ClauseSummary = {
  __typename?: 'ClauseSummary';
  bodyTemplate?: Maybe<Scalars['String']>;
  clauseId: Scalars['ID'];
  mergeFields?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ClauseTemplate = Node & {
  __typename?: 'ClauseTemplate';
  active?: Maybe<Scalars['Boolean']>;
  adminNotes?: Maybe<Scalars['String']>;
  appliedTo?: Maybe<Scalars['String']>;
  bodyTemplate: Scalars['String'];
  companyIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy: Scalars['String'];
  createdByDisplayName?: Maybe<Scalars['String']>;
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  isGlobal: Scalars['Boolean'];
  mergeFields?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  title: Scalars['String'];
  type: Scalars['String'];
  underwriters?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedBy: Scalars['String'];
  updatedByDisplayName?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type ClauseTemplateConnection = Connection & {
  __typename?: 'ClauseTemplateConnection';
  edges: Array<ClauseTemplateEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type ClauseTemplateDomain = {
  __typename?: 'ClauseTemplateDomain';
  connection?: Maybe<ClauseTemplateConnection>;
  fluentConnection?: Maybe<ClauseTemplateConnection>;
  list?: Maybe<WrappedClauseTemplateResponse>;
};


export type ClauseTemplateDomainConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ClauseTemplateFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type ClauseTemplateDomainFluentConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ClauseTemplateFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type ClauseTemplateDomainListArgs = {
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};

export type ClauseTemplateEdge = Edge & {
  __typename?: 'ClauseTemplateEdge';
  node: ClauseTemplate;
};

export enum ClauseTemplateField {
  Active = 'active',
  AdminNotes = 'adminNotes',
  AppliedTo = 'appliedTo',
  BodyTemplate = 'bodyTemplate',
  CompanyIds = 'companyIds',
  CreatedBy = 'createdBy',
  CreatedTimestamp = 'createdTimestamp',
  Id = 'id',
  IsGlobal = 'isGlobal',
  MergeFields = 'mergeFields',
  OrganizationId = 'organizationId',
  States = 'states',
  Title = 'title',
  Type = 'type',
  Underwriters = 'underwriters',
  UpdatedBy = 'updatedBy',
  UpdatedByDisplayName = 'updatedByDisplayName',
  UpdatedTimestamp = 'updatedTimestamp'
}

export type ClauseTemplateFilter = {
  field: ClauseTemplateField;
  operator: ApiFilterOperator;
  sizeOperator?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type ClauseTemplateInput = {
  active: Scalars['Boolean'];
  adminNotes: Scalars['String'];
  appliedTo: Scalars['String'];
  bodyTemplate: Scalars['String'];
  companyIds: Array<InputMaybe<Scalars['String']>>;
  states: Array<InputMaybe<Scalars['String']>>;
  title: Scalars['String'];
  type: Scalars['String'];
  underwriters: Array<InputMaybe<Scalars['String']>>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type ClearAdjustmentInput = {
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  id: Scalars['String'];
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type ClearDcAdjustmentInput = {
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  id: Scalars['String'];
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type ClearFeeInput = {
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  id: Scalars['String'];
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type ClearTransaction = {
  id: Scalars['String'];
  isCleared: Scalars['Boolean'];
  updatedTimestamp: Scalars['String'];
};

export type ClearTransactionsInput = {
  transactions: Array<ClearTransaction>;
};

export type ClearTransactionsResponse = {
  __typename?: 'ClearTransactionsResponse';
  clearedTransactions?: Maybe<Array<Maybe<Transaction>>>;
  ineligibleTransactions?: Maybe<Array<Maybe<IneligibleTransactions>>>;
};

export type ClosingCosts = {
  __typename?: 'ClosingCosts';
  closingCosts?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lenderCredits?: Maybe<Scalars['Float']>;
  loanCosts?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['ID']>;
  otherCosts?: Maybe<Scalars['Float']>;
};

export type ClosingInformation = {
  __typename?: 'ClosingInformation';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  estimatedEscrowAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  interestRate?: Maybe<Scalars['Float']>;
  issueDate?: Maybe<Scalars['String']>;
  loanPurpose?: Maybe<Scalars['String']>;
  loanTerm?: Maybe<Scalars['Float']>;
  loanTermType?: Maybe<Scalars['String']>;
  loanType?: Maybe<Scalars['String']>;
  monthlyMIP?: Maybe<Scalars['Float']>;
  mortgageInsuranceCaseNumber?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['ID']>;
  principalAndInterestAmount?: Maybe<Scalars['Float']>;
  product?: Maybe<Scalars['String']>;
  propertyValue?: Maybe<Scalars['Float']>;
  propertyValueType?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type ClosingInformationInput = {
  estimatedEscrowAmount?: InputMaybe<Scalars['Float']>;
  interestRate?: InputMaybe<Scalars['Float']>;
  issueDate?: InputMaybe<Scalars['String']>;
  loanPurpose?: InputMaybe<Scalars['String']>;
  loanTerm?: InputMaybe<Scalars['Float']>;
  loanTermType?: InputMaybe<Scalars['String']>;
  loanType?: InputMaybe<Scalars['String']>;
  monthlyMIP?: InputMaybe<Scalars['Float']>;
  mortgageInsuranceCaseNumber?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  principalAndInterestAmount?: InputMaybe<Scalars['Float']>;
  product?: InputMaybe<Scalars['String']>;
  propertyValue?: InputMaybe<Scalars['Float']>;
  propertyValueType?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type ClosingQuestions = {
  __typename?: 'ClosingQuestions';
  amountIncreaseAfterClosingQuestion?: Maybe<AmountIncreaseAfterClosingQuestion>;
  canInterestRateIncreaseAfterClosingQuestion?: Maybe<CanInterestRateIncreaseAfterClosingQuestion>;
  canMonthlyPrincipalAndInterestIncreaseQuestion?: Maybe<CanMonthlyPrincipalAndInterestIncreaseQuestion>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  loanBalloonPaymentQuestion?: Maybe<LoanBalloonPaymentQuestion>;
  loanPrepaymentPenaltyQuestion?: Maybe<LoanPrepaymentPenaltyQuestion>;
  orderId?: Maybe<Scalars['ID']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type ClosingQuestionsInput = {
  amountIncreaseAfterClosingQuestion?: InputMaybe<AmountIncreaseAfterClosingQuestionInput>;
  canInterestRateIncreaseAfterClosingQuestion?: InputMaybe<CanInterestRateIncreaseAfterClosingQuestionInput>;
  canMonthlyPrincipalAndInterestIncreaseQuestion?: InputMaybe<CanMonthlyPrincipalAndInterestIncreaseQuestionInput>;
  loanBalloonPaymentQuestion?: InputMaybe<LoanBalloonPaymentQuestionInput>;
  loanPrepaymentPenaltyQuestion?: InputMaybe<LoanPrepaymentPenaltyQuestionInput>;
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type CombineDocumentsAsyncResponse = {
  __typename?: 'CombineDocumentsAsyncResponse';
  subscriptionId?: Maybe<Scalars['String']>;
};

export type CombineDocumentsRequestV2Input = {
  /** @minItems 2 */
  documentIds: Array<Scalars['String']>;
  orderId: Scalars['ID'];
  targetDocumentName: Scalars['String'];
};

export type CommissionBasisOverride = {
  __typename?: 'CommissionBasisOverride';
  value?: Maybe<Scalars['Float']>;
};

export type CommissionFeeAdditionalData = {
  __typename?: 'CommissionFeeAdditionalData';
  agentType?: Maybe<Scalars['String']>;
  externalCommissionLineId?: Maybe<Scalars['String']>;
};

export type CommissionLineItem = {
  __typename?: 'CommissionLineItem';
  commissionAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  realEstateAgentPartyReferenceId?: Maybe<Scalars['String']>;
  realEstateAgentType?: Maybe<Scalars['String']>;
};

export type Company = {
  __typename?: 'Company';
  active?: Maybe<Scalars['Boolean']>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  altaId?: Maybe<Scalars['ID']>;
  alternateSearchName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdTimestamp?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Maybe<EmailAddressSchema>>>;
  id: Scalars['ID'];
  isManagedEntry?: Maybe<Scalars['Boolean']>;
  lenderLanguage?: Maybe<Scalars['String']>;
  lenderLanguageDefaultType?: Maybe<Scalars['String']>;
  lenderLanguageOptions?: Maybe<LenderLanguageOptions>;
  lenderLanguageOptionsOverrideMetadata?: Maybe<LenderLanguageOptionsOverrideMetadata>;
  licenses?: Maybe<Array<Maybe<License>>>;
  nmlsId?: Maybe<Scalars['ID']>;
  notaryCertification?: Maybe<Scalars['String']>;
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  parentItemId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  taxId?: Maybe<Scalars['ID']>;
  taxIdType?: Maybe<Scalars['String']>;
  tenantOrgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  wireInstructions?: Maybe<WireSchema>;
};

export type CompanyContact = {
  __typename?: 'CompanyContact';
  company?: Maybe<Company>;
  contact?: Maybe<Contact>;
};

export type CompanyPartialInput = {
  addresses?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  altaId?: InputMaybe<Scalars['ID']>;
  alternateSearchName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  directoryCompanyId?: InputMaybe<Scalars['ID']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  lenderLanguage?: InputMaybe<Scalars['String']>;
  lenderLanguageDefaultType?: InputMaybe<Scalars['String']>;
  lenderLanguageOptions?: InputMaybe<LenderLanguageOptionsInput>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  nmlsId?: InputMaybe<Scalars['ID']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  taxId?: InputMaybe<Scalars['ID']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  wireInstructions?: InputMaybe<WireInput>;
};

export type CompanyRecipientAccountNumber = {
  __typename?: 'CompanyRecipientAccountNumber';
  recipientAccountNumber?: Maybe<Scalars['String']>;
};

export type CompanySummary = {
  __typename?: 'CompanySummary';
  active?: Maybe<Scalars['Boolean']>;
  alternateSearchName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  isManagedEntry?: Maybe<Scalars['Boolean']>;
  mailingAddress?: Maybe<Address>;
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  parentItemId?: Maybe<Scalars['String']>;
  primaryAddress?: Maybe<Address>;
  primaryEmail?: Maybe<Scalars['String']>;
  primaryPhone?: Maybe<PhoneNumberType>;
  tenantOrgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type CompanySummaryConnection = {
  __typename?: 'CompanySummaryConnection';
  edges?: Maybe<Array<Maybe<CompanySummaryEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type CompanySummaryEdge = {
  __typename?: 'CompanySummaryEdge';
  node?: Maybe<CompanySummary>;
};

export type CompanyTaxId = {
  __typename?: 'CompanyTaxId';
  taxId?: Maybe<Scalars['String']>;
};

export type CompanyTypeDefinition = {
  __typename?: 'CompanyTypeDefinition';
  additionalPartyRoleName?: Maybe<Scalars['String']>;
  additionalProperties?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  isSystemType?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
};

export type CompanyTypes = {
  __typename?: 'CompanyTypes';
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  types: Array<CompanyTypeDefinition>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type Configuration = {
  __typename?: 'Configuration';
  contentful?: Maybe<ContentfulConfiguration>;
  google?: Maybe<GoogleConfiguration>;
  pusher?: Maybe<PusherConfiguration>;
  smartyStreet?: Maybe<SmartyStreetConfiguration>;
};

export type Connection = {
  edges: Array<Edge>;
  pageInfo?: Maybe<PageInfo>;
};

export type Contact = {
  __typename?: 'Contact';
  active?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Address>;
  altaId?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  emailAddresses?: Maybe<Array<Maybe<EmailAddressSchema>>>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isManagedEntry?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenses?: Maybe<Array<Maybe<License>>>;
  nmlsId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  suffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  useCompanyAddress?: Maybe<Scalars['Boolean']>;
};

export type ContactPartialInput = {
  address?: InputMaybe<AddressInput>;
  contactId?: InputMaybe<Scalars['ID']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  firstName?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  nmlsId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  title?: InputMaybe<Scalars['String']>;
  useCompanyAddress?: InputMaybe<Scalars['Boolean']>;
};

export type ContactSummary = {
  __typename?: 'ContactSummary';
  active?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isManagedEntry?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type ContactWithCompanySummary = {
  __typename?: 'ContactWithCompanySummary';
  active?: Maybe<Scalars['Boolean']>;
  directoryCompanyId: Scalars['String'];
  directoryCompanyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isManagedEntry?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type ContactWithCompanySummaryConnection = {
  __typename?: 'ContactWithCompanySummaryConnection';
  edges?: Maybe<Array<Maybe<ContactWithCompanySummaryEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ContactWithCompanySummaryEdge = {
  __typename?: 'ContactWithCompanySummaryEdge';
  node?: Maybe<ContactWithCompanySummary>;
};

export type ContentfulConfiguration = {
  __typename?: 'ContentfulConfiguration';
  contentDeliveryApiKey?: Maybe<Scalars['String']>;
  contentPreviewApiKey?: Maybe<Scalars['String']>;
  isPreview?: Maybe<Scalars['Boolean']>;
  spaceId?: Maybe<Scalars['String']>;
};

export type ConvertTemplatesToDocumentsInput = {
  companyId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
  templateIds: Array<Scalars['ID']>;
};

export type ConvertTemplatesToDocumentsResponse = {
  __typename?: 'ConvertTemplatesToDocumentsResponse';
  data?: Maybe<Array<Maybe<Document>>>;
  errors?: Maybe<Array<Maybe<ErrorObject>>>;
};

export type CplFeeAdditionalData = {
  __typename?: 'CplFeeAdditionalData';
  externalCplId?: Maybe<Scalars['String']>;
  sourceBorrowerPaidAt?: Maybe<Scalars['Float']>;
  sourceSellerPaidAt?: Maybe<Scalars['Float']>;
};

export type CplProduct = {
  __typename?: 'CplProduct';
  createdTimestamp: Scalars['String'];
  documentId: Scalars['String'];
  id: Scalars['String'];
  lender?: Maybe<CplProductLender>;
  statuses: Array<CplProductStatus>;
};

export type CplProductLender = {
  __typename?: 'CplProductLender';
  address: Address;
  loanNumber: Scalars['String'];
  name: Scalars['String'];
};

export type CplProductStatus = {
  __typename?: 'CplProductStatus';
  code: Scalars['String'];
  description: Scalars['String'];
};

export type CreateAdjustmentInput = {
  addendumLineNumber?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['Float']>;
  description: Scalars['String'];
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  isDebitCredit?: InputMaybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  orderId: Scalars['String'];
  payeePayorId?: InputMaybe<Scalars['String']>;
};

export type CreateAdminMilestoneResponse = {
  __typename?: 'CreateAdminMilestoneResponse';
  existingMilestoneName?: Maybe<Scalars['String']>;
  milestone?: Maybe<AdminMilestone>;
};

export type CreateAdminWorkflowResponse = {
  __typename?: 'CreateAdminWorkflowResponse';
  existingWorkflowName?: Maybe<Scalars['String']>;
  workflow?: Maybe<AdminWorkflow>;
};

export type CreateBuyerInput = {
  address?: InputMaybe<AddressInput>;
  alias?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<BuyerSellerEmailAddressInput>>>;
  entityDateOfAgreement?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  entityStateOfAgreement?: InputMaybe<Scalars['String']>;
  excludeFromLoan?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  forwardingAddress?: InputMaybe<AddressInput>;
  forwardingAddressSameAsCurrentAddress?: InputMaybe<Scalars['Boolean']>;
  forwardingAddressSameAsPropertyAddress?: InputMaybe<Scalars['Boolean']>;
  forwardingRegion?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  hasPowerOfAttorney?: InputMaybe<Scalars['Boolean']>;
  isForeignAddress?: InputMaybe<Scalars['Boolean']>;
  isForeignForwardingAddress?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<BuyerSellerPhoneNumberInput>>>;
  powerOfAttorney?: InputMaybe<PowerOfAttorneyInput>;
  sdnStatus?: InputMaybe<Scalars['String']>;
  signingName?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  taxIdNumber?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  typeOfBuyerSeller?: InputMaybe<Scalars['String']>;
  vesting?: InputMaybe<Scalars['String']>;
};

export type CreateChangePasswordUserEventInput = {
  id: Scalars['ID'];
};

export type CreateDcAdjustmentInput = {
  addendumLineNumber?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['Float']>;
  dcAddendumLineNumber?: InputMaybe<Scalars['Int']>;
  dcLineNumber?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  isDebitCredit?: InputMaybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  orderId: Scalars['String'];
  payeePayorId?: InputMaybe<Scalars['String']>;
};

export type CreateDirectoryCompanyInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addresses?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  altaId?: InputMaybe<Scalars['String']>;
  alternateSearchName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  lenderLanguage?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  nmlsId?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentItemId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  tenantOrgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  website?: InputMaybe<Scalars['String']>;
  wireInstructions?: InputMaybe<WireInput>;
};

export type CreateDirectoryContactInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  firstName?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  nmlsId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  suffix?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  useCompanyAddress?: InputMaybe<Scalars['Boolean']>;
};

export type CreateDocumentInput = {
  customSortOrder?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<DocumentType>;
  fileType: Scalars['String'];
  listMergeChoices?: InputMaybe<Scalars['String']>;
  mergeFieldData?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderId: Scalars['ID'];
  path?: InputMaybe<Scalars['String']>;
  showMergeFields?: InputMaybe<Scalars['Boolean']>;
  sizeBytes?: InputMaybe<Scalars['Int']>;
  skipClone?: InputMaybe<Scalars['Boolean']>;
};

export type CreateEscrowAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  accountNumberAlternate?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Array<InputMaybe<EscrowAccountAddressInput>>>;
  bankName: Scalars['String'];
  checkPrinting?: InputMaybe<CheckPrintingInput>;
  description?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  escrowAccountName: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  positivePay?: InputMaybe<PositivePayInput>;
  routingNumber?: InputMaybe<Scalars['String']>;
  routingNumberDeposit?: InputMaybe<Scalars['String']>;
  routingNumberFractional?: InputMaybe<Scalars['String']>;
  routingNumberWire?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type CreateExceptionsInput = {
  exceptions?: InputMaybe<Array<InputMaybe<CreateTitleException>>>;
  orderId: Scalars['String'];
};

export type CreateFeeInput = {
  borrowerPaidAt?: InputMaybe<Scalars['Float']>;
  borrowerPaidBefore?: InputMaybe<Scalars['Float']>;
  description: Scalars['String'];
  feeLineType: Scalars['String'];
  feeTypeAdditionalData?: InputMaybe<FeeTypeAdditionalDataCreateInput>;
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  funding: Scalars['String'];
  gfeLineNumber?: InputMaybe<Scalars['String']>;
  isSetAsCDLastLine?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  payeeId?: InputMaybe<Scalars['String']>;
  pboBorrowerAmount?: InputMaybe<Scalars['Float']>;
  pboBorrowerPaidById?: InputMaybe<Scalars['String']>;
  pboSellerAmount?: InputMaybe<Scalars['Float']>;
  pboSellerPaidById?: InputMaybe<Scalars['String']>;
  sellerPaidAt?: InputMaybe<Scalars['Float']>;
  sellerPaidBefore?: InputMaybe<Scalars['Float']>;
  statementPayeeDisplayName?: InputMaybe<Scalars['String']>;
};

export type CreateFromKnownTemplateV2Input = {
  createDocument?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  listMergeChoices?: InputMaybe<Scalars['String']>;
  mergeFieldData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  rawMergeData?: InputMaybe<Scalars['String']>;
  skipClone?: InputMaybe<Scalars['Boolean']>;
  templateType: Scalars['String'];
};

export type CreateFundInput = {
  escrowAccountId: Scalars['String'];
  orderId: Scalars['String'];
};

export type CreateLineDetailInput = {
  amount: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  escrowAccountId: Scalars['String'];
  isLocked?: InputMaybe<Scalars['Boolean']>;
  lineNumber?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  refMetadata?: InputMaybe<RefMetaDataInput>;
  transactionId: Scalars['String'];
};

export type CreateMergeFieldInput = {
  category: Scalars['String'];
  dataType: Scalars['String'];
  defaultFormat: Scalars['String'];
  domain: Scalars['String'];
  label: Scalars['String'];
  mergeKey: Scalars['String'];
};

export type CreateOrderDocumentV2Input = {
  description?: InputMaybe<Scalars['String']>;
  fileType: Scalars['String'];
  name: Scalars['String'];
  orderId: Scalars['ID'];
  skipClone?: InputMaybe<Scalars['Boolean']>;
};

export type CreateOrderFromMasterPayload = {
  __typename?: 'CreateOrderFromMasterPayload';
  newOrderId?: Maybe<Scalars['String']>;
  newOrderNumber?: Maybe<Scalars['String']>;
  sourceCloneId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type CreateOrderInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  branch: Scalars['String'];
  businessSource?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countyFips?: InputMaybe<Scalars['String']>;
  countyName?: InputMaybe<Scalars['String']>;
  parcelId?: InputMaybe<Scalars['String']>;
  poluId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  propertyState?: InputMaybe<Scalars['String']>;
  sequenceId: Scalars['String'];
  sourceOrderId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  statementType: Scalars['String'];
  transactionTypeId: Scalars['String'];
  underwriterId?: InputMaybe<Scalars['String']>;
};

export type CreateOrderMilestoneInput = {
  name: Scalars['String'];
};

/** This is an input structure for creating an OrderParty with either Directory IDs or complete PartyCompany/PartyContact data */
export type CreateOrderPartyInput = {
  /** When directoryCompanyId is specified, then the company field is ignored */
  company?: InputMaybe<PartyCompanyInput>;
  /** When directoryContactId is specified, then the contact field is ignored */
  contact?: InputMaybe<PartyContactInput>;
  /** Specify the ID of a DirectoryCompany to be copied into the PartyCompany. */
  directoryCompanyReferenceId?: InputMaybe<Scalars['String']>;
  /** Specify the ID of a DirectoryContact to be copied into the PartyContact. */
  directoryContactReferenceId?: InputMaybe<Scalars['String']>;
  isSettlementUseOnly?: InputMaybe<Scalars['Boolean']>;
  refSectionId?: InputMaybe<Scalars['String']>;
  refSectionLabel?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
};

export type CreateOrderPayload = {
  __typename?: 'CreateOrderPayload';
  order?: Maybe<OrderHeader>;
};

export type CreateProrationCharge = {
  frequency?: InputMaybe<Scalars['String']>;
  lineItem?: InputMaybe<ProrationChargeLineItemInput>;
  payeePartyId?: InputMaybe<Scalars['String']>;
  prorationChargeSubtype?: InputMaybe<Scalars['String']>;
  prorationChargeType?: InputMaybe<Scalars['String']>;
  prorationDetails?: InputMaybe<ProrationDetailsInput>;
};

export type CreateReconciliationInput = {
  beginningBalance: Scalars['Float'];
  clearedBalance: Scalars['Float'];
  endingDate: Scalars['String'];
  escrowAccountId: Scalars['String'];
  statementEndingBalance: Scalars['Float'];
  status: ReconciliationStatus;
  transactionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CreateRequirementsInput = {
  orderId: Scalars['ID'];
  requirements?: InputMaybe<Array<InputMaybe<CreateTitleRequirement>>>;
};

export type CreateSecurityGroupInput = {
  description: Scalars['String'];
  name: Scalars['String'];
  permissions?: InputMaybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type CreateSellerInput = {
  address?: InputMaybe<AddressInput>;
  alias?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<BuyerSellerEmailAddressInput>>>;
  entityDateOfAgreement?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  entityStateOfAgreement?: InputMaybe<Scalars['String']>;
  excludeFromLoan?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  forwardingAddress?: InputMaybe<AddressInput>;
  forwardingAddressSameAsCurrentAddress?: InputMaybe<Scalars['Boolean']>;
  forwardingAddressSameAsPropertyAddress?: InputMaybe<Scalars['Boolean']>;
  forwardingRegion?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  hasPowerOfAttorney?: InputMaybe<Scalars['Boolean']>;
  isForeignAddress?: InputMaybe<Scalars['Boolean']>;
  isForeignForwardingAddress?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<BuyerSellerPhoneNumberInput>>>;
  powerOfAttorney?: InputMaybe<PowerOfAttorneyInput>;
  sdnStatus?: InputMaybe<Scalars['String']>;
  signingName?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  taxIdNumber?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  typeOfBuyerSeller?: InputMaybe<Scalars['String']>;
  vesting?: InputMaybe<Scalars['String']>;
};

export type CreateStateWithholdingInput = {
  description?: InputMaybe<Scalars['String']>;
  oTotalWithholdingBasis?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['ID'];
  payorPayeeId: Scalars['String'];
  sellers: Array<InputMaybe<StateWithholdingSellerValuesInput>>;
};

export type CreateTemplateDocV2Input = {
  attributes?: InputMaybe<TemplateAttributesV2Input>;
  description?: InputMaybe<Scalars['String']>;
  documentType: TemplateDocTypeV2;
  fileType: Scalars['String'];
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type CreateTemplateInput = {
  attributes?: InputMaybe<TemplateAttributesInput>;
  description?: InputMaybe<Scalars['String']>;
  documentType: DocumentType;
  fileType?: InputMaybe<Scalars['String']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  path?: InputMaybe<Scalars['String']>;
  showMergeFields?: InputMaybe<Scalars['Boolean']>;
  sizeBytes?: InputMaybe<Scalars['Int']>;
};

export type CreateTenantChildInput = {
  abbreviation: Scalars['String'];
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactFirstName?: InputMaybe<Scalars['String']>;
  contactLastName?: InputMaybe<Scalars['String']>;
  contactMiddleName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  contactPhoneExtension?: InputMaybe<Scalars['String']>;
  contactPhoneType?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  name: Scalars['String'];
  nmlsId?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentItemId: Scalars['ID'];
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  wireInstructions?: InputMaybe<WireInput>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateTenantInput = {
  abbreviation: Scalars['String'];
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  billingContactEmail: Scalars['String'];
  billingContactFirstName: Scalars['String'];
  billingContactLastName: Scalars['String'];
  billingContactMiddleName?: InputMaybe<Scalars['String']>;
  billingContactPhone?: InputMaybe<Scalars['String']>;
  billingContactPhoneExtension?: InputMaybe<Scalars['String']>;
  billingContactPhoneType?: InputMaybe<Scalars['String']>;
  businessContactEmail?: InputMaybe<Scalars['String']>;
  businessContactFirstName?: InputMaybe<Scalars['String']>;
  businessContactLastName?: InputMaybe<Scalars['String']>;
  businessContactMiddleName?: InputMaybe<Scalars['String']>;
  businessContactPhone?: InputMaybe<Scalars['String']>;
  businessContactPhoneExtension?: InputMaybe<Scalars['String']>;
  businessContactPhoneType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  labelL1?: InputMaybe<Scalars['String']>;
  labelL2?: InputMaybe<Scalars['String']>;
  labelL3?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  technicalContactEmail?: InputMaybe<Scalars['String']>;
  technicalContactFirstName?: InputMaybe<Scalars['String']>;
  technicalContactLastName?: InputMaybe<Scalars['String']>;
  technicalContactMiddleName?: InputMaybe<Scalars['String']>;
  technicalContactPhone?: InputMaybe<Scalars['String']>;
  technicalContactPhoneExtension?: InputMaybe<Scalars['String']>;
  technicalContactPhoneType?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateTenantUnderwriterResponse = TenantUnderwriterResponse & {
  __typename?: 'CreateTenantUnderwriterResponse';
  tenantUnderwriter: TenantUnderwriter;
  tenantUnderwriters: Array<TenantUnderwriter>;
};


export type CreateTenantUnderwriterResponseTenantUnderwritersArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};

export type CreateTitleCplInput = {
  address?: InputMaybe<AddressInput>;
  agentRetained?: InputMaybe<Scalars['Float']>;
  amount?: InputMaybe<Scalars['Float']>;
  approvedAttorney?: InputMaybe<Scalars['String']>;
  buyerPays?: InputMaybe<Scalars['Float']>;
  coveredParty?: InputMaybe<Scalars['String']>;
  cplNumber?: InputMaybe<Scalars['String']>;
  displayOnSettlement?: InputMaybe<Scalars['String']>;
  lenderAddress?: InputMaybe<AddressInput>;
  lenderId?: InputMaybe<Scalars['String']>;
  letterType?: InputMaybe<Scalars['String']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  proposedLoanInsured?: InputMaybe<Scalars['String']>;
  remittanceDate?: InputMaybe<Scalars['String']>;
  secondaryPartyId?: InputMaybe<Scalars['String']>;
  secondaryPartyRoleType?: InputMaybe<Scalars['String']>;
  sellerPays?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  underwriterRemitted?: InputMaybe<Scalars['Float']>;
  useLenderAddress?: InputMaybe<Scalars['Boolean']>;
};

export type CreateTitleException = {
  applyToPolicy?: InputMaybe<Scalars['String']>;
  bodyTemplate?: InputMaybe<Scalars['String']>;
  libraryId?: InputMaybe<Scalars['String']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  scope: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateTitleRequirement = {
  bodyTemplate?: InputMaybe<Scalars['String']>;
  libraryId?: InputMaybe<Scalars['String']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  scope: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateTransactionInput = {
  escrowAccountId: Scalars['String'];
  fundingTransactionType?: InputMaybe<Scalars['String']>;
  isClear?: InputMaybe<Scalars['Boolean']>;
  isCleared?: InputMaybe<Scalars['Boolean']>;
  lastActivityDate?: InputMaybe<Scalars['String']>;
  lineDetails?: InputMaybe<Array<InputMaybe<UpdateLineDetailInput>>>;
  memo?: InputMaybe<Scalars['String']>;
  oPayeeAddress?: InputMaybe<AddressInput>;
  oPayorPayeeId?: InputMaybe<Scalars['String']>;
  oTaxId?: InputMaybe<FundingTaxIdInput>;
  oWireTransfer?: InputMaybe<WireInput>;
  orderId: Scalars['String'];
  orderNumber?: InputMaybe<Scalars['String']>;
  payeeAddress?: InputMaybe<AddressInput>;
  payorPayeeId: Scalars['String'];
  payorPayeeString_sk: Scalars['String'];
  positivePayDate?: InputMaybe<Scalars['String']>;
  reconcileDate?: InputMaybe<Scalars['String']>;
  refNumber?: InputMaybe<Scalars['String']>;
  searchData?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusReason?: InputMaybe<Scalars['String']>;
  transactionCategory: Scalars['String'];
  transactionDate?: InputMaybe<Scalars['String']>;
  transferOrderPartyId?: InputMaybe<Scalars['String']>;
  transferredOrderId?: InputMaybe<Scalars['String']>;
  wireExpectedDate?: InputMaybe<Scalars['String']>;
};

export type CreateUserInput = {
  address?: InputMaybe<AddressInput>;
  department?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['EmailAddress']>;
  firstName?: InputMaybe<Scalars['String']>;
  homeL2Id?: InputMaybe<Scalars['ID']>;
  homeL3Id?: InputMaybe<Scalars['ID']>;
  initials?: InputMaybe<Scalars['String']>;
  isDisclosureSettlementAgent?: InputMaybe<Scalars['Boolean']>;
  isUnderwriterAuthorizedSignatory?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  nameSuffix?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<UserPhoneNumberInput>>>;
  security?: InputMaybe<UserSecurityInput>;
  securityV2?: InputMaybe<SecurityGroupV2AssignmentsInput>;
  securityVersion?: InputMaybe<Scalars['String']>;
};

export type CurrentTitleHolderMetadata = {
  __typename?: 'CurrentTitleHolderMetadata';
  bodyContent?: Maybe<Scalars['String']>;
  mergeFields?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
  templates?: Maybe<CurrentTitleHolderMetadataTemplates>;
  type?: Maybe<Scalars['String']>;
};

export type CurrentTitleHolderMetadataTemplates = {
  __typename?: 'CurrentTitleHolderMetadataTemplates';
  DEED_RECITAL?: Maybe<Scalars['String']>;
  NAMES?: Maybe<Scalars['String']>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  assignedTo?: Maybe<Scalars['String']>;
  buyers?: Maybe<Scalars['String']>;
  departmentName?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  milestoneId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  sellers?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  taskName?: Maybe<Scalars['String']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type DcFp7cTaxForm = {
  __typename?: 'DcFp7cTaxForm';
  grantee?: Maybe<DcFp7cTaxFormGrantorGrantee>;
  grantor?: Maybe<DcFp7cTaxFormGrantorGrantee>;
  lot?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyParcelNumbers?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  settlementAgentAddress?: Maybe<DcFp7cTaxFormAddress>;
  settlementAgentName?: Maybe<Scalars['String']>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type DcFp7cTaxFormAddress = {
  __typename?: 'DcFp7cTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type DcFp7cTaxFormGrantorGrantee = {
  __typename?: 'DcFp7cTaxFormGrantorGrantee';
  address?: Maybe<DcFp7cTaxFormAddress>;
  four?: Maybe<Scalars['String']>;
  one?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  three?: Maybe<Scalars['String']>;
  two?: Maybe<Scalars['String']>;
};

export type DefaultLineMapping = {
  __typename?: 'DefaultLineMapping';
  cdAlta?: Maybe<Scalars['Boolean']>;
  hud1986?: Maybe<Scalars['Boolean']>;
  hud2010?: Maybe<Scalars['Boolean']>;
};

export type DeleteAdjustmentInput = {
  id: Scalars['String'];
  orderId: Scalars['String'];
};

export type DeleteAdminMilestoneResponse = {
  __typename?: 'DeleteAdminMilestoneResponse';
  milestone?: Maybe<DeletedAdminMilestone>;
  remainingTasks?: Maybe<Scalars['Int']>;
};

export type DeleteAdminTaskResponse = {
  __typename?: 'DeleteAdminTaskResponse';
  dependentTasks?: Maybe<Array<Maybe<DependentTask>>>;
  task?: Maybe<AdminTask>;
};

export type DeleteBuyerRepResponse = OrderResponse & {
  __typename?: 'DeleteBuyerRepResponse';
  deletedBuyerRepId: Scalars['ID'];
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
};

export type DeleteBuyerResponse = OrderResponse & {
  __typename?: 'DeleteBuyerResponse';
  deletedBuyerId: Scalars['ID'];
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
};

export type DeleteDcAdjustmentInput = {
  id: Scalars['String'];
  orderId: Scalars['String'];
};

export type DeleteDepartmentResponse = {
  __typename?: 'DeleteDepartmentResponse';
  department?: Maybe<Department>;
  workflows?: Maybe<Array<Maybe<AdminWorkflow>>>;
};

export type DeleteExceptionInput = {
  exceptionId: Scalars['String'];
  orderId: Scalars['ID'];
};

export type DeleteFeeInput = {
  id: Scalars['String'];
  orderId: Scalars['String'];
};

export type DeleteLineDetailInput = {
  escrowAccountId: Scalars['String'];
  lineDetailId: Scalars['String'];
  transactionId: Scalars['String'];
};

export type DeleteNoteInput = {
  appliesToId?: InputMaybe<Scalars['String']>;
  entityId: Scalars['String'];
  entityType: NoteEntityType;
  noteId: Scalars['String'];
  tenantOrgEntityId: Scalars['String'];
};

export type DeleteOrderPartyResponse = {
  __typename?: 'DeleteOrderPartyResponse';
  deletedPartyId: Scalars['ID'];
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
};

export type DeleteRequirementInput = {
  orderId: Scalars['ID'];
  requirementId: Scalars['String'];
};

export type DeleteSecurityGroupInput = {
  id: Scalars['ID'];
};

export type DeleteSellerRepResponse = OrderResponse & {
  __typename?: 'DeleteSellerRepResponse';
  deletedSellerRepId: Scalars['ID'];
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
};

export type DeleteSellerResponse = OrderResponse & {
  __typename?: 'DeleteSellerResponse';
  deletedSellerId: Scalars['ID'];
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
};

export type DeleteTaskResponse = {
  __typename?: 'DeleteTaskResponse';
  dependentTasks?: Maybe<Array<Maybe<DependentTask>>>;
  task?: Maybe<Task>;
};

export type DeleteTransactionInput = {
  escrowAccountId: Scalars['String'];
  transactionId: Scalars['String'];
};

export type DeleteUserLocksInput = {
  id: Scalars['ID'];
};

export type DeletedAdminMilestone = {
  __typename?: 'DeletedAdminMilestone';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sortIndex: Scalars['Int'];
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
  workflowId: Scalars['ID'];
};

export type Department = {
  __typename?: 'Department';
  createdBy?: Maybe<User>;
  createdById: Scalars['ID'];
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  users?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DepartmentInput = {
  name: Scalars['String'];
  users: Array<InputMaybe<Scalars['String']>>;
};

export type DependentTask = {
  __typename?: 'DependentTask';
  milestone?: Maybe<Scalars['String']>;
  task?: Maybe<Scalars['String']>;
};

export type DepositPayLoad = {
  __typename?: 'DepositPayLoad';
  itemId: Scalars['ID'];
};

export type DisbursementSummaryForm = {
  __typename?: 'DisbursementSummaryForm';
  balances?: Maybe<BalanceGridDisbursementSummaryForm>;
  buyer?: Maybe<Scalars['String']>;
  closeDate?: Maybe<Scalars['String']>;
  disbursementDate?: Maybe<Scalars['String']>;
  escrowAccountName?: Maybe<Scalars['String']>;
  lenderName?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['Float']>;
  orderNumber?: Maybe<Scalars['String']>;
  pendingDisbursements?: Maybe<FundItemsDisbursementSummaryForm>;
  pendingReceipts?: Maybe<FundItemsDisbursementSummaryForm>;
  postedDisbursements?: Maybe<FundItemsDisbursementSummaryForm>;
  postedReceipts?: Maybe<FundItemsDisbursementSummaryForm>;
  propertyAddress?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  seller?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
};

export type Document = Node & {
  __typename?: 'Document';
  attributes?: Maybe<TemplateAttributes>;
  companyId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  customSortOrder?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  documentType?: Maybe<DocumentType>;
  fileSrc?: Maybe<FileSrc>;
  fileType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isReadOnly?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  listMergeChoices?: Maybe<Scalars['String']>;
  mergeFieldData?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['ID']>;
  path?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  showMergeFields?: Maybe<Scalars['Boolean']>;
  sizeBytes?: Maybe<Scalars['Int']>;
  skipClone?: Maybe<Scalars['Boolean']>;
  sourceTemplateId?: Maybe<Scalars['String']>;
  src?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['ID']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  uploadStatus?: Maybe<UploadStatus>;
  wellKnownTemplateType?: Maybe<Scalars['String']>;
};

export type DocumentEdge = Edge & {
  __typename?: 'DocumentEdge';
  node: Document;
};

export type DocumentSaveAsAsyncResponse = {
  __typename?: 'DocumentSaveAsAsyncResponse';
  subscriptionId?: Maybe<Scalars['String']>;
};

export type DocumentSaveAsInput = {
  documentId: Scalars['ID'];
  name: Scalars['String'];
  orderId: Scalars['ID'];
  targetFormat: Scalars['String'];
};

export type DocumentSaveAsRequestV2Input = {
  documentId: Scalars['ID'];
  name: Scalars['String'];
  orderId: Scalars['ID'];
  targetFormat: DocumentSaveAsRequestV2InputTargetFormat;
};

export enum DocumentSaveAsRequestV2InputTargetFormat {
  Docx = 'docx',
  Pdf = 'pdf'
}

export enum DocumentType {
  Block = 'Block',
  Document = 'Document',
  Folder = 'Folder',
  Set = 'Set',
  Template = 'Template'
}

export type DocumentsConnection = Connection & {
  __typename?: 'DocumentsConnection';
  edges: Array<DocumentEdge>;
  pageInfo: PageInfo;
};

export type DollarsPercent = {
  __typename?: 'DollarsPercent';
  dollars?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
};

export type DownloadAsyncRequestV2Input = {
  /** @minItems 1 */
  documentIds: Array<Scalars['String']>;
  orderId: Scalars['ID'];
};

export type DownloadDocumentsAsyncInput = {
  documentIds: Array<Scalars['String']>;
};

export type DownloadDocumentsAsyncResponse = {
  __typename?: 'DownloadDocumentsAsyncResponse';
  subscriptionId?: Maybe<Scalars['String']>;
};

export type DownloadInput = {
  items: Array<DownloadItemInput>;
};

export type DownloadItemInput = {
  documentId: Scalars['String'];
};

export type DownloadItemResponse = {
  __typename?: 'DownloadItemResponse';
  documentId?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
};

export type DownloadResponse = {
  __typename?: 'DownloadResponse';
  items: Array<Maybe<DownloadItemResponse>>;
};

export type DownloadTemplateDocRequestV2Input = {
  documentType: TemplateDocTypeV2;
  /** @minItems 1 */
  items: Array<TemplateDocIdV2Input>;
};

export type DownloadTemplateDocResultV2 = {
  __typename?: 'DownloadTemplateDocResultV2';
  items: Array<DownloadTemplateUrlV2>;
};

export type DownloadTemplateUrlV2 = {
  __typename?: 'DownloadTemplateUrlV2';
  documentId: Scalars['ID'];
  downloadUrl: Scalars['String'];
};

export type DuplicateDocumentInput = {
  name: Scalars['String'];
  targetFormat?: InputMaybe<Scalars['String']>;
  targetOrderId?: InputMaybe<Scalars['String']>;
};

export type DuplicateTemplateDocV2Input = {
  attributes?: InputMaybe<TemplateAttributesV2Input>;
  description?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type DuplicateTemplateInput = {
  attributes?: InputMaybe<TemplateAttributesInput>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<DocumentType>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  targetFormat?: InputMaybe<Scalars['String']>;
};

export type Edge = {
  node: Node;
};

export type EffectiveOrderCommissions = {
  __typename?: 'EffectiveOrderCommissions';
  buyerPaidPercentage?: Maybe<Scalars['Float']>;
  commissionBasis?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lineItems: Array<EffectiveOrderCommissionsLineItem>;
  sellerPaidPercentage?: Maybe<Scalars['Float']>;
  totalCommissionAmount?: Maybe<Scalars['Float']>;
};

export type EffectiveOrderCommissionsLineItem = BaseOrderCommissionsLineItem & {
  __typename?: 'EffectiveOrderCommissionsLineItem';
  agentType: Scalars['String'];
  commissionAmount?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  party?: Maybe<OrderParty>;
  partyId: Scalars['String'];
};

export type EmailAddressInput = {
  emailAddress?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
};

export type EmailAddressSchema = {
  __typename?: 'EmailAddressSchema';
  emailAddress?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export type EndorsementFeeAdditionalData = {
  __typename?: 'EndorsementFeeAdditionalData';
  externalEndorsementId?: Maybe<Scalars['String']>;
  sourceBorrowerPaidAt?: Maybe<Scalars['Float']>;
  sourceSellerPaidAt?: Maybe<Scalars['Float']>;
};

export type EndorsementRateCalculation = {
  __typename?: 'EndorsementRateCalculation';
  additionalQuestions: Array<AdditionalQuestion>;
  amount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
};

export type EndorsementRateRequest = {
  additionalQuestions?: InputMaybe<Array<AdditionalQuestionsRateRequest>>;
  amount?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
};

export type EndorsementRateValidationRequest = {
  id?: InputMaybe<Scalars['String']>;
};

export type Error = {
  __typename?: 'Error';
  errorCode: Scalars['String'];
  message: Scalars['String'];
};

export type ErrorBody = {
  __typename?: 'ErrorBody';
  errorCode?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type ErrorObject = {
  __typename?: 'ErrorObject';
  body?: Maybe<ErrorBody>;
  statusCode?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
};

export type EscrowAccount = {
  __typename?: 'EscrowAccount';
  accountNumber?: Maybe<Scalars['String']>;
  accountNumberAlternate?: Maybe<Scalars['String']>;
  addresses?: Maybe<Array<Maybe<EscrowAccountAddress>>>;
  bankName?: Maybe<Scalars['String']>;
  canActivate?: Maybe<Scalars['Boolean']>;
  checkPrinting?: Maybe<CheckPrinting>;
  companies?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy?: Maybe<User>;
  createdTimestamp?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Maybe<EmailAddressSchema>>>;
  escrowAccountName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  positivePay?: Maybe<PositivePay>;
  routingNumber?: Maybe<Scalars['String']>;
  routingNumberDeposit?: Maybe<Scalars['String']>;
  routingNumberFractional?: Maybe<Scalars['String']>;
  routingNumberWire?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type EscrowAccountAddress = {
  __typename?: 'EscrowAccountAddress';
  address1?: Maybe<Scalars['String']>;
  address1AndAddress2?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressType?: Maybe<EscrowAddressTypes>;
  city?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  countyFips?: Maybe<Scalars['String']>;
  countyName?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  stateOrProvince?: Maybe<Scalars['String']>;
  usePrimaryAddress?: Maybe<Scalars['Boolean']>;
};

export type EscrowAccountAddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<EscrowAddressTypes>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  countyFips?: InputMaybe<Scalars['String']>;
  countyName?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  stateOrProvince?: InputMaybe<Scalars['String']>;
  usePrimaryAddress?: InputMaybe<Scalars['Boolean']>;
};

export type EscrowAccountNumberAlternateProtected = {
  __typename?: 'EscrowAccountNumberAlternateProtected';
  accountNumberAlternateProtected: Scalars['String'];
  escrowAccountId: Scalars['ID'];
};

export type EscrowAccountNumberProtected = {
  __typename?: 'EscrowAccountNumberProtected';
  accountNumberProtected: Scalars['String'];
  escrowAccountId: Scalars['ID'];
};

export enum EscrowAddressTypes {
  Alternate = 'Alternate',
  Mailing = 'Mailing',
  Primary = 'Primary'
}

export type EscrowTrialEntry = {
  __typename?: 'EscrowTrialEntry';
  balance?: Maybe<Scalars['Float']>;
  createdDate?: Maybe<Scalars['String']>;
  disbursements?: Maybe<Scalars['Float']>;
  fundingDate?: Maybe<Scalars['String']>;
  lastActivityDate?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  receipts?: Maybe<Scalars['Float']>;
};

export type EstimatedTaxesInsuranceAssessments = {
  __typename?: 'EstimatedTaxesInsuranceAssessments';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  estimatedEscrow?: Maybe<Scalars['Float']>;
  estimatedEscrowOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  id?: Maybe<Scalars['ID']>;
  items?: Maybe<Array<Maybe<EstimatedTaxesInsuranceAssessmentsItem>>>;
  orderId?: Maybe<Scalars['ID']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type EstimatedTaxesInsuranceAssessmentsInput = {
  estimatedEscrow?: InputMaybe<Scalars['Float']>;
  items?: InputMaybe<Array<InputMaybe<EstimatedTaxesInsuranceAssessmentsItemInput>>>;
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type EstimatedTaxesInsuranceAssessmentsItem = {
  __typename?: 'EstimatedTaxesInsuranceAssessmentsItem';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  inEscrow?: Maybe<Scalars['String']>;
  includedInEstimate?: Maybe<Scalars['Boolean']>;
  isDefaultLine?: Maybe<Scalars['Boolean']>;
  orderId?: Maybe<Scalars['ID']>;
};

export type EstimatedTaxesInsuranceAssessmentsItemInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  inEscrow?: InputMaybe<Scalars['String']>;
  includedInEstimate?: InputMaybe<Scalars['Boolean']>;
};

export type ExceptionReference = {
  exceptionId: Scalars['String'];
  exceptions?: InputMaybe<Array<InputMaybe<ExceptionReference>>>;
};

export type Fee = {
  __typename?: 'Fee';
  borrowerPaidAt?: Maybe<Scalars['Float']>;
  borrowerPaidAtOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  borrowerPaidBefore?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  defaultLineMapping?: Maybe<DefaultLineMapping>;
  description: Scalars['String'];
  feeLineType: Scalars['String'];
  feeTypeAdditionalData?: Maybe<FeeTypeAdditionalData>;
  funding?: Maybe<Scalars['String']>;
  gfeLineNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSetAsCDLastLine?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<FeeLineNumber>;
  orderId: Scalars['String'];
  payeeId?: Maybe<Scalars['String']>;
  payeeIdOverrideMetadata?: Maybe<OverrideMetadataString>;
  payeeName?: Maybe<Scalars['String']>;
  pboBorrowerAmount?: Maybe<Scalars['Float']>;
  pboBorrowerPaidById?: Maybe<Scalars['String']>;
  pboBorrowerPaidByName?: Maybe<Scalars['String']>;
  pboSellerAmount?: Maybe<Scalars['Float']>;
  pboSellerPaidById?: Maybe<Scalars['String']>;
  pboSellerPaidByName?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['String']>;
  sectionMapping: SectionMapping;
  sellerPaidAt?: Maybe<Scalars['Float']>;
  sellerPaidBefore?: Maybe<Scalars['Float']>;
  statementPayeeDisplayName?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type FeeItem = {
  __typename?: 'FeeItem';
  amount?: Maybe<Scalars['Float']>;
  buyerPercentage: Scalars['Float'];
  gfe?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  payeeId?: Maybe<Scalars['String']>;
  payeeIdOverrideMetadata?: Maybe<OverrideMetadataString>;
  sellerPercentage: Scalars['Float'];
};

export type FeeLineNumber = {
  __typename?: 'FeeLineNumber';
  alta?: Maybe<Scalars['String']>;
  cd?: Maybe<Scalars['String']>;
  hud1986?: Maybe<Scalars['String']>;
  hud2010?: Maybe<Scalars['String']>;
};

export type FeeToUpdateInput = {
  feeLineType: Scalars['String'];
  id: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
};

export type FeeTypeAdditionalData = {
  __typename?: 'FeeTypeAdditionalData';
  agentDisclosureFeeData?: Maybe<AgentDisclosureFeeAdditionalData>;
  /** @deprecated Use commissionFeeData.agentType */
  agentType?: Maybe<Scalars['String']>;
  commissionFeeData?: Maybe<CommissionFeeAdditionalData>;
  cplFeeData?: Maybe<CplFeeAdditionalData>;
  /** @deprecated Use commissionFeeData.externalCommissionLineId */
  externalCommissionLineId?: Maybe<Scalars['String']>;
  homeownersInsurancePremiumEscrowFeeData?: Maybe<HomeownersInsurancePremiumEscrowFeeAdditionalData>;
  homeownersInsurancePremiumFeeData?: Maybe<HomeownersInsurancePremiumFeeAdditionalData>;
  lenderCreditsFeeData?: Maybe<LenderCreditsFeeAdditionalData>;
  lenderDisclosureFeeData?: Maybe<OwnerLenderDisclosureFeeAdditionalData>;
  lenderEndorsementFeeData?: Maybe<EndorsementFeeAdditionalData>;
  lenderPremiumFeeData?: Maybe<PremiumFeeAdditionalData>;
  loanDiscountFeeData?: Maybe<LoanDiscountFeeAdditionalData>;
  loanOriginationFeeData?: Maybe<LoanOriginationFeeAdditionalData>;
  mortgageInsurancePremiumEscrowFeeData?: Maybe<MortgageInsurancePremiumEscrowFeeAdditionalData>;
  mortgageInsurancePremiumFeeData?: Maybe<MortgageInsurancePremiumFeeAdditionalData>;
  ownerDisclosureFeeData?: Maybe<OwnerLenderDisclosureFeeAdditionalData>;
  ownerEndorsementFeeData?: Maybe<EndorsementFeeAdditionalData>;
  ownerPremiumFeeData?: Maybe<PremiumFeeAdditionalData>;
  prepaidInterestFeeData?: Maybe<PrepaidInterestFeeAdditionalData>;
  propertyTaxEscrowFeeData?: Maybe<PropertyTaxEscrowFeeAdditionalData>;
  propertyTaxFeeData?: Maybe<PropertyTaxFeeAdditionalData>;
  recordingFeeData?: Maybe<RecordingFeeAdditionalData>;
  standardEscrowFeeData?: Maybe<StandardEscrowFeeAdditionalData>;
  titleFeeData?: Maybe<TitleFeeAdditionalData>;
  transferTaxFeeData?: Maybe<TransferTaxFeeAdditionalData>;
  underwriterDisclosureFeeData?: Maybe<UnderwriterDisclosureFeeAdditionalData>;
};

export type FeeTypeAdditionalDataCreateInput = {
  amountPerMonth?: InputMaybe<Scalars['Float']>;
  numberOfMonths?: InputMaybe<Scalars['Float']>;
};

export type FeeTypeAdditionalDataInput = {
  additionalDescription?: InputMaybe<Scalars['String']>;
  agentType?: InputMaybe<Scalars['String']>;
  amountPerDay?: InputMaybe<Scalars['Float']>;
  amountPerMonth?: InputMaybe<Scalars['Float']>;
  externalCommissionLineId?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['String']>;
  lenderCreditsAmount?: InputMaybe<Scalars['Float']>;
  numberOfMonths?: InputMaybe<Scalars['Float']>;
  originationAdjustmentPercentage?: InputMaybe<Scalars['Float']>;
  originationPercentage?: InputMaybe<Scalars['Float']>;
  toDate?: InputMaybe<Scalars['String']>;
};

export type FeesInput = {
  fees?: InputMaybe<Array<InputMaybe<FeesItemInput>>>;
  updatedTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type FeesItemInput = {
  amount?: InputMaybe<Scalars['Float']>;
  buyerPercentage: Scalars['Float'];
  gfe?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  payeeId?: InputMaybe<Scalars['String']>;
  sellerPercentage: Scalars['Float'];
};

export type FileSrc = {
  __typename?: 'FileSrc';
  native?: Maybe<Scalars['String']>;
  serialized?: Maybe<Scalars['String']>;
};

export type FileUrlSourceV2 = {
  __typename?: 'FileUrlSourceV2';
  native?: Maybe<Scalars['String']>;
  serialized?: Maybe<Scalars['String']>;
};

export type FilteredTenantCompanies = {
  __typename?: 'FilteredTenantCompanies';
  childNodes?: Maybe<Array<Maybe<TenantChildNode>>>;
  totalCompanies: Scalars['Int'];
};

export type FinalizedPayorPayeeData = {
  __typename?: 'FinalizedPayorPayeeData';
  address?: Maybe<Address>;
  displayName?: Maybe<Scalars['String']>;
};

export type Fund = {
  __typename?: 'Fund';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locked?: Maybe<Scalars['Boolean']>;
  orderId?: Maybe<Scalars['String']>;
  totals?: Maybe<FundTotals>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type FundItemsDisbursementSummaryForm = {
  __typename?: 'FundItemsDisbursementSummaryForm';
  items?: Maybe<Array<Maybe<FundLineItemDisbursementSummaryForm>>>;
  total?: Maybe<Scalars['Float']>;
};

export type FundLineItemDisbursementSummaryForm = {
  __typename?: 'FundLineItemDisbursementSummaryForm';
  fundingTransactionType?: Maybe<Scalars['String']>;
  payeeName?: Maybe<Scalars['String']>;
  reconcileDate?: Maybe<Scalars['String']>;
  refNumber?: Maybe<Scalars['String']>;
  transactionAmount?: Maybe<Scalars['Float']>;
  transactionDate?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<Scalars['String']>;
};

export type FundTotals = {
  __typename?: 'FundTotals';
  fundedDisbursementBalance?: Maybe<Scalars['Float']>;
  fundedReceiptBalance?: Maybe<Scalars['Float']>;
  orderDisbursementBalance?: Maybe<Scalars['Float']>;
  orderReceiptBalance?: Maybe<Scalars['Float']>;
};

export type FundingTaxId = {
  __typename?: 'FundingTaxId';
  taxId?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
};

export type FundingTaxIdInput = {
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
};

export type GenerateAsyncResponseV2 = {
  __typename?: 'GenerateAsyncResponseV2';
  subscriptionId: Scalars['ID'];
};

export type GetAdjustmentsResponse = {
  __typename?: 'GetAdjustmentsResponse';
  adjustments: Array<Adjustment>;
};

export type GetMergeFieldsResponseV2 = {
  __typename?: 'GetMergeFieldsResponseV2';
  mergeFields: Array<MergeFieldDataV2>;
};

export type GetOrderDocumentV2Input = {
  canBeHidden?: InputMaybe<Scalars['Boolean']>;
  documentId: Scalars['ID'];
  orderId: Scalars['ID'];
};

export type GetRfttDocumentsInput = {
  city: Scalars['String'];
  county: Scalars['String'];
  loanAmount?: InputMaybe<Scalars['Float']>;
  propertyType: Scalars['String'];
  salesAmount: Scalars['Float'];
  settlementDate: Scalars['String'];
  state: Scalars['String'];
  transactionType: Scalars['String'];
};

export type GetRfttFeesInput = {
  city: Scalars['String'];
  county: Scalars['String'];
  documents: Array<GetRfttQuestionsDocumentInput>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  propertyType: Scalars['String'];
  questions: Array<GetRfttFeesQuestionInput>;
  salesAmount?: InputMaybe<Scalars['Float']>;
  settlementDate: Scalars['String'];
  state: Scalars['String'];
  transactionType: Scalars['String'];
};

export type GetRfttFeesQuestionInput = {
  answer: Scalars['String'];
  defaultAnswer?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<RfttQuestionOptionInput>>>;
  providerMetadata: RfttQuestionProviderMetadataInput;
  questionText?: InputMaybe<Scalars['String']>;
  shouldPrompt: Scalars['Boolean'];
  valueType: Scalars['String'];
};

export type GetRfttQuestionsDocumentInput = {
  considerationAmount?: InputMaybe<Scalars['Float']>;
  documentId: Scalars['String'];
  documentName: Scalars['String'];
  documentType: Scalars['String'];
  numberOfPages?: InputMaybe<Scalars['Float']>;
};

export type GetRfttQuestionsInput = {
  city: Scalars['String'];
  county: Scalars['String'];
  documents: Array<GetRfttQuestionsDocumentInput>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  propertyType: Scalars['String'];
  salesAmount: Scalars['Float'];
  settlementDate: Scalars['String'];
  state: Scalars['String'];
  transactionType: Scalars['String'];
};

export type GetRateValidation = RateValidation & {
  __typename?: 'GetRateValidation';
  missingFields: Array<Scalars['String']>;
  orderId: Scalars['String'];
  premiumType: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type GetTemplatesByNameAndFileTypeV2Input = {
  documentType: TemplateDocTypeV2;
  fileType: Scalars['String'];
  name: Scalars['String'];
};

export type GetTenantUnderwritersResponse = TenantUnderwriterResponse & {
  __typename?: 'GetTenantUnderwritersResponse';
  tenantUnderwriter: TenantUnderwriter;
  tenantUnderwriters: Array<TenantUnderwriter>;
};


export type GetTenantUnderwritersResponseTenantUnderwriterArgs = {
  tenantUnderwriterId?: InputMaybe<Scalars['String']>;
};


export type GetTenantUnderwritersResponseTenantUnderwritersArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};

export type GfeCharge = {
  __typename?: 'GfeCharge';
  comparisonCategory?: Maybe<Scalars['String']>;
  comparisonCategoryLocked?: Maybe<Scalars['Boolean']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  gfeAmount?: Maybe<Scalars['Float']>;
  gfeChargeAdditionalData?: Maybe<GfeChargeAdditionalData>;
  gfeLineNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lineNumber?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['ID']>;
  statementAmount?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type GfeChargeAdditionalData = {
  __typename?: 'GfeChargeAdditionalData';
  amountPerDay?: Maybe<Scalars['Float']>;
};

export type GoogleConfiguration = {
  __typename?: 'GoogleConfiguration';
  apiKey?: Maybe<Scalars['String']>;
};

export type HudBorrowerCalculations = {
  __typename?: 'HUDBorrowerCalculations';
  cashCheckFromBorrower?: Maybe<Scalars['Float']>;
  loanAmount?: Maybe<Scalars['Float']>;
  totalDisbursementsToBorrower?: Maybe<Scalars['Float']>;
  totalDisbursementsToOthers?: Maybe<Scalars['Float']>;
  totalSettlementCharges?: Maybe<Scalars['Float']>;
};

export type HomeownersInsurancePremiumEscrowFeeAdditionalData = {
  __typename?: 'HomeownersInsurancePremiumEscrowFeeAdditionalData';
  amountPerMonth?: Maybe<Scalars['Float']>;
  amountPerMonthOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type HomeownersInsurancePremiumFeeAdditionalData = {
  __typename?: 'HomeownersInsurancePremiumFeeAdditionalData';
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type Hud1986Statement = {
  __typename?: 'Hud1986Statement';
  addendum?: Maybe<HudStatementAddendum>;
  header?: Maybe<HudStatementHeader>;
  settlementCharges?: Maybe<HudStatementSettlementCharges>;
  signatures?: Maybe<HudStatementSignatures>;
  transactionSummary?: Maybe<HudStatementTransactionSummary>;
};

export type Hud2010Statement = {
  __typename?: 'Hud2010Statement';
  addendum?: Maybe<HudStatementAddendum>;
  gfeComparison?: Maybe<Hud2010StatementGfeComparison>;
  header?: Maybe<HudStatementHeader>;
  loanTerms?: Maybe<Hud2010StatementLoanTerms>;
  settlementCharges?: Maybe<HudStatementSettlementCharges>;
  signatures?: Maybe<HudStatementSignatures>;
  transactionSummary?: Maybe<HudStatementTransactionSummary>;
};

export type Hud2010StatementGfeComparison = {
  __typename?: 'Hud2010StatementGfeComparison';
  canChange?: Maybe<Hud2010StatementGfeComparisonSection>;
  cannotIncrease?: Maybe<Hud2010StatementGfeComparisonSection>;
  tenPercent?: Maybe<Hud2010StatementGfeComparisonSection>;
};

export type Hud2010StatementGfeComparisonSection = {
  __typename?: 'Hud2010StatementGfeComparisonSection';
  gfeTotal?: Maybe<Scalars['Float']>;
  increaseAmount?: Maybe<Scalars['Float']>;
  increasePercent?: Maybe<Scalars['Float']>;
  items?: Maybe<Array<Maybe<Hud2010StatementGfeComparisonSectionItem>>>;
  statementTotal?: Maybe<Scalars['Float']>;
};

export type Hud2010StatementGfeComparisonSectionItem = {
  __typename?: 'Hud2010StatementGfeComparisonSectionItem';
  description?: Maybe<Scalars['String']>;
  gfeAmount?: Maybe<Scalars['Float']>;
  lineNumber?: Maybe<Scalars['String']>;
  statementAmount?: Maybe<Scalars['Float']>;
};

export type Hud2010StatementLoanTerms = {
  __typename?: 'Hud2010StatementLoanTerms';
  balloonPayment?: Maybe<Hud2010StatementLoanTermsBalloonPayment>;
  escrowPayments?: Maybe<Hud2010StatementLoanTermsEscrowPayments>;
  interestRate?: Maybe<Scalars['Float']>;
  interestRateIncrease?: Maybe<Hud2010StatementLoanTermsInterestRateIncrease>;
  loanAmount?: Maybe<Scalars['Float']>;
  loanAmountIncrease?: Maybe<Hud2010StatementLoanTermsLoanAmountIncrease>;
  loanTerm?: Maybe<Scalars['String']>;
  monthlyAmountOwed?: Maybe<Hud2010StatementLoanTermsMonthlyAmountOwed>;
  monthlyPrincipalAndInterestIncrease?: Maybe<Hud2010StatementLoanTermsMonthlyPrincipalAndInterestIncrease>;
  prepaymentPenalty?: Maybe<Hud2010StatementLoanTermsPrepaymentPenalty>;
};

export type Hud2010StatementLoanTermsBalloonPayment = {
  __typename?: 'Hud2010StatementLoanTermsBalloonPayment';
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentDueDate?: Maybe<Scalars['String']>;
  paymentDueIncrement?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type Hud2010StatementLoanTermsEscrowPayments = {
  __typename?: 'Hud2010StatementLoanTermsEscrowPayments';
  escrowIncludesOther?: Maybe<Array<Maybe<HudStatementLoanTermsEscrowPaymentsOther>>>;
  includesHomeownersInsurance?: Maybe<Scalars['Boolean']>;
  includesPropertyTaxes?: Maybe<Scalars['Boolean']>;
  initialMonthlyAmount?: Maybe<Scalars['Float']>;
  monthlyEscrowPayment?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type Hud2010StatementLoanTermsInterestRateIncrease = {
  __typename?: 'Hud2010StatementLoanTermsInterestRateIncrease';
  adjustsEveryAfterDate?: Maybe<Scalars['String']>;
  adjustsEveryIncrement?: Maybe<Scalars['String']>;
  changePercentage?: Maybe<Scalars['Float']>;
  firstChangeDate?: Maybe<Scalars['String']>;
  maximumInterestPercentage?: Maybe<Scalars['Float']>;
  minimumInterestPercentage?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type Hud2010StatementLoanTermsLoanAmountIncrease = {
  __typename?: 'Hud2010StatementLoanTermsLoanAmountIncrease';
  asHighAsAmount?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type Hud2010StatementLoanTermsMonthlyAmountOwed = {
  __typename?: 'Hud2010StatementLoanTermsMonthlyAmountOwed';
  amount?: Maybe<Scalars['Float']>;
  includesInterest?: Maybe<Scalars['Boolean']>;
  includesMortgageInsurance?: Maybe<Scalars['Boolean']>;
  includesPrincipal?: Maybe<Scalars['Boolean']>;
};

export type Hud2010StatementLoanTermsMonthlyPrincipalAndInterestIncrease = {
  __typename?: 'Hud2010StatementLoanTermsMonthlyPrincipalAndInterestIncrease';
  asHighAsAmount?: Maybe<Scalars['Float']>;
  firstChangeAsHighAsAmount?: Maybe<Scalars['Float']>;
  firstChangeDate?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type Hud2010StatementLoanTermsPrepaymentPenalty = {
  __typename?: 'Hud2010StatementLoanTermsPrepaymentPenalty';
  penaltyAsHighAsAmount?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type HudStatementAddendum = {
  __typename?: 'HudStatementAddendum';
  settlementCharges?: Maybe<HudStatementSettlementCharges>;
  transactionSummary?: Maybe<HudStatementAddendumTransactionSummary>;
};

export type HudStatementAddendumTransactionSummary = {
  __typename?: 'HudStatementAddendumTransactionSummary';
  section100?: Maybe<HudStatementAddendumTransactionSummarySection>;
  section200?: Maybe<HudStatementAddendumTransactionSummarySection>;
  section400?: Maybe<HudStatementAddendumTransactionSummarySection>;
  section500?: Maybe<HudStatementAddendumTransactionSummarySection>;
  section1500?: Maybe<HudStatementAddendumTransactionSummarySection>;
};

export type HudStatementAddendumTransactionSummarySection = {
  __typename?: 'HudStatementAddendumTransactionSummarySection';
  items?: Maybe<Array<Maybe<HudStatementAddendumTransactionSummarySectionItem>>>;
};

export type HudStatementAddendumTransactionSummarySectionItem = {
  __typename?: 'HudStatementAddendumTransactionSummarySectionItem';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
};

export type HudStatementBorrowerSeller = {
  __typename?: 'HudStatementBorrowerSeller';
  address?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type HudStatementHeader = {
  __typename?: 'HudStatementHeader';
  borrowers?: Maybe<Array<Maybe<HudStatementBorrowerSeller>>>;
  dateDisbursement?: Maybe<Scalars['String']>;
  dateSettlement?: Maybe<Scalars['String']>;
  lenderCompanyAddress?: Maybe<Scalars['String']>;
  lenderCompanyCityStateZip?: Maybe<Scalars['String']>;
  lenderCompanyName?: Maybe<Scalars['String']>;
  loanNumber?: Maybe<Scalars['String']>;
  loanType?: Maybe<Scalars['String']>;
  micNumber?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyCityStateZip?: Maybe<Scalars['String']>;
  sellers?: Maybe<Array<Maybe<HudStatementBorrowerSeller>>>;
  settlementAgentCompanyAddress?: Maybe<Scalars['String']>;
  settlementAgentCompanyName?: Maybe<Scalars['String']>;
  settlementAgentContactFullName?: Maybe<Scalars['String']>;
  settlementLocationAddress?: Maybe<Scalars['String']>;
  settlementLocationCityStateZip?: Maybe<Scalars['String']>;
};

export type HudStatementLoanTermsEscrowPaymentsOther = {
  __typename?: 'HudStatementLoanTermsEscrowPaymentsOther';
  description?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type HudStatementSettlementCharges = {
  __typename?: 'HudStatementSettlementCharges';
  section700?: Maybe<HudStatementSettlementChargesSection>;
  section800?: Maybe<HudStatementSettlementChargesSection>;
  section900?: Maybe<HudStatementSettlementChargesSection>;
  section1000?: Maybe<HudStatementSettlementChargesSection>;
  section1100?: Maybe<HudStatementSettlementChargesSection>;
  section1200?: Maybe<HudStatementSettlementChargesSection>;
  section1300?: Maybe<HudStatementSettlementChargesSection>;
  section1400?: Maybe<HudStatementSettlementChargesSection>;
};

export type HudStatementSettlementChargesSection = {
  __typename?: 'HudStatementSettlementChargesSection';
  items?: Maybe<Array<Maybe<HudStatementSettlementChargesSectionItem>>>;
  title?: Maybe<Scalars['String']>;
};

export type HudStatementSettlementChargesSectionItem = {
  __typename?: 'HudStatementSettlementChargesSectionItem';
  bpa?: Maybe<Scalars['Float']>;
  descriptionAndPayee?: Maybe<Scalars['String']>;
  gfe?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['String']>;
  spa?: Maybe<Scalars['Float']>;
};

export type HudStatementSignature = {
  __typename?: 'HudStatementSignature';
  entityName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerofAttorneySigningName?: Maybe<Scalars['String']>;
};

export type HudStatementSignatures = {
  __typename?: 'HudStatementSignatures';
  buyers?: Maybe<Array<Maybe<HudStatementSignature>>>;
  escrowOfficer?: Maybe<Scalars['String']>;
  sellers?: Maybe<Array<Maybe<HudStatementSignature>>>;
};

export type HudStatementTransactionSummary = {
  __typename?: 'HudStatementTransactionSummary';
  borrowerCalcTotal?: Maybe<Scalars['Float']>;
  cashFromBorrower?: Maybe<Scalars['Boolean']>;
  cashFromSeller?: Maybe<Scalars['Boolean']>;
  section100?: Maybe<StatementLineItemAdjustmentSection>;
  section200?: Maybe<StatementLineItemAdjustmentSection>;
  section400?: Maybe<StatementLineItemAdjustmentSection>;
  section500?: Maybe<StatementLineItemAdjustmentSection>;
  section1500?: Maybe<StatementLineItemAdjustmentSection>;
  section1600?: Maybe<HudStatementTransactionSummarySection1600>;
  sellerCalcTotal?: Maybe<Scalars['Float']>;
  totalDueFromBorrower?: Maybe<Scalars['Float']>;
  totalDueFromSeller?: Maybe<Scalars['Float']>;
  totalDueToSeller?: Maybe<Scalars['Float']>;
  totalPaidByBorrower?: Maybe<Scalars['Float']>;
};

export type HudStatementTransactionSummarySection1600 = {
  __typename?: 'HudStatementTransactionSummarySection1600';
  items?: Maybe<Array<Maybe<HudStatementTransactionSummarySection1600Item>>>;
};

export type HudStatementTransactionSummarySection1600Item = {
  __typename?: 'HudStatementTransactionSummarySection1600Item';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  descriptionPrefix?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['String']>;
};

export type Image = {
  __typename?: 'Image';
  dataUrl?: Maybe<Scalars['String']>;
  metadata?: Maybe<ImageMetadata>;
};

export type ImageMetadata = {
  __typename?: 'ImageMetadata';
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};

export type ImportRepositoryItemEntry = {
  __typename?: 'ImportRepositoryItemEntry';
  error?: Maybe<Scalars['String']>;
  importCollision?: Maybe<Scalars['Boolean']>;
  repositoryTemplateId: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
  template?: Maybe<Document>;
};

export type ImportRepositoryItemEntryV2 = {
  __typename?: 'ImportRepositoryItemEntryV2';
  error?: Maybe<Scalars['String']>;
  importCollision: Scalars['Boolean'];
  repositoryTemplateId: Scalars['ID'];
  success: Scalars['Boolean'];
  template: TemplateDocV2;
};

export type ImportRepositoryTemplateInput = {
  overwriteBlocks?: InputMaybe<Scalars['Boolean']>;
  repositoryTemplateIds: Array<Scalars['String']>;
};

export type ImportRepositoryTemplateRequestV2Input = {
  documentType: ImportRepositoryTemplateRequestV2InputDocumentType;
  overwriteBlocks?: InputMaybe<Scalars['Boolean']>;
  repositoryTemplateIds: Array<Scalars['String']>;
};

export enum ImportRepositoryTemplateRequestV2InputDocumentType {
  Template = 'Template'
}

export type ImportRepositoryTemplateResponse = {
  __typename?: 'ImportRepositoryTemplateResponse';
  blockNameCollisions?: Maybe<Array<Scalars['String']>>;
  importCollision?: Maybe<Scalars['Boolean']>;
  results?: Maybe<Array<ImportRepositoryItemEntry>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ImportRepositoryTemplateResponseV2 = {
  __typename?: 'ImportRepositoryTemplateResponseV2';
  blockNameCollisions: Array<Scalars['String']>;
  importCollision: Scalars['Boolean'];
  results: Array<ImportRepositoryItemEntryV2>;
  success: Scalars['Boolean'];
};

export type IneligibleTransactions = {
  __typename?: 'IneligibleTransactions';
  reason?: Maybe<Scalars['String']>;
  transaction?: Maybe<Transaction>;
};

export type InsuredVesting = {
  __typename?: 'InsuredVesting';
  bodyContent?: Maybe<Scalars['String']>;
  bodyTemplate: Scalars['String'];
  mergeFields?: Maybe<Scalars['String']>;
  requirementMergeable?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type IntegratedRfttAnswerInput = {
  value?: InputMaybe<Scalars['String']>;
};

export type IntegratedRfttDocument = {
  __typename?: 'IntegratedRFTTDocument';
  considerationAmount?: Maybe<Scalars['Float']>;
  considerationAmountFallback?: Maybe<Scalars['Float']>;
  documentId: Scalars['String'];
  documentName: Scalars['String'];
  documentType: Scalars['String'];
  isDefault: Scalars['Boolean'];
  numberOfPages?: Maybe<Scalars['Float']>;
  numberOfPagesFallback?: Maybe<Scalars['Float']>;
};

export type IntegratedRfttDocumentsParams = {
  __typename?: 'IntegratedRFTTDocumentsParams';
  city: Scalars['String'];
  cityFallback?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  countyFallback?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['Float']>;
  propertyType?: Maybe<Scalars['String']>;
  salesAmount?: Maybe<Scalars['Float']>;
  settlementDate: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
};

export type IntegratedRfttDocumentsParamsInput = {
  city: Scalars['String'];
  cityFallback?: InputMaybe<Scalars['String']>;
  county: Scalars['String'];
  countyFallback?: InputMaybe<Scalars['String']>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  propertyType: Scalars['String'];
  salesAmount?: InputMaybe<Scalars['Float']>;
  settlementDate: Scalars['String'];
  state: Scalars['String'];
  transactionType: Scalars['String'];
};

export type IntegratedRfttFeesQuestionInput = {
  answer: Scalars['String'];
  defaultAnswer?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<IntegratedRfttQuestionOptionInput>>>;
  providerMetadata: IntegratedRfttQuestionProviderMetadataInput;
  questionText?: InputMaybe<Scalars['String']>;
  shouldPrompt: Scalars['Boolean'];
  valueType: Scalars['String'];
};

export type IntegratedRfttInput = {
  documents: Array<IntegratedRfttQuestionsDocumentInput>;
  documentsParams: IntegratedRfttDocumentsParamsInput;
  orderId: Scalars['String'];
  questions: Array<IntegratedRfttFeesQuestionInput>;
  recordingFees: IntegratedRecordingFeesInput;
  transferTaxes: IntegratedTransferTaxesInput;
};

export type IntegratedRfttQuestion = {
  __typename?: 'IntegratedRFTTQuestion';
  answer?: Maybe<Scalars['String']>;
  defaultAnswer?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  options?: Maybe<Array<IntegratedRfttQuestionOption>>;
  providerMetadata: IntegratedRfttQuestionProviderMetadata;
  questionText?: Maybe<Scalars['String']>;
  shouldPrompt: Scalars['Boolean'];
  valueType?: Maybe<Scalars['String']>;
};

export type IntegratedRfttQuestionOption = {
  __typename?: 'IntegratedRFTTQuestionOption';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type IntegratedRfttQuestionOptionInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type IntegratedRfttQuestionProviderMetadata = {
  __typename?: 'IntegratedRFTTQuestionProviderMetadata';
  lvis: IntegratedRfttQuestionProviderMetadataLvis;
};

export type IntegratedRfttQuestionProviderMetadataInput = {
  lvis: IntegratedRfttQuestionProviderMetadataLvisInput;
};

export type IntegratedRfttQuestionProviderMetadataLvis = {
  __typename?: 'IntegratedRFTTQuestionProviderMetadataLVIS';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type IntegratedRfttQuestionProviderMetadataLvisInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type IntegratedRfttQuestionsDocumentInput = {
  considerationAmount?: InputMaybe<Scalars['Float']>;
  considerationAmountFallback?: InputMaybe<Scalars['Float']>;
  documentId: Scalars['String'];
  documentName: Scalars['String'];
  documentType: Scalars['String'];
  isDefault: Scalars['Boolean'];
  numberOfPages: Scalars['Float'];
  numberOfPagesFallback?: InputMaybe<Scalars['Float']>;
};

export type IntegratedRecordingFeeInput = {
  amount: Scalars['Float'];
  amountFallback?: InputMaybe<Scalars['Float']>;
  buyerAmount: Scalars['Float'];
  buyerAmountFallback?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nameFallback: Scalars['String'];
  type: Scalars['String'];
};

export type IntegratedRecordingFeesInput = {
  lineItems: Array<IntegratedRecordingFeeInput>;
  payeeId: Scalars['String'];
  payeeSuggested?: InputMaybe<Scalars['String']>;
};

export type IntegratedTransferTaxInput = {
  amount: Scalars['Float'];
  amountFallback?: InputMaybe<Scalars['Float']>;
  buyerAmount: Scalars['Float'];
  buyerAmountFallback?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nameFallback: Scalars['String'];
  payeeId: Scalars['String'];
  payeeSuggested?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type IntegratedTransferTaxesInput = {
  lineItems: Array<IntegratedTransferTaxInput>;
};

export type Integration = {
  __typename?: 'Integration';
  cplProduct: Scalars['JSONObject'];
  pricing: Scalars['JSONObject'];
  products: Scalars['JSONObject'];
};

export type InviteUserInput = {
  id: Scalars['ID'];
};

export type Jacket = {
  __typename?: 'Jacket';
  documentId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  fileId?: Maybe<Scalars['Int']>;
  fluentPremiumType: Scalars['String'];
  fluentStatus: Scalars['String'];
  policyNumber?: Maybe<Scalars['String']>;
  warnings?: Maybe<Array<Warning>>;
};

export type JacketInput = {
  orderId: Scalars['String'];
  premiumType: Scalars['String'];
};

export type JoinNewTransactionInput = {
  fundingTransactionType?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  oPayeeAddress?: InputMaybe<AddressInput>;
  oPayorPayeeId?: InputMaybe<Scalars['String']>;
  payeeAddress?: InputMaybe<AddressInput>;
  payorPayeeId?: InputMaybe<Scalars['String']>;
  refNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusReason?: InputMaybe<Scalars['String']>;
  transactionDate?: InputMaybe<Scalars['String']>;
};

export type JoinTransactionsInput = {
  escrowAccountId: Scalars['String'];
  joinTransactions: Array<JoinTransactionsItemInput>;
  newTransaction?: InputMaybe<JoinNewTransactionInput>;
  orderId: Scalars['String'];
};

export type JoinTransactionsItemInput = {
  transactionId: Scalars['String'];
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type JoinTransactionsResponse = {
  __typename?: 'JoinTransactionsResponse';
  removedTransactions?: Maybe<Array<Maybe<Scalars['String']>>>;
  transaction?: Maybe<Transaction>;
};

export type LegacyBuyerSellerRepInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  representativeCapacity?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type LegacyOrderBuyerSellerInput = {
  entityDateOfAgreement?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  entityStateOfAgreement?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  representatives?: InputMaybe<Array<InputMaybe<LegacyBuyerSellerRepInput>>>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  spouseFirstName?: InputMaybe<Scalars['String']>;
  spouseLastName?: InputMaybe<Scalars['String']>;
  spouseMiddleName?: InputMaybe<Scalars['String']>;
  spouseSuffix?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type LegacyOrderDocumentInput = {
  documentAlias?: InputMaybe<Scalars['String']>;
  documentDate?: InputMaybe<Scalars['String']>;
  documentFileName?: InputMaybe<Scalars['String']>;
  documentPath?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type LegacyOrderDocumentResponse = {
  __typename?: 'LegacyOrderDocumentResponse';
  documentDate?: Maybe<Scalars['String']>;
  documentId: Scalars['ID'];
  documentName?: Maybe<Scalars['String']>;
  presignedURL?: Maybe<Scalars['String']>;
};

export type LegacyOrderNotesInput = {
  note?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type LegacyOrderParcelIdInput = {
  parcelId?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type LegacyOrderPolicyExceptionInput = {
  exception?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type LegacyOrderPropertyInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  briefLegalDescription?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countyName?: InputMaybe<Scalars['String']>;
  fullLegalDescription?: InputMaybe<Scalars['String']>;
  municipalityName?: InputMaybe<Scalars['String']>;
  municipalityType?: InputMaybe<Scalars['String']>;
  parcelIds?: InputMaybe<Array<InputMaybe<LegacyOrderParcelIdInput>>>;
  postalCode?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};

export type LegacyOrderResponse = {
  __typename?: 'LegacyOrderResponse';
  documents?: Maybe<Array<Maybe<LegacyOrderDocumentResponse>>>;
  orderNumber?: Maybe<Scalars['String']>;
};

export type LegacyOrdersInput = {
  buyerNames?: InputMaybe<Array<InputMaybe<LegacyOrderBuyerSellerInput>>>;
  commitmentExceptions?: InputMaybe<Array<InputMaybe<LegacyOrderPolicyExceptionInput>>>;
  commonExceptions?: InputMaybe<Array<InputMaybe<LegacyOrderPolicyExceptionInput>>>;
  companyAddress?: InputMaybe<Scalars['String']>;
  companyAddress1?: InputMaybe<Scalars['String']>;
  companyAddress2?: InputMaybe<Scalars['String']>;
  companyCity?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyState?: InputMaybe<Scalars['String']>;
  companyZip?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<InputMaybe<LegacyOrderDocumentInput>>>;
  fileUniqueId?: InputMaybe<Scalars['String']>;
  lenderPolicyExceptions?: InputMaybe<Array<InputMaybe<LegacyOrderPolicyExceptionInput>>>;
  notes?: InputMaybe<Array<InputMaybe<LegacyOrderNotesInput>>>;
  openDate?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  ownerPolicyExceptions?: InputMaybe<Array<InputMaybe<LegacyOrderPolicyExceptionInput>>>;
  properties?: InputMaybe<Array<InputMaybe<LegacyOrderPropertyInput>>>;
  sellerNames?: InputMaybe<Array<InputMaybe<LegacyOrderBuyerSellerInput>>>;
  settlementDate?: InputMaybe<Scalars['String']>;
  statementType?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Scalars['String']>;
};

export type LenderCreditsFeeAdditionalData = {
  __typename?: 'LenderCreditsFeeAdditionalData';
  additionalDescription?: Maybe<Scalars['String']>;
  lenderCreditsAmount?: Maybe<Scalars['Float']>;
};

export type LenderLanguageOptions = {
  __typename?: 'LenderLanguageOptions';
  FHA?: Maybe<Scalars['String']>;
  MERS?: Maybe<Scalars['String']>;
  OTHER?: Maybe<Scalars['String']>;
  STANDARD?: Maybe<Scalars['String']>;
  SUCCESSOR_OWNERSHIP?: Maybe<Scalars['String']>;
  VA?: Maybe<Scalars['String']>;
};

export type LenderLanguageOptionsInput = {
  FHA?: InputMaybe<Scalars['String']>;
  MERS?: InputMaybe<Scalars['String']>;
  OTHER?: InputMaybe<Scalars['String']>;
  STANDARD?: InputMaybe<Scalars['String']>;
  SUCCESSOR_OWNERSHIP?: InputMaybe<Scalars['String']>;
  VA?: InputMaybe<Scalars['String']>;
};

export type LenderLanguageOptionsOverrideMetadata = {
  __typename?: 'LenderLanguageOptionsOverrideMetadata';
  FHA?: Maybe<OverrideMetadataString>;
  MERS?: Maybe<OverrideMetadataString>;
  OTHER?: Maybe<OverrideMetadataString>;
  STANDARD?: Maybe<OverrideMetadataString>;
  SUCCESSOR_OWNERSHIP?: Maybe<OverrideMetadataString>;
  VA?: Maybe<OverrideMetadataString>;
};

export type LenderLanguageOptionsType = {
  __typename?: 'LenderLanguageOptionsType';
  FHA?: Maybe<Scalars['String']>;
  MERS?: Maybe<Scalars['String']>;
  OTHER?: Maybe<Scalars['String']>;
  STANDARD?: Maybe<Scalars['String']>;
  SUCCESSOR_OWNERSHIP?: Maybe<Scalars['String']>;
  VA?: Maybe<Scalars['String']>;
};

export type License = {
  __typename?: 'License';
  licenseNumber?: Maybe<Scalars['String']>;
  licensedState?: Maybe<Scalars['String']>;
};

export type LicenseInput = {
  licenseNumber?: InputMaybe<Scalars['String']>;
  licensedState?: InputMaybe<Scalars['String']>;
};

export type LineDetail = {
  __typename?: 'LineDetail';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  isUserCreated?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['String']>;
  oAmount?: Maybe<Scalars['Float']>;
  oDescription?: Maybe<Scalars['String']>;
  oLineNumber?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  refMetadata?: Maybe<RefMetaData>;
  transactionId?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type LineTypeMapping = {
  __typename?: 'LineTypeMapping';
  alta?: Maybe<StatementSections>;
  cd?: Maybe<StatementSections>;
  hud1986?: Maybe<StatementSections>;
  hud2010?: Maybe<StatementSections>;
  lineType: Scalars['String'];
};

export type LoanBalloonPaymentQuestion = {
  __typename?: 'LoanBalloonPaymentQuestion';
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentDueDate?: Maybe<Scalars['String']>;
  paymentDueIncrement?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type LoanBalloonPaymentQuestionInput = {
  paymentAmount?: InputMaybe<Scalars['Float']>;
  paymentDueDate?: InputMaybe<Scalars['String']>;
  paymentDueIncrement?: InputMaybe<Scalars['Float']>;
  response?: InputMaybe<Scalars['Boolean']>;
};

export type LoanCalculationsDisclosures = {
  __typename?: 'LoanCalculationsDisclosures';
  amountFinanced?: Maybe<Scalars['Float']>;
  annualPercentageRate?: Maybe<Scalars['Float']>;
  contacts?: Maybe<Array<Maybe<LoanCalculationsDisclosuresContact>>>;
  financeCharge?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  liabilityAfterForeclosure?: Maybe<Scalars['String']>;
  receiptConfirmed?: Maybe<Scalars['Boolean']>;
  totalInterestPercentage?: Maybe<Scalars['Float']>;
  totalOfPayments?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type LoanCalculationsDisclosuresContact = {
  __typename?: 'LoanCalculationsDisclosuresContact';
  address1?: Maybe<Scalars['String']>;
  cityStatePostalCode?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  contactEmailAddress?: Maybe<Scalars['String']>;
  contactLicenseNumber?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactNmlsId?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  contactType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  licenseNumber?: Maybe<Scalars['String']>;
  nmlsId?: Maybe<Scalars['String']>;
};

export type LoanCalculationsDisclosuresContactInput = {
  address1?: InputMaybe<Scalars['String']>;
  cityStatePostalCode?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contactEmailAddress?: InputMaybe<Scalars['String']>;
  contactLicenseNumber?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactNmlsId?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  contactType?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  licenseNumber?: InputMaybe<Scalars['String']>;
  nmlsId?: InputMaybe<Scalars['String']>;
};

export type LoanCalculationsDisclosuresInput = {
  amountFinanced?: InputMaybe<Scalars['Float']>;
  annualPercentageRate?: InputMaybe<Scalars['Float']>;
  contacts?: InputMaybe<Array<InputMaybe<LoanCalculationsDisclosuresContactInput>>>;
  financeCharge?: InputMaybe<Scalars['Float']>;
  liabilityAfterForeclosure?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  receiptConfirmed?: InputMaybe<Scalars['Boolean']>;
  totalInterestPercentage?: InputMaybe<Scalars['Float']>;
  totalOfPayments?: InputMaybe<Scalars['Float']>;
  updatedTimestamp: Scalars['String'];
};

export type LoanDisclosures = {
  __typename?: 'LoanDisclosures';
  adjustableInterestRateTable?: Maybe<AdjustableInterestRateTable>;
  adjustablePaymentsTable?: Maybe<AdjustablePaymentsTable>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  escrowAccount?: Maybe<Scalars['String']>;
  escrowWaiverFee?: Maybe<Scalars['Float']>;
  escrowWaiverFeeDescription?: Maybe<Scalars['String']>;
  escrowedCostsFirstYear?: Maybe<Scalars['Float']>;
  escrowedCostsFirstYearOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  escrowedCostsListing?: Maybe<Scalars['String']>;
  escrowedCostsListingOverrideMetadata?: Maybe<OverrideMetadataString>;
  estimatedCostsOverFirstYear?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  initialEscrowPayment?: Maybe<Scalars['Float']>;
  initialEscrowPaymentOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  latePaymentDays?: Maybe<Scalars['Int']>;
  latePaymentFeeDescription?: Maybe<Scalars['String']>;
  loanAssumptionPermitted?: Maybe<Scalars['String']>;
  loanHasDemandFeature?: Maybe<Scalars['String']>;
  monthlyEscrowAmount?: Maybe<Scalars['Float']>;
  monthlyEscrowAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  negativeAmortization?: Maybe<Scalars['String']>;
  nonEscrowedCostFirstYear?: Maybe<Scalars['Float']>;
  nonEscrowedCostsListing?: Maybe<Scalars['String']>;
  nonEscrowedCostsListingOverrideMetadata?: Maybe<OverrideMetadataString>;
  orderId?: Maybe<Scalars['ID']>;
  partialPayments?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type LoanDiscountFeeAdditionalData = {
  __typename?: 'LoanDiscountFeeAdditionalData';
  originationAdjustmentPercentage?: Maybe<Scalars['Float']>;
};

export type LoanOriginationFeeAdditionalData = {
  __typename?: 'LoanOriginationFeeAdditionalData';
  originationPercentage?: Maybe<Scalars['Float']>;
};

export type LoanPrepaymentPenaltyQuestion = {
  __typename?: 'LoanPrepaymentPenaltyQuestion';
  penaltyAsHighAsAmount?: Maybe<Scalars['Float']>;
  penaltyDuringFirstIncrement?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type LoanPrepaymentPenaltyQuestionInput = {
  penaltyAsHighAsAmount?: InputMaybe<Scalars['Float']>;
  penaltyDuringFirstIncrement?: InputMaybe<Scalars['Float']>;
  response?: InputMaybe<Scalars['Boolean']>;
};

export type LoginInfoItem = {
  __typename?: 'LoginInfoItem';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  dateInvited: Scalars['String'];
  forceLogout: Scalars['Boolean'];
  lastActivityDate: Scalars['String'];
  lastLoginDate: Scalars['String'];
  passwordChangedDate: Scalars['String'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  userStatus: Scalars['String'];
};

export type MasterOrder = {
  __typename?: 'MasterOrder';
  id: Scalars['ID'];
  orderId: Scalars['ID'];
  orderNumber: Scalars['String'];
  propertyState?: Maybe<Scalars['String']>;
  statementType?: Maybe<Scalars['String']>;
  transactionType: TransactionType;
  underwriter?: Maybe<Underwriter>;
  underwriterId?: Maybe<Scalars['String']>;
};

export type MasterOrderResponseObject = {
  __typename?: 'MasterOrderResponseObject';
  masterOrders: Array<MasterOrder>;
};

export type MdLandInstrumentSheet = {
  __typename?: 'MdLandInstrumentSheet';
  block?: Maybe<Scalars['String']>;
  buyerAddress?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  containsMortgage?: Maybe<Scalars['Boolean']>;
  containsPurchase?: Maybe<Scalars['Boolean']>;
  countyTransferTax?: Maybe<Scalars['Float']>;
  existingMortgageBalance?: Maybe<Scalars['Float']>;
  instrumentSubmittedByAddress?: Maybe<Scalars['String']>;
  instrumentSubmittedByFirm?: Maybe<Scalars['String']>;
  instrumentSubmittedByName?: Maybe<Scalars['String']>;
  instrumentSubmittedByPhone?: Maybe<Scalars['String']>;
  interestInLand?: Maybe<Scalars['String']>;
  lenderName?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['Float']>;
  lot?: Maybe<Scalars['String']>;
  mapNumber?: Maybe<Scalars['String']>;
  notContainsCash?: Maybe<Scalars['Boolean']>;
  plat?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyDistrict?: Maybe<Scalars['String']>;
  propertyParcelNumber?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  recordingChargeOne?: Maybe<Scalars['Float']>;
  recordingChargeTwo?: Maybe<Scalars['Float']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellerNames?: Maybe<Scalars['String']>;
  stateRecordationTax?: Maybe<Scalars['Float']>;
  stateTransferTax?: Maybe<Scalars['Float']>;
  subDivision?: Maybe<Scalars['String']>;
  surchargeOne?: Maybe<Scalars['Float']>;
  surchargeTwo?: Maybe<Scalars['Float']>;
};

export type MdMw506aeForm = {
  __typename?: 'MdMw506aeForm';
  legalDescriptionBrief?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyCityStateZip?: Maybe<Scalars['String']>;
  propertyCounty?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<MdMw506aeFormSellers>>>;
  settlementAgentAddress?: Maybe<MdMw506aeFormAddress>;
  settlementAgentEmailAddress?: Maybe<Scalars['String']>;
  settlementAgentFaxNumber?: Maybe<Scalars['String']>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type MdMw506aeFormAddress = {
  __typename?: 'MdMw506aeFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MdMw506aeFormSellers = {
  __typename?: 'MdMw506aeFormSellers';
  address?: Maybe<MdMw506aeFormAddress>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  sellerType?: Maybe<Scalars['String']>;
  spouse?: Maybe<MdMw506aeFormSpouse>;
  taxIDNumber?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type MdMw506aeFormSpouse = {
  __typename?: 'MdMw506aeFormSpouse';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  taxIDNumber?: Maybe<Scalars['String']>;
};

export type MdMw506nrsForm = {
  __typename?: 'MdMw506nrsForm';
  closingCostsAmount?: Maybe<Scalars['Float']>;
  legalDescriptionBrief?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  netSalesPrice?: Maybe<Scalars['Float']>;
  payoffsAmount?: Maybe<Scalars['Float']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyCityStateZip?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<MdMw506nrsFormSellers>>>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  totalWithholdingBasis?: Maybe<Scalars['Float']>;
};

export type MdMw506nrsFormSellers = {
  __typename?: 'MdMw506nrsFormSellers';
  address?: Maybe<Scalars['String']>;
  addressCityStateZip?: Maybe<Scalars['String']>;
  allFullNames?: Maybe<Scalars['String']>;
  dueAmount?: Maybe<Scalars['Float']>;
  entityName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['String']>;
  sellerType?: Maybe<Scalars['String']>;
  spouseTaxIDNumber?: Maybe<Scalars['String']>;
  taxIDNumber?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
  withholdingBasis?: Maybe<Scalars['Float']>;
};

export type MdMw506rForm = {
  __typename?: 'MdMw506rForm';
  legalDescriptionBrief?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyCityStateZip?: Maybe<Scalars['String']>;
  propertyCounty?: Maybe<Scalars['String']>;
  sellers?: Maybe<Array<Maybe<MdMw506rFormSellers>>>;
  settlementAgentAddress?: Maybe<Scalars['String']>;
  settlementAgentEmailAddress?: Maybe<Scalars['String']>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type MdMw506rFormAddress = {
  __typename?: 'MdMw506rFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MdMw506rFormSellers = {
  __typename?: 'MdMw506rFormSellers';
  address?: Maybe<MdMw506rFormAddress>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  sellerType?: Maybe<Scalars['String']>;
  spouse?: Maybe<MdMw506rFormSpouse>;
  taxIDNumber?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type MdMw506rFormSpouse = {
  __typename?: 'MdMw506rFormSpouse';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  taxIDNumber?: Maybe<Scalars['String']>;
};

export type MeRettdTaxForm = {
  __typename?: 'MeRettdTaxForm';
  acreage?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  buyer?: Maybe<MeRettdTaxFormBuyerSeller>;
  county?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  map?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  physicalLocation?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  seller?: Maybe<MeRettdTaxFormBuyerSeller>;
  settlementAgent?: Maybe<MeRettdTaxFormSettlementAgent>;
  settlementDate?: Maybe<Scalars['String']>;
  staffName?: Maybe<Scalars['String']>;
};

export type MeRettdTaxFormAddres = {
  __typename?: 'MeRettdTaxFormAddres';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MeRettdTaxFormBuyerSeller = {
  __typename?: 'MeRettdTaxFormBuyerSeller';
  address?: Maybe<MeRettdTaxFormAddres>;
  name?: Maybe<Scalars['String']>;
  spouse?: Maybe<MeRettdTaxFormSpouse>;
  taxId?: Maybe<Scalars['String']>;
};

export type MeRettdTaxFormSettlementAgent = {
  __typename?: 'MeRettdTaxFormSettlementAgent';
  address?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type MeRettdTaxFormSpouse = {
  __typename?: 'MeRettdTaxFormSpouse';
  name?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

export type MeRew1040SellersIndivForm = {
  __typename?: 'MeRew1040SellersIndivForm';
  buyer?: Maybe<MeRew1040SellersIndivFormBuyer>;
  municipality?: Maybe<Scalars['String']>;
  propertyStreet?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<MeRew1040SellersIndivFormSeller>>>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type MeRew1040SellersIndivFormAddress = {
  __typename?: 'MeRew1040SellersIndivFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MeRew1040SellersIndivFormBuyer = {
  __typename?: 'MeRew1040SellersIndivFormBuyer';
  address?: Maybe<MeRew1040SellersIndivFormAddress>;
  fullName?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
};

export type MeRew1040SellersIndivFormSeller = {
  __typename?: 'MeRew1040SellersIndivFormSeller';
  address?: Maybe<MeRew1040SellersIndivFormAddress>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  spouse?: Maybe<MeRew1040SellersIndivFormSpouse>;
  taxIdNumber?: Maybe<Scalars['String']>;
  withheldAmount?: Maybe<Scalars['Float']>;
};

export type MeRew1040SellersIndivFormSpouse = {
  __typename?: 'MeRew1040SellersIndivFormSpouse';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
};

export type MeRew1041SellersEstateForm = {
  __typename?: 'MeRew1041SellersEstateForm';
  buyer?: Maybe<MeRew1041SellersEstateFormBuyer>;
  municipality?: Maybe<Scalars['String']>;
  propertyStreet?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<MeRew1041SellersEstateFormSeller>>>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type MeRew1041SellersEstateFormAddress = {
  __typename?: 'MeRew1041SellersEstateFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MeRew1041SellersEstateFormBuyer = {
  __typename?: 'MeRew1041SellersEstateFormBuyer';
  address?: Maybe<MeRew1041SellersEstateFormAddress>;
  fullName?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
};

export type MeRew1041SellersEstateFormSeller = {
  __typename?: 'MeRew1041SellersEstateFormSeller';
  address?: Maybe<MeRew1041SellersEstateFormAddress>;
  entityName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  repName?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
  withheldAmount?: Maybe<Scalars['String']>;
};

export type MeRew1120CorporateSellersForm = {
  __typename?: 'MeRew1120CorporateSellersForm';
  buyer?: Maybe<MeRew1120CorporateSellersFormBuyer>;
  municipality?: Maybe<Scalars['String']>;
  propertyStreet?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<MeRew1120CorporateSellersFormSeller>>>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type MeRew1120CorporateSellersFormAddress = {
  __typename?: 'MeRew1120CorporateSellersFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MeRew1120CorporateSellersFormBuyer = {
  __typename?: 'MeRew1120CorporateSellersFormBuyer';
  address?: Maybe<MeRew1120CorporateSellersFormAddress>;
  fullName?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
};

export type MeRew1120CorporateSellersFormSeller = {
  __typename?: 'MeRew1120CorporateSellersFormSeller';
  address?: Maybe<MeRew1120CorporateSellersFormAddress>;
  entityName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  withheldAmount?: Maybe<Scalars['Float']>;
};

export type MergeData = {
  __typename?: 'MergeData';
  altaStatement?: Maybe<AltaStatement>;
  buyerAltaStatement?: Maybe<AltaStatement>;
  buyerCdStatement?: Maybe<CdStatement>;
  buyerHud1986Statement?: Maybe<Hud1986Statement>;
  buyerHud2010Statement?: Maybe<Hud2010Statement>;
  cashAltaStatement?: Maybe<AltaStatement>;
  cdStatement?: Maybe<CdStatement>;
  checkDetails?: Maybe<CheckPrintingData>;
  dcFp7cTaxForm?: Maybe<DcFp7cTaxForm>;
  disbursementSummaryForm?: Maybe<DisbursementSummaryForm>;
  hud1986Statement?: Maybe<Hud1986Statement>;
  hud2010Statement?: Maybe<Hud2010Statement>;
  id: Scalars['ID'];
  mdLandInstrumentSheet?: Maybe<MdLandInstrumentSheet>;
  md_mw506aeForm?: Maybe<MdMw506aeForm>;
  md_mw506nrsForm?: Maybe<MdMw506nrsForm>;
  md_mw506rForm?: Maybe<MdMw506rForm>;
  me_rettd_taxForm?: Maybe<MeRettdTaxForm>;
  me_rew1040_sellersIndivForm?: Maybe<MeRew1040SellersIndivForm>;
  me_rew1041_sellersEstateForm?: Maybe<MeRew1041SellersEstateForm>;
  me_rew1120_corporateSellersForm?: Maybe<MeRew1120CorporateSellersForm>;
  nhInventoryPropertyTaxForm?: Maybe<NhInventoryPropertyTaxForm>;
  nhRealEstatePurchaserTaxForm?: Maybe<NhRealEstatePurchaserTaxForm>;
  nhRealEstateSellerTaxForm?: Maybe<NhRealEstateSellerTaxForm>;
  noSellerCdStatement?: Maybe<CdStatement>;
  noSellerHud1986Statement?: Maybe<Hud1986Statement>;
  noSellerHud2010Statement?: Maybe<Hud2010Statement>;
  order?: Maybe<Order>;
  payoffs?: Maybe<Array<Maybe<Payoff>>>;
  prorations?: Maybe<Array<Maybe<ProrationCharge>>>;
  recordingFeeTransferTax?: Maybe<RecordingFeeTransferTax>;
  sellerAltaStatement?: Maybe<AltaStatement>;
  sellerCdStatement?: Maybe<CdStatement>;
  sellerHud1986Statement?: Maybe<Hud1986Statement>;
  sellerHud2010Statement?: Maybe<Hud2010Statement>;
  system?: Maybe<System>;
  ten99Form?: Maybe<Ten99Form>;
  title?: Maybe<TitleFields>;
  titleCpls?: Maybe<Array<Maybe<TitleCpl>>>;
  titleExceptions?: Maybe<TitleExceptions>;
  titleFees?: Maybe<TitleFees>;
  titleGeneral?: Maybe<TitleGeneral>;
  titlePremiums?: Maybe<TitlePremiums>;
  titleRequirements?: Maybe<TitleRequirements>;
  va2012R5PForm?: Maybe<Va2012R5PForm>;
};


export type MergeDataCheckDetailsArgs = {
  transactionId: Scalars['ID'];
};

export type MergeField = {
  __typename?: 'MergeField';
  category?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  dataType?: Maybe<Scalars['String']>;
  defaultFormat?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  mergeFieldId?: Maybe<Scalars['String']>;
  mergeKey?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['ID']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type MergeFieldDataV2 = {
  __typename?: 'MergeFieldDataV2';
  category?: Maybe<Scalars['String']>;
  dataType: Scalars['String'];
  defaultFormat: Scalars['String'];
  domain: Scalars['String'];
  label: Scalars['String'];
  mergeFieldId: Scalars['ID'];
  mergeKey: Scalars['String'];
};

export type MergeFieldsResponse = {
  __typename?: 'MergeFieldsResponse';
  mergeFields?: Maybe<Array<Maybe<MergeField>>>;
};

export type Milestone = {
  __typename?: 'Milestone';
  createdBy?: Maybe<User>;
  createdById: Scalars['ID'];
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sortIndex: Scalars['Int'];
  tasks?: Maybe<Array<Maybe<Task>>>;
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['ID'];
};

export type MortgageInsurancePremiumEscrowFeeAdditionalData = {
  __typename?: 'MortgageInsurancePremiumEscrowFeeAdditionalData';
  amountPerMonth?: Maybe<Scalars['Float']>;
  amountPerMonthOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type MortgageInsurancePremiumFeeAdditionalData = {
  __typename?: 'MortgageInsurancePremiumFeeAdditionalData';
  monthlyMIP?: Maybe<Scalars['Float']>;
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type MortgageRecital = {
  __typename?: 'MortgageRecital';
  bodyContent?: Maybe<Scalars['String']>;
  bodyTemplate: Scalars['String'];
  mergeFields?: Maybe<Scalars['String']>;
  requirementMergeable?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type MoveAdminTaskInput = {
  destinationMilestoneId?: InputMaybe<Scalars['String']>;
  destinationSortOrder?: InputMaybe<Scalars['Int']>;
};

export type MoveOrderTaskInput = {
  destinationMilestoneId?: InputMaybe<Scalars['String']>;
  destinationSortOrder?: InputMaybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']>;
  addBuyer?: Maybe<OrderPayload>;
  addNote: Note;
  /** @deprecated Use createOrderParty instead */
  addPartyToOrder?: Maybe<AddPartyToOrderResult>;
  addSeller?: Maybe<OrderPayload>;
  addSequence?: Maybe<Sequence>;
  addUserRecentOrder: AddUserRecentOrderPayload;
  calculateCplRates: CalculateCplRateResponse;
  calculatePremiumRate: PremiumRateCalculationResponse;
  changeOrderWorkflow: Workflow;
  clearDcAdjustment: AdjustmentResponseWithMirror;
  clearFee?: Maybe<Fee>;
  clearTransactions?: Maybe<ClearTransactionsResponse>;
  cloneAdminTask: AdminTask;
  cloneAdminWorkflow: AdminWorkflow;
  cloneOrder?: Maybe<OrderPayload>;
  cloneOrderAsynchronous?: Maybe<OrderCloneResponse>;
  combineDocumentsAsync?: Maybe<CombineDocumentsAsyncResponse>;
  combineDocumentsAsyncV2: GenerateAsyncResponseV2;
  convertTemplatesToDocuments?: Maybe<ConvertTemplatesToDocumentsResponse>;
  createAdminMilestone: CreateAdminMilestoneResponse;
  createAdminTask: AdminTask;
  createAdminWorkflow: CreateAdminWorkflowResponse;
  createChangePasswordUserEvent: LoginInfoItem;
  createClausePackage: ClausePackage;
  createClauseTemplate: ClauseTemplate;
  createDcAdjustment: AdjustmentResponseWithMirror;
  createDepartment: Department;
  createDirectoryCompany?: Maybe<Company>;
  createDirectoryContact?: Maybe<Contact>;
  createDocument?: Maybe<Document>;
  createDocumentV2: OrderDocumentV2;
  createEscrowAccount?: Maybe<EscrowAccount>;
  createExceptions?: Maybe<Array<Maybe<TitleException>>>;
  createFee?: Maybe<Fee>;
  createFromMasterOrder?: Maybe<CreateOrderFromMasterPayload>;
  createFund?: Maybe<Fund>;
  createJacket: Jacket;
  createOrder?: Maybe<CreateOrderPayload>;
  createOrderMilestone: Milestone;
  createOrderParty?: Maybe<OrderParty>;
  createOrderTask: Task;
  createOrderWorkflowFromAdminWorkflow: Workflow;
  createPayoff: Payoff;
  createPositivePaySubmission?: Maybe<PositivePayFile>;
  createProrationCharge: ProrationCharge;
  createReconciliation?: Maybe<Reconciliation>;
  createRequirements?: Maybe<Array<Maybe<Requirement>>>;
  createSecurityGroup?: Maybe<SecurityGroup>;
  createStateWithholding?: Maybe<StateWithholding>;
  createTemplate?: Maybe<Document>;
  createTemplateV2: TemplateDocV2;
  createTenant?: Maybe<Tenant>;
  createTenantChild?: Maybe<TenantChildNode>;
  createTenantUnderwriter: CreateTenantUnderwriterResponse;
  createTransaction?: Maybe<Transaction>;
  createTransactionLineDetail?: Maybe<LineDetail>;
  createUser: User;
  deactivateAgentNet: AdminCredentialAgentNetStatus;
  deleteAdminMilestone: DeleteAdminMilestoneResponse;
  deleteAdminTask: DeleteAdminTaskResponse;
  deleteAdminWorkflow: AdminWorkflow;
  deleteBuyer: Array<Buyer>;
  deleteBuyerRep?: Maybe<DeleteBuyerRepResponse>;
  deleteBuyerV2: DeleteBuyerResponse;
  deleteClausePackage: ClausePackage;
  deleteClauseTemplate: ClauseTemplate;
  deleteDcAdjustment: AdjustmentResponseWithMirror;
  deleteDepartment: DeleteDepartmentResponse;
  deleteDocument?: Maybe<Document>;
  deleteDocumentV2: OrderDocumentV2;
  deleteEscrowAccount?: Maybe<EscrowAccount>;
  deleteException?: Maybe<Scalars['Boolean']>;
  deleteFee?: Maybe<Fee>;
  deleteFund?: Maybe<Fund>;
  deleteNote: Note;
  deleteOrderMilestone: Milestone;
  deleteOrderParty: DeleteOrderPartyResponse;
  deleteOrderTask: DeleteTaskResponse;
  deletePayoff: Payoff;
  deleteProrationCharge: ProrationCharge;
  deleteReconciliation?: Maybe<Scalars['Boolean']>;
  deleteRecordingFeeTransferTaxCalc: RecordingFeeTransferTaxCalc;
  deleteRequirement?: Maybe<Scalars['Boolean']>;
  deleteSecurityGroup: SecurityGroup;
  deleteSeller: DeleteSellerResponse;
  deleteSellerRep?: Maybe<DeleteSellerRepResponse>;
  deleteSequence?: Maybe<Sequence>;
  deleteStateWithholding?: Maybe<StateWithholding>;
  deleteTemplate?: Maybe<Document>;
  deleteTemplateV2: TemplateDocV2;
  deleteTransaction?: Maybe<Transaction>;
  deleteTransactionLineDetail?: Maybe<LineDetail>;
  deleteUserLocks: User;
  documentSaveAsAsync?: Maybe<DocumentSaveAsAsyncResponse>;
  documentSaveAsAsyncV2: GenerateAsyncResponseV2;
  downloadDocumentsAsync?: Maybe<DownloadDocumentsAsyncResponse>;
  downloadDocumentsAsyncV2: GenerateAsyncResponseV2;
  downloadTemplates?: Maybe<DownloadResponse>;
  duplicateTemplate?: Maybe<Document>;
  duplicateTemplateV2: TemplateDocV2;
  finalizeReconciliation?: Maybe<Reconciliation>;
  importRepositoryTemplateV2: ImportRepositoryTemplateResponseV2;
  importRepositoryTemplates: ImportRepositoryTemplateResponse;
  inviteUser: LoginInfoItem;
  joinTransactions?: Maybe<JoinTransactionsResponse>;
  legacyOrdersPost?: Maybe<Array<Maybe<LegacyOrderResponse>>>;
  moveAdminTask: AdminTask;
  moveOrderTask: Task;
  orderTitleCplProduct: TitleCpls;
  orderTitleCplProductV2: TitleCpls;
  patchBuyerSpouse?: Maybe<OrderBuyerSellerSoRep>;
  patchBuyers?: Maybe<Array<Maybe<Buyer>>>;
  patchCalculatingCashToClose: CalculatingCashToClose;
  patchSellerSpouse?: Maybe<OrderBuyerSellerSoRep>;
  patchSellerSpouseV2: PatchSellerSpouseResponse;
  patchSellers?: Maybe<Array<Maybe<Seller>>>;
  postAutoClear?: Maybe<PostAutoClearResponse>;
  printChecks?: Maybe<PrintChecksResult>;
  printChecksFast?: Maybe<PrintChecksResult>;
  printChecksV2: PrintChecksResponseV2;
  printDocumentsAsync?: Maybe<PrintDocumentsAsyncResponse>;
  printDocumentsAsyncV2: GenerateAsyncResponseV2;
  printTestChecks?: Maybe<PrintChecksResultTest>;
  putDocumentFromKnownTemplate: Document;
  putDocumentFromKnownTemplateV2: OrderDocumentV2;
  putIntegratedRecordingFeeTransferTax: RecordingFeeTransferTaxCalc;
  putOrderCommissions: OrderCommissionsV2;
  putOrderDeposits: OrderDeposits;
  putProjectedPayments: ProjectedPayments;
  putRecordingFeeTransferTax: RecordingFeeTransferTaxCalc;
  putTenantChildImage?: Maybe<TenantChildImage>;
  refreshCommissions?: Maybe<Array<Fee>>;
  refreshDepositsForAdjustments: GetAdjustmentsResponse;
  refreshDepositsForFees?: Maybe<Array<Fee>>;
  refreshPremiumsAndFees?: Maybe<Array<Fee>>;
  /** @deprecated Use updateOrderParty instead */
  replacePartyCompanyAndContact?: Maybe<ReplacePartyCompanyAndContactResult>;
  reprintChecks?: Maybe<PrintChecksResult>;
  sendEmail: SendEmailItem;
  setAgentNetAdminCredentials: AdminCredentialAgentNetStatus;
  setAgentNetAdminOffices: AgentNetAdminSetOfficesResponse;
  setAgentNetUserCredentials: UserCredentialAgentNetStatus;
  splitTransaction?: Maybe<SplitTransactionDetailsResponse>;
  switchRecordingFeeTransferTaxCalculator: RecordingFeeTransferTaxCalc;
  synchronizeGfeCharges: Array<GfeCharge>;
  toggleTen99: ToggleTen99Response;
  transferTransactionDetails?: Maybe<TransferTransactionDetailsResponse>;
  updateAdminMilestone: UpdateAdminMilestoneResponse;
  updateAdminTask: UpdateAdminTaskResponse;
  updateAdminWorkflow: UpdateAdminWorkflowResponse;
  updateClausePackage: ClausePackage;
  updateClauseTemplate: ClauseTemplate;
  updateClosingInformation: ClosingInformation;
  updateClosingQuestions: ClosingQuestions;
  updateDcAdjustment: AdjustmentResponseWithMirror;
  updateDepartment: Department;
  updateDirectoryCompany?: Maybe<Company>;
  updateDirectoryContact?: Maybe<Contact>;
  updateDocumentV2: OrderDocumentV2;
  updateDocuments?: Maybe<Array<Maybe<Document>>>;
  updateDocumentsV2: Array<Maybe<OrderDocumentV2>>;
  updateEscrowAccount?: Maybe<EscrowAccount>;
  updateEstimatedTaxesInsuranceAssessments: EstimatedTaxesInsuranceAssessments;
  updateException: TitleException;
  updateExceptions?: Maybe<Array<Maybe<TitleException>>>;
  updateExceptionsHeader: TitleExceptions;
  updateFee?: Maybe<Fee>;
  updateFund?: Maybe<Fund>;
  updateFundingForFees: Array<Fee>;
  updateGfeCharge: GfeCharge;
  updateGfeCharges: Array<GfeCharge>;
  updateIsSetAsCDLastLine?: Maybe<Fee>;
  updateLoanCalculationsDisclosures: LoanCalculationsDisclosures;
  updateLoanDisclosures: LoanDisclosures;
  updateNote: Note;
  updateNotifications?: Maybe<Array<Maybe<Notification>>>;
  updateOrder?: Maybe<OrderPayload>;
  updateOrderBuyerSellerRepresentativeById?: Maybe<OrderBuyerSellerSoRepPayload>;
  updateOrderMilestone: Milestone;
  updateOrderParty?: Maybe<OrderParty>;
  /** @deprecated Use updateOrderParty instead */
  updateOrderPartyById?: Maybe<OrderPartyPayLoad>;
  updateOrderTask: UpdateOrderTaskResponse;
  updatePayoffs: WrappedPayoff;
  updatePolicyMetadata?: Maybe<PolicyMetadata>;
  updateProrationCharge: ProrationCharge;
  updateReconciliation?: Maybe<Reconciliation>;
  updateRequirement?: Maybe<Requirement>;
  updateRequirements?: Maybe<Array<Maybe<Requirement>>>;
  updateRequirementsHeader?: Maybe<TitleRequirements>;
  updateSecurityGroup: SecurityGroup;
  updateSequence?: Maybe<Sequence>;
  updateStaffRole: StaffRole;
  updateStateWithholding?: Maybe<StateWithholding>;
  updateTemplate?: Maybe<Document>;
  updateTemplateV2: TemplateDocV2;
  updateTen99: UpdateTen99Response;
  updateTenant?: Maybe<Tenant>;
  updateTenantChild?: Maybe<TenantChildNode>;
  updateTenantProfileImage?: Maybe<TenantProfileImage>;
  updateTenantUnderwriter: UpdateTenantUnderwriterResponse;
  updateTitleCpls: TitleCpls;
  updateTitleFees?: Maybe<TitleFees>;
  updateTitleGeneral: TitleGeneral;
  updateTitlePremium: TitlePremium;
  updateTransaction?: Maybe<Array<Maybe<Transaction>>>;
  updateTransactionLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  updateTransactions?: Maybe<Array<Maybe<Transaction>>>;
  updateUser: User;
  updateUserSignatureImage: UserSignatureImage;
  updateUserStatus: User;
  upsertBuyerSellerSplit?: Maybe<BuyerSellerSplit>;
  validateRate?: Maybe<ValidateRate>;
  validateSdn: ValidateSdnResponse;
  voidJacket: Jacket;
  voidTitleCpl: TitleCpls;
  wireTransactions?: Maybe<Array<Maybe<Transaction>>>;
};


export type MutationAddBuyerArgs = {
  input?: InputMaybe<AddBuyerInput>;
};


export type MutationAddNoteArgs = {
  input: AddNoteInput;
};


export type MutationAddPartyToOrderArgs = {
  orderId: Scalars['ID'];
  payload: AddPartyToOrderPayload;
};


export type MutationAddSellerArgs = {
  input?: InputMaybe<AddSellerInput>;
};


export type MutationAddSequenceArgs = {
  input: AddSequenceInput;
};


export type MutationAddUserRecentOrderArgs = {
  input: AddUserRecentOrderInput;
};


export type MutationCalculateCplRatesArgs = {
  input: CalculateCplRateRequest;
  orderId: Scalars['ID'];
};


export type MutationCalculatePremiumRateArgs = {
  input: CalculatePremiumRateRequest;
  orderId: Scalars['ID'];
};


export type MutationChangeOrderWorkflowArgs = {
  adminWorkflowId: Scalars['ID'];
  orderId: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
  workflowId: Scalars['ID'];
};


export type MutationClearDcAdjustmentArgs = {
  input: ClearDcAdjustmentInput;
};


export type MutationClearFeeArgs = {
  input?: InputMaybe<ClearFeeInput>;
};


export type MutationClearTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  input?: InputMaybe<ClearTransactionsInput>;
};


export type MutationCloneAdminTaskArgs = {
  milestoneId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationCloneAdminWorkflowArgs = {
  source: Scalars['ID'];
};


export type MutationCloneOrderArgs = {
  orderId: Scalars['ID'];
};


export type MutationCloneOrderAsynchronousArgs = {
  orderId: Scalars['ID'];
};


export type MutationCombineDocumentsAsyncArgs = {
  documentIds: Array<Scalars['ID']>;
  name: Scalars['String'];
  orderId: Scalars['String'];
};


export type MutationCombineDocumentsAsyncV2Args = {
  input: CombineDocumentsRequestV2Input;
};


export type MutationConvertTemplatesToDocumentsArgs = {
  input?: InputMaybe<ConvertTemplatesToDocumentsInput>;
};


export type MutationCreateAdminMilestoneArgs = {
  input: AdminMilestoneInput;
  workflowId: Scalars['ID'];
};


export type MutationCreateAdminTaskArgs = {
  input: AdminTaskInput;
  milestoneId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationCreateAdminWorkflowArgs = {
  input: AdminWorkflowInput;
};


export type MutationCreateChangePasswordUserEventArgs = {
  input?: InputMaybe<CreateChangePasswordUserEventInput>;
};


export type MutationCreateClausePackageArgs = {
  input?: InputMaybe<ClausePackageInput>;
};


export type MutationCreateClauseTemplateArgs = {
  input?: InputMaybe<ClauseTemplateInput>;
};


export type MutationCreateDcAdjustmentArgs = {
  input: CreateDcAdjustmentInput;
};


export type MutationCreateDepartmentArgs = {
  input: DepartmentInput;
};


export type MutationCreateDirectoryCompanyArgs = {
  input?: InputMaybe<CreateDirectoryCompanyInput>;
};


export type MutationCreateDirectoryContactArgs = {
  directoryCompanyId: Scalars['String'];
  input?: InputMaybe<CreateDirectoryContactInput>;
};


export type MutationCreateDocumentArgs = {
  input?: InputMaybe<CreateDocumentInput>;
};


export type MutationCreateDocumentV2Args = {
  input: CreateOrderDocumentV2Input;
};


export type MutationCreateEscrowAccountArgs = {
  input?: InputMaybe<CreateEscrowAccountInput>;
};


export type MutationCreateExceptionsArgs = {
  input?: InputMaybe<CreateExceptionsInput>;
};


export type MutationCreateFeeArgs = {
  input?: InputMaybe<CreateFeeInput>;
};


export type MutationCreateFromMasterOrderArgs = {
  input?: InputMaybe<CreateOrderInput>;
};


export type MutationCreateFundArgs = {
  input?: InputMaybe<CreateFundInput>;
};


export type MutationCreateJacketArgs = {
  jacketInput: JacketInput;
};


export type MutationCreateOrderArgs = {
  input?: InputMaybe<CreateOrderInput>;
};


export type MutationCreateOrderMilestoneArgs = {
  orderId: Scalars['ID'];
  payload: CreateOrderMilestoneInput;
};


export type MutationCreateOrderPartyArgs = {
  input?: InputMaybe<CreateOrderPartyInput>;
  orderId: Scalars['ID'];
};


export type MutationCreateOrderTaskArgs = {
  input: OrderTaskInput;
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationCreateOrderWorkflowFromAdminWorkflowArgs = {
  adminWorkflowId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationCreatePayoffArgs = {
  orderId: Scalars['String'];
};


export type MutationCreatePositivePaySubmissionArgs = {
  escrowAccountId: Scalars['ID'];
};


export type MutationCreateProrationChargeArgs = {
  orderId: Scalars['String'];
  prorationChargeInput: CreateProrationCharge;
};


export type MutationCreateReconciliationArgs = {
  input?: InputMaybe<CreateReconciliationInput>;
};


export type MutationCreateRequirementsArgs = {
  input?: InputMaybe<CreateRequirementsInput>;
};


export type MutationCreateSecurityGroupArgs = {
  input?: InputMaybe<CreateSecurityGroupInput>;
};


export type MutationCreateStateWithholdingArgs = {
  input: CreateStateWithholdingInput;
};


export type MutationCreateTemplateArgs = {
  input?: InputMaybe<CreateTemplateInput>;
  orgId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateTemplateV2Args = {
  input: CreateTemplateDocV2Input;
};


export type MutationCreateTenantArgs = {
  input?: InputMaybe<CreateTenantInput>;
};


export type MutationCreateTenantChildArgs = {
  input?: InputMaybe<CreateTenantChildInput>;
};


export type MutationCreateTenantUnderwriterArgs = {
  input?: InputMaybe<TenantUnderwriterInput>;
};


export type MutationCreateTransactionArgs = {
  input?: InputMaybe<CreateTransactionInput>;
};


export type MutationCreateTransactionLineDetailArgs = {
  input?: InputMaybe<CreateLineDetailInput>;
};


export type MutationCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type MutationDeleteAdminMilestoneArgs = {
  milestoneId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationDeleteAdminTaskArgs = {
  milestoneId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationDeleteAdminWorkflowArgs = {
  workflowId: Scalars['ID'];
};


export type MutationDeleteBuyerArgs = {
  buyerId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationDeleteBuyerRepArgs = {
  buyerId: Scalars['ID'];
  buyerRepId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationDeleteBuyerV2Args = {
  buyerId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationDeleteClausePackageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClauseTemplateArgs = {
  clauseId: Scalars['ID'];
};


export type MutationDeleteDcAdjustmentArgs = {
  input: DeleteDcAdjustmentInput;
};


export type MutationDeleteDepartmentArgs = {
  departmentId: Scalars['ID'];
};


export type MutationDeleteDocumentArgs = {
  documentId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationDeleteDocumentV2Args = {
  input: GetOrderDocumentV2Input;
};


export type MutationDeleteEscrowAccountArgs = {
  escrowAccountId: Scalars['String'];
};


export type MutationDeleteExceptionArgs = {
  input?: InputMaybe<DeleteExceptionInput>;
};


export type MutationDeleteFeeArgs = {
  input?: InputMaybe<DeleteFeeInput>;
};


export type MutationDeleteFundArgs = {
  orderId: Scalars['String'];
};


export type MutationDeleteNoteArgs = {
  input?: InputMaybe<DeleteNoteInput>;
};


export type MutationDeleteOrderMilestoneArgs = {
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationDeleteOrderPartyArgs = {
  orderId: Scalars['ID'];
  partyId: Scalars['ID'];
};


export type MutationDeleteOrderTaskArgs = {
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationDeletePayoffArgs = {
  orderId: Scalars['String'];
  payoffId: Scalars['String'];
};


export type MutationDeleteProrationChargeArgs = {
  orderId: Scalars['String'];
  prorationChargeId: Scalars['String'];
};


export type MutationDeleteReconciliationArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type MutationDeleteRecordingFeeTransferTaxCalcArgs = {
  orderId: Scalars['String'];
};


export type MutationDeleteRequirementArgs = {
  input?: InputMaybe<DeleteRequirementInput>;
};


export type MutationDeleteSecurityGroupArgs = {
  input?: InputMaybe<DeleteSecurityGroupInput>;
};


export type MutationDeleteSellerArgs = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
};


export type MutationDeleteSellerRepArgs = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
  sellerRepId: Scalars['ID'];
};


export type MutationDeleteSequenceArgs = {
  sequenceId: Scalars['ID'];
};


export type MutationDeleteStateWithholdingArgs = {
  orderId: Scalars['ID'];
};


export type MutationDeleteTemplateArgs = {
  documentId: Scalars['ID'];
  orgId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteTemplateV2Args = {
  input: TemplateDocTypeAndIdV2Input;
};


export type MutationDeleteTransactionArgs = {
  input?: InputMaybe<DeleteTransactionInput>;
};


export type MutationDeleteTransactionLineDetailArgs = {
  input?: InputMaybe<DeleteLineDetailInput>;
};


export type MutationDeleteUserLocksArgs = {
  input?: InputMaybe<DeleteUserLocksInput>;
};


export type MutationDocumentSaveAsAsyncArgs = {
  input: DocumentSaveAsInput;
};


export type MutationDocumentSaveAsAsyncV2Args = {
  input: DocumentSaveAsRequestV2Input;
};


export type MutationDownloadDocumentsAsyncArgs = {
  input: DownloadDocumentsAsyncInput;
  orderId: Scalars['String'];
};


export type MutationDownloadDocumentsAsyncV2Args = {
  input: DownloadAsyncRequestV2Input;
};


export type MutationDownloadTemplatesArgs = {
  input: DownloadInput;
  orgId?: InputMaybe<Scalars['String']>;
};


export type MutationDuplicateTemplateArgs = {
  input: DuplicateTemplateInput;
  sourceDocumentId: Scalars['String'];
  targetOrgId?: InputMaybe<Scalars['String']>;
};


export type MutationDuplicateTemplateV2Args = {
  input: DuplicateTemplateDocV2Input;
};


export type MutationFinalizeReconciliationArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};


export type MutationImportRepositoryTemplateV2Args = {
  input: ImportRepositoryTemplateRequestV2Input;
};


export type MutationImportRepositoryTemplatesArgs = {
  input: ImportRepositoryTemplateInput;
};


export type MutationInviteUserArgs = {
  input?: InputMaybe<InviteUserInput>;
};


export type MutationJoinTransactionsArgs = {
  input?: InputMaybe<JoinTransactionsInput>;
};


export type MutationLegacyOrdersPostArgs = {
  input?: InputMaybe<Array<InputMaybe<LegacyOrdersInput>>>;
};


export type MutationMoveAdminTaskArgs = {
  input?: InputMaybe<MoveAdminTaskInput>;
  milestoneId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationMoveOrderTaskArgs = {
  input: MoveOrderTaskInput;
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationOrderTitleCplProductArgs = {
  input?: InputMaybe<OrderTitleCplProductInput>;
  orderId: Scalars['ID'];
};


export type MutationOrderTitleCplProductV2Args = {
  input?: InputMaybe<OrderTitleCplProductInput>;
  orderId: Scalars['ID'];
};


export type MutationPatchBuyerSpouseArgs = {
  buyerId: Scalars['ID'];
  orderId: Scalars['ID'];
  spouse?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
};


export type MutationPatchBuyersArgs = {
  buyers?: InputMaybe<Array<InputMaybe<BuyerSellerCollectionPatchInput>>>;
  orderId: Scalars['ID'];
};


export type MutationPatchCalculatingCashToCloseArgs = {
  input: CalculatingCashToCloseInput;
};


export type MutationPatchSellerSpouseArgs = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
  spouse?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
};


export type MutationPatchSellerSpouseV2Args = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
  spouse?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
};


export type MutationPatchSellersArgs = {
  orderId: Scalars['ID'];
  sellers?: InputMaybe<Array<InputMaybe<BuyerSellerCollectionPatchInput>>>;
};


export type MutationPostAutoClearArgs = {
  input?: InputMaybe<PostAutoClearInput>;
};


export type MutationPrintChecksArgs = {
  input?: InputMaybe<PrintChecksInput>;
};


export type MutationPrintChecksFastArgs = {
  input?: InputMaybe<PrintChecksInput>;
};


export type MutationPrintChecksV2Args = {
  input: PrintChecksRequestV2Input;
};


export type MutationPrintDocumentsAsyncArgs = {
  documentIds: Array<Scalars['ID']>;
  orderId: Scalars['String'];
};


export type MutationPrintDocumentsAsyncV2Args = {
  input: PrintDocumentsRequestV2Input;
};


export type MutationPrintTestChecksArgs = {
  input?: InputMaybe<CheckPrintingTestInput>;
};


export type MutationPutDocumentFromKnownTemplateArgs = {
  orderId: Scalars['String'];
  templateType: Scalars['String'];
};


export type MutationPutDocumentFromKnownTemplateV2Args = {
  input: CreateFromKnownTemplateV2Input;
};


export type MutationPutIntegratedRecordingFeeTransferTaxArgs = {
  input: IntegratedRfttInput;
};


export type MutationPutOrderCommissionsArgs = {
  input: PutOrderCommissionsInput;
  metadata: PutOrderCommissionsMetadata;
};


export type MutationPutOrderDepositsArgs = {
  input: PutOrderDepositsInput;
  orderId: Scalars['ID'];
};


export type MutationPutProjectedPaymentsArgs = {
  input: ProjectedPaymentsInput;
};


export type MutationPutRecordingFeeTransferTaxArgs = {
  input: PutRecordingFeeTransferTaxInput;
};


export type MutationPutTenantChildImageArgs = {
  input?: InputMaybe<PutTenantChildImageInput>;
};


export type MutationRefreshCommissionsArgs = {
  input?: InputMaybe<RefreshCommissionsInput>;
};


export type MutationRefreshDepositsForAdjustmentsArgs = {
  input: RefreshDepositsForAdjustmentsInput;
};


export type MutationRefreshDepositsForFeesArgs = {
  input: RefreshDepositsForFeesInput;
};


export type MutationRefreshPremiumsAndFeesArgs = {
  input?: InputMaybe<RefreshPremiumsAndFeesInput>;
};


export type MutationReplacePartyCompanyAndContactArgs = {
  metadata: ReplacePartyCompanyAndContactMetadata;
  payload: ReplacePartyCompanyAndContactPayload;
};


export type MutationReprintChecksArgs = {
  input?: InputMaybe<PrintChecksInput>;
};


export type MutationSendEmailArgs = {
  input: SendEmailRequestInput;
};


export type MutationSetAgentNetAdminCredentialsArgs = {
  input: AdminSetCredentialAgentNet;
};


export type MutationSetAgentNetAdminOfficesArgs = {
  input: AdminSetAgentNetOffices;
};


export type MutationSetAgentNetUserCredentialsArgs = {
  input: UserSetCredentialAgentNet;
};


export type MutationSplitTransactionArgs = {
  input?: InputMaybe<SplitTransactionInput>;
};


export type MutationSwitchRecordingFeeTransferTaxCalculatorArgs = {
  input: SwitchRecordingFeeTransferTaxCalculatorInput;
};


export type MutationSynchronizeGfeChargesArgs = {
  orderId: Scalars['String'];
};


export type MutationToggleTen99Args = {
  input: ToggleTen99Input;
};


export type MutationTransferTransactionDetailsArgs = {
  input?: InputMaybe<TransferTransactionDetailsInput>;
};


export type MutationUpdateAdminMilestoneArgs = {
  input: UpdateAdminMilestoneInput;
  milestoneId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationUpdateAdminTaskArgs = {
  input: UpdateAdminTaskInput;
  milestoneId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationUpdateAdminWorkflowArgs = {
  input: UpdateAdminWorkflowInput;
  workflowId: Scalars['ID'];
};


export type MutationUpdateClausePackageArgs = {
  id: Scalars['ID'];
  input?: InputMaybe<ClausePackageInput>;
};


export type MutationUpdateClauseTemplateArgs = {
  clauseId: Scalars['ID'];
  input?: InputMaybe<ClauseTemplateInput>;
};


export type MutationUpdateClosingInformationArgs = {
  input: ClosingInformationInput;
};


export type MutationUpdateClosingQuestionsArgs = {
  input: ClosingQuestionsInput;
};


export type MutationUpdateDcAdjustmentArgs = {
  input: UpdateDcAdjustmentInput;
};


export type MutationUpdateDepartmentArgs = {
  departmentId: Scalars['ID'];
  input: UpdateDepartmentInput;
};


export type MutationUpdateDirectoryCompanyArgs = {
  input?: InputMaybe<UpdateDirectoryCompanyInput>;
};


export type MutationUpdateDirectoryContactArgs = {
  directoryCompanyId: Scalars['String'];
  input?: InputMaybe<UpdateDirectoryContactInput>;
};


export type MutationUpdateDocumentV2Args = {
  input: UpdateOrderDocumentV2Input;
};


export type MutationUpdateDocumentsArgs = {
  input?: InputMaybe<UpdateDocumentsInput>;
};


export type MutationUpdateDocumentsV2Args = {
  input: UpdateOrderDocumentsV2Input;
};


export type MutationUpdateEscrowAccountArgs = {
  input?: InputMaybe<UpdateEscrowAccountInput>;
};


export type MutationUpdateEstimatedTaxesInsuranceAssessmentsArgs = {
  input: EstimatedTaxesInsuranceAssessmentsInput;
};


export type MutationUpdateExceptionArgs = {
  input?: InputMaybe<UpdateExceptionInput>;
};


export type MutationUpdateExceptionsArgs = {
  input?: InputMaybe<UpdateExceptionsInput>;
};


export type MutationUpdateExceptionsHeaderArgs = {
  input?: InputMaybe<UpdateExceptionsHeaderInput>;
};


export type MutationUpdateFeeArgs = {
  input?: InputMaybe<UpdateFeeInput>;
};


export type MutationUpdateFundArgs = {
  input?: InputMaybe<UpdateFundInput>;
};


export type MutationUpdateFundingForFeesArgs = {
  input?: InputMaybe<UpdateFundingForFeesInput>;
};


export type MutationUpdateGfeChargeArgs = {
  input: UpdateGfeChargeInput;
};


export type MutationUpdateGfeChargesArgs = {
  input: UpdateGfeChargesInput;
};


export type MutationUpdateIsSetAsCdLastLineArgs = {
  input?: InputMaybe<UpdateIsSetAsCdLastLineInput>;
};


export type MutationUpdateLoanCalculationsDisclosuresArgs = {
  input: LoanCalculationsDisclosuresInput;
};


export type MutationUpdateLoanDisclosuresArgs = {
  input: UpdateLoanDisclosuresInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateNotificationsArgs = {
  input?: InputMaybe<UpdateNotificationsInput>;
};


export type MutationUpdateOrderArgs = {
  input?: InputMaybe<UpdateOrderInput>;
};


export type MutationUpdateOrderBuyerSellerRepresentativeByIdArgs = {
  input?: InputMaybe<UpdateOrderInput>;
};


export type MutationUpdateOrderMilestoneArgs = {
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  payload: UpdateOrderMilestoneInput;
};


export type MutationUpdateOrderPartyArgs = {
  input?: InputMaybe<UpdateOrderPartyInput>;
  orderId: Scalars['ID'];
};


export type MutationUpdateOrderPartyByIdArgs = {
  input?: InputMaybe<UpdateOrderInput>;
};


export type MutationUpdateOrderTaskArgs = {
  input: UpdateOrderTaskInput;
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationUpdatePayoffsArgs = {
  orderId: Scalars['String'];
  payoffs?: InputMaybe<Array<InputMaybe<UpdatePayoffInput>>>;
};


export type MutationUpdatePolicyMetadataArgs = {
  input?: InputMaybe<UpdatePolicyMetadataInput>;
};


export type MutationUpdateProrationChargeArgs = {
  orderId: Scalars['String'];
  prorationChargeId: Scalars['String'];
  prorationChargeInput: UpdateProrationCharge;
};


export type MutationUpdateReconciliationArgs = {
  input?: InputMaybe<UpdateReconciliationInput>;
};


export type MutationUpdateRequirementArgs = {
  input?: InputMaybe<UpdateRequirementInput>;
};


export type MutationUpdateRequirementsArgs = {
  input?: InputMaybe<UpdateRequirementsInput>;
};


export type MutationUpdateRequirementsHeaderArgs = {
  input?: InputMaybe<UpdateRequirementsHeaderInput>;
};


export type MutationUpdateSecurityGroupArgs = {
  input?: InputMaybe<UpdateSecurityGroupInput>;
};


export type MutationUpdateSequenceArgs = {
  input: UpdateSequenceInput;
};


export type MutationUpdateStaffRoleArgs = {
  id: Scalars['ID'];
  input: StaffRolePatchInput;
};


export type MutationUpdateStateWithholdingArgs = {
  input: UpdateStateWithholdingInput;
};


export type MutationUpdateTemplateArgs = {
  documentId: Scalars['String'];
  input?: InputMaybe<UpdateTemplateInput>;
  orgId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateTemplateV2Args = {
  input: UpdateTemplateDocV2Input;
};


export type MutationUpdateTen99Args = {
  input?: InputMaybe<Ten99Input>;
};


export type MutationUpdateTenantArgs = {
  input?: InputMaybe<UpdateTenantInput>;
};


export type MutationUpdateTenantChildArgs = {
  input?: InputMaybe<UpdateTenantChildInput>;
};


export type MutationUpdateTenantProfileImageArgs = {
  input?: InputMaybe<UpdateTenantProfileImageInput>;
};


export type MutationUpdateTenantUnderwriterArgs = {
  input?: InputMaybe<UpdateTenantUnderwriterInput>;
};


export type MutationUpdateTitleCplsArgs = {
  input?: InputMaybe<UpdateTitleCplsInput>;
  orderId: Scalars['ID'];
};


export type MutationUpdateTitleFeesArgs = {
  orderId: Scalars['String'];
  updateTitleFeesInput?: InputMaybe<FeesInput>;
};


export type MutationUpdateTitleGeneralArgs = {
  input?: InputMaybe<UpdateTitleGeneralInput>;
};


export type MutationUpdateTitlePremiumArgs = {
  input?: InputMaybe<UpdateTitlePremiumInput>;
  orderId: Scalars['ID'];
  premiumType: Scalars['String'];
};


export type MutationUpdateTransactionArgs = {
  input?: InputMaybe<UpdateTransactionInput>;
};


export type MutationUpdateTransactionLineDetailsArgs = {
  input?: InputMaybe<UpdateLineDetailsInput>;
};


export type MutationUpdateTransactionsArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateTransactionInput>>>;
};


export type MutationUpdateUserArgs = {
  input?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateUserSignatureImageArgs = {
  input?: InputMaybe<UpdateUserSignatureImageInput>;
};


export type MutationUpdateUserStatusArgs = {
  input?: InputMaybe<UpdateUserStatusInput>;
};


export type MutationUpsertBuyerSellerSplitArgs = {
  input?: InputMaybe<BuyerSellerSplitInput>;
};


export type MutationValidateRateArgs = {
  input: RateValidationRequest;
  orderId: Scalars['String'];
};


export type MutationValidateSdnArgs = {
  input: ValidateSdnInput;
};


export type MutationVoidJacketArgs = {
  jacketInput: JacketInput;
};


export type MutationVoidTitleCplArgs = {
  input: VoidTitleCplInput;
  orderId: Scalars['ID'];
};


export type MutationWireTransactionsArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateTransactionInput>>>;
};

export type Name = {
  __typename?: 'Name';
  displayName?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxForm = {
  __typename?: 'NhInventoryPropertyTaxForm';
  acreage?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  buyer?: Maybe<NhInventoryPropertyTaxFormBuyer>;
  lot?: Maybe<Scalars['String']>;
  property?: Maybe<NhInventoryPropertyTaxFormProperty>;
  seller?: Maybe<NhInventoryPropertyTaxFormSeller>;
  settlementAgentAddress?: Maybe<NhInventoryPropertyTaxFormAddress>;
  settlementAgentName?: Maybe<Scalars['String']>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  staff?: Maybe<NhInventoryPropertyTaxFormStaff>;
  taxMap?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxFormAddress = {
  __typename?: 'NhInventoryPropertyTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxFormBuyer = {
  __typename?: 'NhInventoryPropertyTaxFormBuyer';
  address?: Maybe<NhInventoryPropertyTaxFormAddress>;
  buyerType?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  representatives?: Maybe<NhInventoryPropertyTaxFormRepresentatives>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseFullName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxFormProperty = {
  __typename?: 'NhInventoryPropertyTaxFormProperty';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxFormRepresentatives = {
  __typename?: 'NhInventoryPropertyTaxFormRepresentatives';
  first?: Maybe<Scalars['String']>;
  second?: Maybe<Scalars['String']>;
  third?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxFormSeller = {
  __typename?: 'NhInventoryPropertyTaxFormSeller';
  address?: Maybe<NhInventoryPropertyTaxFormAddress>;
  email?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  sellerType?: Maybe<Scalars['String']>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxFormStaff = {
  __typename?: 'NhInventoryPropertyTaxFormStaff';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type NhRealEstatePurchaserTaxForm = {
  __typename?: 'NhRealEstatePurchaserTaxForm';
  buyers?: Maybe<Array<Maybe<NhRealEstatePurchaserTaxFormBuyer>>>;
  county?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<NhRealEstatePurchaserTaxFormSeller>;
  settlementAgentAddress?: Maybe<NhRealEstatePurchaserTaxFormAddress>;
  settlementAgentName?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  staff?: Maybe<NhRealEstatePurchaserTaxFormStaff>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type NhRealEstatePurchaserTaxFormAddress = {
  __typename?: 'NhRealEstatePurchaserTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type NhRealEstatePurchaserTaxFormBuyer = {
  __typename?: 'NhRealEstatePurchaserTaxFormBuyer';
  address?: Maybe<NhRealEstatePurchaserTaxFormAddress>;
  buyerType?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  representatives?: Maybe<NhRealEstatePurchaserTaxFormRepresentatives>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseFullName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
  spouseTaxIdNumber?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type NhRealEstatePurchaserTaxFormRepresentatives = {
  __typename?: 'NhRealEstatePurchaserTaxFormRepresentatives';
  first?: Maybe<Scalars['String']>;
  second?: Maybe<Scalars['String']>;
};

export type NhRealEstatePurchaserTaxFormSeller = {
  __typename?: 'NhRealEstatePurchaserTaxFormSeller';
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  sellerType?: Maybe<Scalars['String']>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
};

export type NhRealEstatePurchaserTaxFormStaff = {
  __typename?: 'NhRealEstatePurchaserTaxFormStaff';
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type NhRealEstateSellerTaxForm = {
  __typename?: 'NhRealEstateSellerTaxForm';
  buyers?: Maybe<NhRealEstateSellerTaxFormBuyer>;
  county?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<NhRealEstateSellerTaxFormSeller>>>;
  settlementAgentAddress?: Maybe<NhRealEstateSellerTaxFormAddress>;
  settlementAgentName?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  staff?: Maybe<NhRealEstateSellerTaxFormStaff>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type NhRealEstateSellerTaxFormAddress = {
  __typename?: 'NhRealEstateSellerTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type NhRealEstateSellerTaxFormBuyer = {
  __typename?: 'NhRealEstateSellerTaxFormBuyer';
  buyerType?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
};

export type NhRealEstateSellerTaxFormRepresentatives = {
  __typename?: 'NhRealEstateSellerTaxFormRepresentatives';
  first?: Maybe<Scalars['String']>;
  second?: Maybe<Scalars['String']>;
};

export type NhRealEstateSellerTaxFormSeller = {
  __typename?: 'NhRealEstateSellerTaxFormSeller';
  address?: Maybe<NhRealEstateSellerTaxFormAddress>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  representatives?: Maybe<NhRealEstateSellerTaxFormRepresentatives>;
  sellerType?: Maybe<Scalars['String']>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseFullName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
  spouseTaxIdNumber?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type NhRealEstateSellerTaxFormStaff = {
  __typename?: 'NhRealEstateSellerTaxFormStaff';
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type Node = {
  id: Scalars['ID'];
};

export type Note = {
  __typename?: 'Note';
  appliesTo?: Maybe<AppliesTo>;
  body: Scalars['String'];
  createdBy?: Maybe<NoteUser>;
  createdById?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<NoteEntityType>;
  id?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<NoteUser>;
  updatedById?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export enum NoteEntityType {
  Directory = 'directory',
  Order = 'order',
  Reconciliation = 'reconciliation',
  Workflow = 'workflow'
}

export type NoteUser = {
  __typename?: 'NoteUser';
  displayName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Notification = {
  __typename?: 'Notification';
  createdTimestamp?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  seen?: Maybe<Scalars['Boolean']>;
  status?: Maybe<ReadStatus>;
};

export type NotificationInput = {
  createdTimestamp?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  seen?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ReadStatus>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  branch?: Maybe<TenantChildNode>;
  branchLogo?: Maybe<Image>;
  buyerReps?: Maybe<Array<Maybe<OrderBuyerSellerSoRep>>>;
  buyers?: Maybe<Array<Buyer>>;
  buyersAllNames?: Maybe<Scalars['String']>;
  buyersAllNamesWithMarital?: Maybe<Scalars['String']>;
  buyersAllNamesWithMaritalAndVesting?: Maybe<Scalars['String']>;
  buyersAllNamesWithVesting?: Maybe<Scalars['String']>;
  clonedOrderSource?: Maybe<Order>;
  commissions?: Maybe<OrderCommissions>;
  companyLogo?: Maybe<Image>;
  deposits?: Maybe<OrderDeposits>;
  header?: Maybe<OrderHeader>;
  id: Scalars['ID'];
  lenderName?: Maybe<Scalars['String']>;
  loan?: Maybe<OrderLoan>;
  main?: Maybe<OrderMain>;
  parties?: Maybe<Array<Maybe<OrderParty>>>;
  piq?: Maybe<OrderPiq>;
  restrictions: Array<Restriction>;
  sellerReps?: Maybe<Array<Maybe<OrderBuyerSellerSoRep>>>;
  sellers?: Maybe<Array<Seller>>;
  sellersAllNames?: Maybe<Scalars['String']>;
  sellersAllNamesWithMarital?: Maybe<Scalars['String']>;
  sellersAllNamesWithMaritalAndVesting?: Maybe<Scalars['String']>;
  sellersAllNamesWithVesting?: Maybe<Scalars['String']>;
  ten99?: Maybe<Ten99>;
  title?: Maybe<TitleDomain>;
  transactionType?: Maybe<TransactionType>;
};

export type OrderBuyerSeller = {
  address?: Maybe<Address>;
  alias?: Maybe<Scalars['String']>;
  buyerSellerId?: Maybe<Scalars['ID']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayNameMetadata?: Maybe<OverrideMetadataString>;
  emailAddresses?: Maybe<Array<Maybe<BuyerSellerEmailAddress>>>;
  entityDateOfAgreement?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  entityStateOfAgreement?: Maybe<Scalars['String']>;
  excludeFromLoan?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  forwardingAddress?: Maybe<Address>;
  forwardingAddressSameAsCurrentAddress?: Maybe<Scalars['Boolean']>;
  forwardingAddressSameAsPropertyAddress?: Maybe<Scalars['Boolean']>;
  forwardingRegion?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasPowerOfAttorney?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isForeignAddress?: Maybe<Scalars['Boolean']>;
  isForeignForwardingAddress?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  ownershipPercentage?: Maybe<Scalars['Float']>;
  ownershipPercentageMetadata?: Maybe<OverrideMetadataNumber>;
  phoneNumbers?: Maybe<Array<Maybe<BuyerSellerPhoneNumber>>>;
  powerOfAttorney?: Maybe<PowerOfAttorney>;
  recordName?: Maybe<BuyerSellerRecordName>;
  representatives?: Maybe<Array<OrderBuyerSellerSoRep>>;
  representativesAllNames?: Maybe<Scalars['String']>;
  representativesAllNamesWithCapacity?: Maybe<Scalars['String']>;
  sdnStatus?: Maybe<Scalars['String']>;
  sdnStatusDetails?: Maybe<SdnStatusDetails>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  signingName?: Maybe<Scalars['String']>;
  signingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  spouse?: Maybe<OrderBuyerSellerSoRep>;
  suffix?: Maybe<Scalars['String']>;
  taxIdFormatted?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  typeOfBuyerSeller?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type OrderBuyerSellerSoRep = {
  __typename?: 'OrderBuyerSellerSORep';
  alias?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Maybe<BuyerSellerEmailAddress>>>;
  excludeFromLoan?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasPowerOfAttorney?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isBuyer?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  phoneNumbers?: Maybe<Array<Maybe<BuyerSellerPhoneNumber>>>;
  powerOfAttorney?: Maybe<PowerOfAttorney>;
  refBuyerSellerId?: Maybe<Scalars['String']>;
  referencedAs?: Maybe<Scalars['String']>;
  representativeCapacity?: Maybe<Scalars['String']>;
  sdnStatus?: Maybe<Scalars['String']>;
  sdnStatusDetails?: Maybe<SdnStatusDetails>;
  signingName?: Maybe<Scalars['String']>;
  signingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  soRepId?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  taxIdFormatted?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type OrderBuyerSellerSoRepPayload = {
  __typename?: 'OrderBuyerSellerSORepPayload';
  buyerReps?: Maybe<OrderBuyerSellerSoRep>;
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
  sellerReps?: Maybe<OrderBuyerSellerSoRep>;
};

export type OrderChangelog = {
  __typename?: 'OrderChangelog';
  action?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  fieldName?: Maybe<Scalars['String']>;
  fieldPath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  previousValue?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
  userDisplayName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type OrderCloneResponse = {
  __typename?: 'OrderCloneResponse';
  newOrderId?: Maybe<Scalars['String']>;
  sourceCloneId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type OrderCommissionLineItemInput = {
  commissionAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  realEstateAgentPartyReferenceId?: InputMaybe<Scalars['String']>;
  realEstateAgentType?: InputMaybe<Scalars['String']>;
};

export type OrderCommissions = {
  __typename?: 'OrderCommissions';
  buyerPaidPercent?: Maybe<Scalars['Float']>;
  commissionBasis?: Maybe<Scalars['Float']>;
  commissionLineItems?: Maybe<Array<Maybe<CommissionLineItem>>>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isCommissionBasisOverride?: Maybe<Scalars['Boolean']>;
  sellerPaidPercent?: Maybe<Scalars['Float']>;
  totalCommission?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type OrderCommissionsInput = {
  buyerPaidPercent?: InputMaybe<Scalars['Float']>;
  commissionBasis?: InputMaybe<Scalars['Float']>;
  commissionLineItems?: InputMaybe<Array<InputMaybe<OrderCommissionLineItemInput>>>;
  isCommissionBasisOverride?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['ID']>;
  sellerPaidPercent?: InputMaybe<Scalars['Float']>;
  totalCommission?: InputMaybe<Scalars['Float']>;
  updatedTimestamp: Scalars['String'];
};

export type OrderCommissionsV2 = {
  __typename?: 'OrderCommissionsV2';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  effectiveCommissions?: Maybe<EffectiveOrderCommissions>;
  id: Scalars['ID'];
  orderId: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
  userEnteredCommissions: UserEnteredCommissions;
};

export type OrderDepositLineItem = {
  __typename?: 'OrderDepositLineItem';
  dateReceived?: Maybe<Scalars['String']>;
  deductFromCommission?: Maybe<Scalars['Boolean']>;
  depositAmount?: Maybe<Scalars['Float']>;
  fundsHeldBy?: Maybe<Scalars['String']>;
  fundsHeldByName?: Maybe<Scalars['String']>;
  fundsHeldByResourceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  receiptNumber?: Maybe<Scalars['String']>;
  typeOfFunds?: Maybe<Scalars['String']>;
};

export type OrderDepositLineItemInput = {
  dateReceived?: InputMaybe<Scalars['String']>;
  deductFromCommission?: InputMaybe<Scalars['Boolean']>;
  depositAmount?: InputMaybe<Scalars['Float']>;
  fundsHeldBy?: InputMaybe<Scalars['String']>;
  fundsHeldByName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  receiptNumber?: InputMaybe<Scalars['String']>;
  typeOfFunds?: InputMaybe<Scalars['String']>;
};

export type OrderDeposits = {
  __typename?: 'OrderDeposits';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  lineItems: Array<OrderDepositLineItem>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export enum OrderDocumentTypeV2 {
  Document = 'Document',
  Hidden = 'Hidden'
}

export type OrderDocumentV2 = {
  __typename?: 'OrderDocumentV2';
  createdBy: UserDisplayNameV2;
  createdTimestamp: Scalars['String'];
  description: Scalars['String'];
  documentId: Scalars['ID'];
  documentType: OrderDocumentTypeV2;
  fileSrc?: Maybe<FileUrlSourceV2>;
  fileType: Scalars['String'];
  id: Scalars['ID'];
  isReadOnly: Scalars['Boolean'];
  listMergeChoices?: Maybe<Scalars['String']>;
  mergeFieldData?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orderId: Scalars['ID'];
  query?: Maybe<Scalars['String']>;
  rawMergeData?: Maybe<Scalars['String']>;
  skipClone?: Maybe<Scalars['Boolean']>;
  sourceTemplateId?: Maybe<Scalars['ID']>;
  updatedBy: UserDisplayNameV2;
  updatedTimestamp: Scalars['String'];
  uploadStatus: UploadStatusV2;
  wellKnownTemplateType?: Maybe<Scalars['String']>;
};

export type OrderHeader = {
  __typename?: 'OrderHeader';
  branch: Scalars['String'];
  businessSource?: Maybe<Scalars['String']>;
  clonedOrderSourceId?: Maybe<Scalars['ID']>;
  company?: Maybe<Scalars['String']>;
  createdTimestamp: Scalars['String'];
  dateCancelled?: Maybe<Scalars['String']>;
  dateClosed?: Maybe<Scalars['String']>;
  dateOnHold?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isMasterOrder?: Maybe<Scalars['Boolean']>;
  orderId: Scalars['ID'];
  orderNumber: Scalars['String'];
  propertyState?: Maybe<Scalars['String']>;
  propertyStateDetail?: Maybe<StateDetail>;
  statementType: Scalars['String'];
  status: Scalars['String'];
  tenantId: Scalars['String'];
  transactionType: TransactionType;
  updatedTimestamp: Scalars['String'];
};

export type OrderIdV2Input = {
  orderId: Scalars['ID'];
};

export type OrderLoan = {
  __typename?: 'OrderLoan';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  dateFirstPayment?: Maybe<Scalars['DateTime']>;
  dateLoanContingency?: Maybe<Scalars['DateTime']>;
  fundingTypes?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  insuredLanguage?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  interestType?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['Float']>;
  loanNumber?: Maybe<Scalars['String']>;
  loanPurpose?: Maybe<Scalars['String']>;
  loanTerm?: Maybe<Scalars['Float']>;
  loanTermIdentifier?: Maybe<Scalars['String']>;
  mers?: Maybe<Scalars['String']>;
  mersMin?: Maybe<Scalars['String']>;
  monthlyMip?: Maybe<Scalars['Float']>;
  mortgageInsurance?: Maybe<Scalars['String']>;
  mortgageInsuranceCaseNumber?: Maybe<Scalars['String']>;
  mortgageType?: Maybe<Scalars['String']>;
  mortgageTypeOtherDescription?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  principalAndInterestAmount?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type OrderLoanInput = {
  dateFirstPayment?: InputMaybe<Scalars['DateTime']>;
  dateLoanContingency?: InputMaybe<Scalars['DateTime']>;
  fundingTypes?: InputMaybe<Scalars['String']>;
  insuredLanguage?: InputMaybe<Scalars['String']>;
  interestRate?: InputMaybe<Scalars['Float']>;
  interestType?: InputMaybe<Scalars['String']>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  loanPurpose?: InputMaybe<Scalars['String']>;
  loanTerm?: InputMaybe<Scalars['Float']>;
  loanTermIdentifier?: InputMaybe<Scalars['String']>;
  mers?: InputMaybe<Scalars['String']>;
  mersMin?: InputMaybe<Scalars['String']>;
  monthlyMip?: InputMaybe<Scalars['Float']>;
  mortgageInsurance?: InputMaybe<Scalars['String']>;
  mortgageInsuranceCaseNumber?: InputMaybe<Scalars['String']>;
  mortgageType?: InputMaybe<Scalars['String']>;
  mortgageTypeOtherDescription?: InputMaybe<Scalars['String']>;
  principalAndInterestAmount?: InputMaybe<Scalars['Float']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type OrderMain = {
  __typename?: 'OrderMain';
  /** Amount of Initial Draw */
  amountInitialDraw?: Maybe<Scalars['Float']>;
  /**
   * (Deprecated) Amount of Loan
   * @deprecated Use OrderLoan
   */
  amountLoan?: Maybe<Scalars['Float']>;
  /** Amount of Sale */
  amountSale?: Maybe<Scalars['Float']>;
  /** Closing Location */
  closingLocation?: Maybe<Address>;
  /** Time of record creation */
  createdTimestamp?: Maybe<Scalars['String']>;
  /** Date of Disbursement */
  dateDisbursement?: Maybe<Scalars['String']>;
  /** Date of Funding */
  dateFunding?: Maybe<Scalars['String']>;
  /** Date of Rescission */
  dateRecission?: Maybe<Scalars['String']>;
  /** Date of the Settlement */
  dateSettlement?: Maybe<Scalars['String']>;
  /** ID of the Order */
  id: Scalars['ID'];
  /** Other Reference Number */
  otherReferenceNumber?: Maybe<Scalars['String']>;
  /** Staff associated to Order */
  staff?: Maybe<Array<Maybe<OrderStaff>>>;
  /** Time of the Settlement */
  timeSettlement?: Maybe<Scalars['String']>;
  /** Underwriter */
  underwriter?: Maybe<Underwriter>;
  /** ID of Underwriter */
  underwriterId?: Maybe<Scalars['String']>;
  /** Time of last update - needed to update Main */
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type OrderPiq = {
  __typename?: 'OrderPIQ';
  acreage?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  airResourcesBoardNumber?: Maybe<Scalars['String']>;
  appraisedValue?: Maybe<Scalars['String']>;
  assessedValue?: Maybe<Scalars['String']>;
  assessorsParcelNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  block?: Maybe<Scalars['String']>;
  boatslip?: Maybe<Scalars['String']>;
  book?: Maybe<Scalars['String']>;
  building?: Maybe<Scalars['String']>;
  carport?: Maybe<Scalars['String']>;
  commonElementOwnership?: Maybe<Scalars['String']>;
  condominiumName?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  countyLabel?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  firstTimeBuyer?: Maybe<Scalars['Boolean']>;
  garage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instrumentNumber?: Maybe<Scalars['String']>;
  legalDescriptionBrief?: Maybe<Scalars['String']>;
  legalDescriptionBriefHtml?: Maybe<Scalars['String']>;
  legalDescriptionBriefMergeable?: Maybe<Scalars['String']>;
  legalDescriptionFull?: Maybe<Scalars['String']>;
  legalDescriptionFullMergeable?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  mapNumber?: Maybe<Scalars['String']>;
  mudName?: Maybe<Scalars['String']>;
  municipalityName?: Maybe<Scalars['String']>;
  municipalityType?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  outlot?: Maybe<Scalars['String']>;
  ownerOccupied?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['String']>;
  parcel?: Maybe<Scalars['String']>;
  parkingSpace?: Maybe<Scalars['String']>;
  part?: Maybe<Scalars['String']>;
  phase?: Maybe<Scalars['String']>;
  platName?: Maybe<Scalars['String']>;
  propertyDetailsGroup?: Maybe<Scalars['String']>;
  propertyParcelNumbersAll?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  pudName?: Maybe<Scalars['String']>;
  q1Q3?: Maybe<Scalars['String']>;
  range?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  storage?: Maybe<Scalars['String']>;
  subdivisionName?: Maybe<Scalars['String']>;
  townhouse?: Maybe<Scalars['String']>;
  township?: Maybe<Scalars['String']>;
  tract?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  ward?: Maybe<Scalars['String']>;
};

export type OrderPiqInput = {
  acreage?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<AddressInput>;
  airResourcesBoardNumber?: InputMaybe<Scalars['String']>;
  appraisedValue?: InputMaybe<Scalars['String']>;
  assessedValue?: InputMaybe<Scalars['String']>;
  assessorsParcelNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  block?: InputMaybe<Scalars['String']>;
  boatslip?: InputMaybe<Scalars['String']>;
  book?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  carport?: InputMaybe<Scalars['String']>;
  commonElementOwnership?: InputMaybe<Scalars['String']>;
  condominiumName?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  countyLabel?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  firstTimeBuyer?: InputMaybe<Scalars['Boolean']>;
  garage?: InputMaybe<Scalars['String']>;
  instrumentNumber?: InputMaybe<Scalars['String']>;
  legalDescriptionBrief?: InputMaybe<Scalars['String']>;
  legalDescriptionBriefHtml?: InputMaybe<Scalars['String']>;
  legalDescriptionFull?: InputMaybe<Scalars['String']>;
  lot?: InputMaybe<Scalars['String']>;
  mapNumber?: InputMaybe<Scalars['String']>;
  mudName?: InputMaybe<Scalars['String']>;
  municipalityName?: InputMaybe<Scalars['String']>;
  municipalityType?: InputMaybe<Scalars['String']>;
  outlot?: InputMaybe<Scalars['String']>;
  ownerOccupied?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['String']>;
  parcel?: InputMaybe<Scalars['String']>;
  parkingSpace?: InputMaybe<Scalars['String']>;
  part?: InputMaybe<Scalars['String']>;
  phase?: InputMaybe<Scalars['String']>;
  platName?: InputMaybe<Scalars['String']>;
  propertyDetailsGroup?: InputMaybe<Scalars['String']>;
  propertyType?: InputMaybe<Scalars['String']>;
  pudName?: InputMaybe<Scalars['String']>;
  q1Q3?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  storage?: InputMaybe<Scalars['String']>;
  subdivisionName?: InputMaybe<Scalars['String']>;
  townhouse?: InputMaybe<Scalars['String']>;
  township?: InputMaybe<Scalars['String']>;
  tract?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  ward?: InputMaybe<Scalars['String']>;
};

/** This is the complete result structure of an Order Party */
export type OrderParty = {
  __typename?: 'OrderParty';
  company?: Maybe<PartyCompany>;
  contact?: Maybe<PartyContact>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSettlementUseOnly?: Maybe<Scalars['Boolean']>;
  orderId: Scalars['ID'];
  /** ID from api used to resolve ID! */
  partyId: Scalars['ID'];
  refSectionId?: Maybe<Scalars['String']>;
  refSectionLabel?: Maybe<Scalars['String']>;
  roleId: Scalars['String'];
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

/** This is the input structure for creating or updating an OrderParty through the updateOrder Mutation - deprecated (Use CreateOrderPartyInput or UpdateOrderPartyInput instead) */
export type OrderPartyInput = {
  company?: InputMaybe<CompanyPartialInput>;
  contact?: InputMaybe<ContactPartialInput>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdTimestamp?: InputMaybe<Scalars['String']>;
  isSettlementUseOnly?: InputMaybe<Scalars['Boolean']>;
  partyId?: InputMaybe<Scalars['String']>;
  refSectionId?: InputMaybe<Scalars['String']>;
  refSectionLabel?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type OrderPartyPayLoad = {
  __typename?: 'OrderPartyPayLoad';
  party?: Maybe<OrderParty>;
};

export type OrderPayload = {
  __typename?: 'OrderPayload';
  order?: Maybe<Order>;
};

export type OrderResponse = {
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
};

export type OrderStaff = {
  __typename?: 'OrderStaff';
  roleId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type OrderStaffInput = {
  roleId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type OrderSummary = Node & {
  __typename?: 'OrderSummary';
  addresses?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  branchName?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  buyersDisplayName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  disbursementDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lenderNames?: Maybe<Scalars['String']>;
  loanAmounts?: Maybe<Scalars['String']>;
  loanNumbers?: Maybe<Scalars['String']>;
  masterOrder?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  salesPrice?: Maybe<Scalars['String']>;
  sellerNames?: Maybe<Scalars['String']>;
  sellersDisplayName?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transactionTypeName?: Maybe<Scalars['String']>;
  underwriterName?: Maybe<Scalars['String']>;
};

export type OrderSummaryConnection = {
  __typename?: 'OrderSummaryConnection';
  edges?: Maybe<Array<Maybe<OrderSummaryEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type OrderSummaryEdge = {
  __typename?: 'OrderSummaryEdge';
  node?: Maybe<OrderSummary>;
};

export enum OrderSummaryField {
  Addresses = 'addresses',
  BranchName = 'branchName',
  BuyerNames = 'buyerNames',
  BuyersDisplayName = 'buyersDisplayName',
  CompanyName = 'companyName',
  CreatedByName = 'createdByName',
  CreatedTimestamp = 'createdTimestamp',
  DisbursementDate = 'disbursementDate',
  LenderNames = 'lenderNames',
  LoanAmounts = 'loanAmounts',
  LoanNumbers = 'loanNumbers',
  MasterOrder = 'masterOrder',
  OrderNumber = 'orderNumber',
  SalesPrice = 'salesPrice',
  SellerNames = 'sellerNames',
  SellersDisplayName = 'sellersDisplayName',
  SettlementDate = 'settlementDate',
  Status = 'status',
  TransactionTypeName = 'transactionTypeName',
  UnderwriterName = 'underwriterName'
}

export type OrderSummaryFilter = {
  field: OrderSummaryField;
  operator: ApiFilterOperator;
  value: Scalars['String'];
};

export type OrderTaskInput = {
  active: Scalars['Boolean'];
  assignment: TaskAssignmentInput;
  completedBy?: InputMaybe<Scalars['String']>;
  completedTimestamp?: InputMaybe<Scalars['String']>;
  departmentDependency?: InputMaybe<Scalars['String']>;
  due?: InputMaybe<TaskDueInput>;
  dueDate?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  sortIndex: Scalars['Int'];
  start?: InputMaybe<TaskStartInput>;
  startDate?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  type: Scalars['String'];
};

export type OrderTitleCplProductInput = {
  agentRetained?: InputMaybe<Scalars['Float']>;
  amount?: InputMaybe<Scalars['Float']>;
  approvedAttorney?: InputMaybe<Scalars['String']>;
  buyerPays?: InputMaybe<Scalars['Float']>;
  coveredParty: Scalars['String'];
  displayOnSettlement?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  letterType: Scalars['String'];
  proposedLoanInsured?: InputMaybe<Scalars['String']>;
  secondaryPartyId?: InputMaybe<Scalars['String']>;
  secondaryPartyRoleType?: InputMaybe<Scalars['String']>;
  sellerPays?: InputMaybe<Scalars['Float']>;
  status: Scalars['String'];
  underwriterRemitted?: InputMaybe<Scalars['Float']>;
  updatedTimestamp: Scalars['String'];
};

export type OverrideMetadataNumber = {
  __typename?: 'OverrideMetadataNumber';
  effectiveValue?: Maybe<Scalars['Float']>;
  fallbackValue?: Maybe<Scalars['Float']>;
  overridden: Scalars['Boolean'];
  overrideValue?: Maybe<Scalars['Float']>;
};

export type OverrideMetadataString = {
  __typename?: 'OverrideMetadataString';
  effectiveValue?: Maybe<Scalars['String']>;
  fallbackValue?: Maybe<Scalars['String']>;
  overridden: Scalars['Boolean'];
  overrideValue?: Maybe<Scalars['String']>;
};

export type OwnerLenderDisclosureFeeAdditionalData = {
  __typename?: 'OwnerLenderDisclosureFeeAdditionalData';
  derivedActualAmount?: Maybe<Scalars['Float']>;
  externalLenderPremiumId?: Maybe<Scalars['String']>;
  externalOwnerPremiumId?: Maybe<Scalars['String']>;
  liabilityAmount?: Maybe<Scalars['Float']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
};

export enum PaginatedQueryFilterOperatorV2 {
  Begins = 'begins',
  Contains = 'contains',
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte',
  Neq = 'neq',
  NotContains = 'notContains',
  Size = 'size'
}

export type PaginatedQueryFilterV2Input = {
  field: Scalars['String'];
  operator: PaginatedQueryFilterOperatorV2;
  shouldFilterEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type PaginatedTemplatesQueryV2Input = {
  after?: InputMaybe<Scalars['String']>;
  documentType: TemplateDocTypeV2;
  filters?: InputMaybe<Array<PaginatedQueryFilterV2Input>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type PaginatedTemplatesV2 = {
  __typename?: 'PaginatedTemplatesV2';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  templates?: Maybe<Array<TemplateDocV2>>;
};

export type ParameterError = {
  __typename?: 'ParameterError';
  fieldName: Scalars['String'];
  issue: Scalars['String'];
  message: Scalars['String'];
};

export type ParameterValidation = {
  __typename?: 'ParameterValidation';
  errorFields: Array<ParameterError>;
};

/** PartyCompany, one component of an OrderParty */
export type PartyCompany = {
  __typename?: 'PartyCompany';
  addresses?: Maybe<Array<Maybe<Address>>>;
  altaId?: Maybe<Scalars['String']>;
  alternateSearchName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** If the PartyCompany was copied from the Directory, then directoryCompanyReferenceId will hold the Directory's Company ID */
  directoryCompanyReferenceId?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Maybe<EmailAddressSchema>>>;
  lenderLanguage?: Maybe<Scalars['String']>;
  lenderLanguageDefaultType?: Maybe<Scalars['String']>;
  lenderLanguageOptions?: Maybe<LenderLanguageOptionsType>;
  licenses?: Maybe<Array<Maybe<License>>>;
  nmlsId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  taxId?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  /** If the PartyCompany was copied from the Tenant Hierarchy, then tenantOrgReferenceId will hold the Org ID (usually a Branch) */
  tenantOrgReferenceId?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  wireInstructions?: Maybe<WireSchema>;
};

/** Input for a PartyCompany, used for both creating and updating */
export type PartyCompanyInput = {
  addresses?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  altaId?: InputMaybe<Scalars['String']>;
  alternateSearchName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directoryCompanyReferenceId?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  lenderLanguage?: InputMaybe<Scalars['String']>;
  lenderLanguageDefaultType?: InputMaybe<Scalars['String']>;
  lenderLanguageOptions?: InputMaybe<LenderLanguageOptionsInput>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  nmlsId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  tenantOrgReferenceId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  wireInstructions?: InputMaybe<WireInput>;
};

/** PartyContact, one component of an OrderParty */
export type PartyContact = {
  __typename?: 'PartyContact';
  address?: Maybe<Address>;
  altaId?: Maybe<Scalars['String']>;
  /** If the PartyContact was copied from the Directory, then directoryContactReferenceId will hold the Directory's Contact ID */
  directoryContactReferenceId?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Maybe<EmailAddressSchema>>>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenses?: Maybe<Array<Maybe<License>>>;
  nmlsId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  suffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  useCompanyAddress?: Maybe<Scalars['Boolean']>;
  /** If the PartyContact was copied from the Users list, then userReferenceId will hold the User ID */
  userReferenceId?: Maybe<Scalars['String']>;
};

/** Input for a PartyContact, used for both creating and updating */
export type PartyContactInput = {
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  directoryContactReferenceId?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  firstName?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  nmlsId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  suffix?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  useCompanyAddress?: InputMaybe<Scalars['Boolean']>;
  userReferenceId?: InputMaybe<Scalars['String']>;
};

export type PartySelection = {
  __typename?: 'PartySelection';
  party?: Maybe<OrderParty>;
};

export type PasteConversionResponse = {
  __typename?: 'PasteConversionResponse';
  error?: Maybe<ErrorBody>;
  tracking?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PasteInput = {
  content: Scalars['String'];
  tracking?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type PatchSellerSpouseResponse = OrderResponse & {
  __typename?: 'PatchSellerSpouseResponse';
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
  spouse?: Maybe<OrderBuyerSellerSoRep>;
};

export type Payoff = {
  __typename?: 'Payoff';
  additionalDaysAfterDisbursement?: Maybe<Scalars['Int']>;
  additionalFees?: Maybe<Array<Maybe<PayoffAdditionalFee>>>;
  appendedDescription?: Maybe<Scalars['String']>;
  asOfDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  lender?: Maybe<OrderParty>;
  lenderPartyId?: Maybe<Scalars['String']>;
  loanNumber?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  paidBy?: Maybe<Scalars['String']>;
  perDiemInterestAmount?: Maybe<Scalars['Float']>;
  principalBalance?: Maybe<Scalars['Float']>;
  totalAdditionalInterest?: Maybe<Scalars['Float']>;
  totalAdditionalInterestOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type PayoffAdditionalFee = {
  __typename?: 'PayoffAdditionalFee';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type PermissionDefinition = {
  __typename?: 'PermissionDefinition';
  key: Scalars['String'];
  prerequisites?: Maybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type PermissionsRule = {
  __typename?: 'PermissionsRule';
  key: Scalars['String'];
  prerequisites?: Maybe<Prerequisites>;
};

export type PermissionsRuleSet = {
  __typename?: 'PermissionsRuleSet';
  name: Scalars['String'];
  permissionsRules: Array<PermissionsRule>;
  sortOrder: Scalars['Int'];
};

export type PermissionsRuleSets = {
  __typename?: 'PermissionsRuleSets';
  adminPermissionsRuleSets: Array<PermissionsRuleSet>;
  applicationPermissionsRuleSets: Array<PermissionsRuleSet>;
};

export type Phone = {
  __typename?: 'Phone';
  extension?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  phoneNumberFull?: Maybe<Scalars['String']>;
  phoneType: Scalars['String'];
};

export type PhoneNumberInput = {
  ext?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  phoneNumber: Scalars['PhoneNumber'];
  type: Scalars['String'];
};

export type PhoneNumberType = {
  __typename?: 'PhoneNumberType';
  ext?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  phoneNumber: Scalars['PhoneNumber'];
  phoneNumberFull?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type PlacePrediction = {
  __typename?: 'PlacePrediction';
  place: Scalars['String'];
  placeId: Scalars['String'];
  structuredFormat: PlacePredictionStructuredFormat;
  text: PlacePredictionText;
  types: Array<Scalars['String']>;
};

export type PlacePredictionSecondaryText = {
  __typename?: 'PlacePredictionSecondaryText';
  text: Scalars['String'];
};

export type PlacePredictionStructuredFormat = {
  __typename?: 'PlacePredictionStructuredFormat';
  mainText: PlacePredictionText;
  secondaryText: PlacePredictionSecondaryText;
};

export type PlacePredictionText = {
  __typename?: 'PlacePredictionText';
  matches: Array<PlacePredictionTextMatch>;
  text: Scalars['String'];
};

export type PlacePredictionTextMatch = {
  __typename?: 'PlacePredictionTextMatch';
  endOffset: Scalars['Int'];
  startOffset?: Maybe<Scalars['Int']>;
};

export type PlacesSuggestion = {
  __typename?: 'PlacesSuggestion';
  placePrediction: PlacePrediction;
};

export type PolicyData = {
  __typename?: 'PolicyData';
  effectiveDate?: Maybe<Scalars['String']>;
  effectiveDateFallbackValue?: Maybe<Scalars['String']>;
  effectiveDateOverrideMetadata?: Maybe<OverrideMetadataString>;
  effectiveTime?: Maybe<Scalars['String']>;
  policyNumber?: Maybe<Scalars['String']>;
  remittanceDate?: Maybe<Scalars['String']>;
};

export type PolicyDataInput = {
  effectiveDate?: InputMaybe<Scalars['String']>;
  effectiveTime?: InputMaybe<Scalars['String']>;
  policyNumber?: InputMaybe<Scalars['String']>;
  remittanceDate?: InputMaybe<Scalars['String']>;
};

export type PolicyDetails = {
  __typename?: 'PolicyDetails';
  canPrice: Scalars['Boolean'];
  coveredParties: Array<Scalars['String']>;
  letterType: Scalars['String'];
};

export type PolicyMetadata = {
  __typename?: 'PolicyMetadata';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  insuredVesting?: Maybe<InsuredVesting>;
  loanPolicy?: Maybe<PolicyData>;
  mortgageRecital?: Maybe<MortgageRecital>;
  orderId: Scalars['String'];
  ownerPolicy?: Maybe<PolicyData>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type PolicyRateRequest = {
  additionalQuestions?: InputMaybe<Array<AdditionalQuestionsRateRequest>>;
  effectiveDate: Scalars['String'];
  endorsements?: InputMaybe<Array<EndorsementRateRequest>>;
  policyId: Scalars['String'];
  priorPolicyAmount?: InputMaybe<Scalars['Float']>;
  priorPolicyCoverageType?: InputMaybe<Scalars['String']>;
  rateId: Scalars['String'];
};

export type PolicyRateValidationRequest = {
  additionalQuestions?: InputMaybe<Array<AdditionalQuestionsRateValidationRequest>>;
  effectiveDate?: InputMaybe<Scalars['String']>;
  endorsements?: InputMaybe<Array<EndorsementRateValidationRequest>>;
  policyId?: InputMaybe<Scalars['String']>;
  priorPolicyAmount?: InputMaybe<Scalars['Float']>;
  priorPolicyCoverageType?: InputMaybe<Scalars['String']>;
  rateId?: InputMaybe<Scalars['String']>;
};

export type PolicyRates = {
  __typename?: 'PolicyRates';
  expirationDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  rateType: Scalars['String'];
};

export type PolicyType = {
  __typename?: 'PolicyType';
  endorsements?: Maybe<Array<Maybe<PolicyTypeEndorsement>>>;
  id: Scalars['String'];
  name: Scalars['String'];
  policyType: Scalars['String'];
  rates?: Maybe<Array<Maybe<PolicyRates>>>;
};

export type PolicyTypeEndorsement = {
  __typename?: 'PolicyTypeEndorsement';
  /** @deprecated Use agentRetainedV2 instead for dollar/percentage values */
  agentRetained?: Maybe<Scalars['Float']>;
  agentRetainedV2?: Maybe<DollarsPercent>;
  amount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isDefaultEndorsement?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /** @deprecated Use underwriterRemittedV2 instead for dollar/percentage values */
  underwriterRemitted?: Maybe<Scalars['Float']>;
  underwriterRemittedV2?: Maybe<DollarsPercent>;
};

export type PositivePay = {
  __typename?: 'PositivePay';
  exportFileName?: Maybe<Scalars['String']>;
  fileExportTemplate?: Maybe<Scalars['String']>;
  fileExtension?: Maybe<Scalars['String']>;
};

export type PositivePayFile = {
  __typename?: 'PositivePayFile';
  fileBuffer?: Maybe<Scalars['String']>;
  fileExtension?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type PositivePayInput = {
  exportFileName?: InputMaybe<Scalars['String']>;
  fileExportTemplate?: InputMaybe<Scalars['String']>;
  fileExtension?: InputMaybe<Scalars['String']>;
};

export type PositivePaySubmission = {
  __typename?: 'PositivePaySubmission';
  createdBy?: Maybe<User>;
  createdDate?: Maybe<Scalars['String']>;
  transactionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PostAutoClearInput = {
  bai2: Scalars['String'];
  escrowAccountId: Scalars['String'];
  fileType: Scalars['String'];
  reconciliationId: Scalars['String'];
};

export type PostAutoClearResponse = {
  __typename?: 'PostAutoClearResponse';
  result: Scalars['String'];
  totals: AutoClearTotals;
  unmatchedTransactions: Array<Bai2TransactionSummary>;
};

export type PowerOfAttorney = {
  __typename?: 'PowerOfAttorney';
  address?: Maybe<Address>;
  associatedToParty?: Maybe<Scalars['String']>;
  attorneyFirstName?: Maybe<Scalars['String']>;
  attorneyLastName?: Maybe<Scalars['String']>;
  attorneyMiddleName?: Maybe<Scalars['String']>;
  attorneySuffix?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Scalars['EmailAddress']>>;
  endDate?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Scalars['PhoneNumber']>>;
  signingName?: Maybe<Scalars['String']>;
  signingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  startDate?: Maybe<Scalars['String']>;
};

export type PowerOfAttorneyInput = {
  address?: InputMaybe<AddressInput>;
  associatedToParty?: InputMaybe<Scalars['String']>;
  attorneyFirstName?: InputMaybe<Scalars['String']>;
  attorneyLastName?: InputMaybe<Scalars['String']>;
  attorneyMiddleName?: InputMaybe<Scalars['String']>;
  attorneySuffix?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<Scalars['EmailAddress']>>;
  endDate?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<Scalars['PhoneNumber']>>;
  signingName?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type PremiumAdditionalQuestion = {
  __typename?: 'PremiumAdditionalQuestion';
  answer?: Maybe<PremiumAdditionalQuestionAnswer>;
  defaultAnswer?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inputType: Scalars['String'];
  options: Array<PremiumAdditionalQuestionAnswerOption>;
  question: Scalars['String'];
};

export type PremiumAdditionalQuestionAnswer = {
  __typename?: 'PremiumAdditionalQuestionAnswer';
  answerType?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
};

export type PremiumAdditionalQuestionAnswerOption = {
  __typename?: 'PremiumAdditionalQuestionAnswerOption';
  description: Scalars['String'];
  id: Scalars['String'];
};

export type PremiumFeeAdditionalData = {
  __typename?: 'PremiumFeeAdditionalData';
  externalPremiumLineId?: Maybe<Scalars['String']>;
  sourceBorrowerPaidAt?: Maybe<Scalars['Float']>;
  sourceSellerPaidAt?: Maybe<Scalars['Float']>;
};

export type PremiumRateCalculation = {
  __typename?: 'PremiumRateCalculation';
  actual?: Maybe<Scalars['Float']>;
  additionalQuestions: Array<PremiumAdditionalQuestion>;
  /** @deprecated Use agentRetainedV2 instead for dollar/percentage values */
  agentRetained?: Maybe<Scalars['Float']>;
  agentRetainedV2?: Maybe<DollarsPercent>;
  disclosed?: Maybe<Scalars['Float']>;
  discountApplied?: Maybe<Scalars['Float']>;
  endorsements: Array<PremiumRateCalculationEndorsement>;
  /** @deprecated Use underwriterRemittedV2 instead for dollar/percentage values */
  underwriterRemitted?: Maybe<Scalars['Float']>;
  underwriterRemittedV2?: Maybe<DollarsPercent>;
};

export type PremiumRateCalculationEndorsement = {
  __typename?: 'PremiumRateCalculationEndorsement';
  additionalQuestions: Array<PremiumAdditionalQuestion>;
  amount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
};

export type PremiumRateCalculationResponse = {
  __typename?: 'PremiumRateCalculationResponse';
  lender?: Maybe<PremiumRateCalculation>;
  owner?: Maybe<PremiumRateCalculation>;
  warnings: Array<Scalars['String']>;
};

export type PrepaidInterestFeeAdditionalData = {
  __typename?: 'PrepaidInterestFeeAdditionalData';
  amountPerDay?: Maybe<Scalars['Float']>;
  amountPerDayOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  fromDate?: Maybe<Scalars['String']>;
  fromDateOverrideMetadata?: Maybe<OverrideMetadataString>;
  toDate?: Maybe<Scalars['String']>;
  toDateOverrideMetadata?: Maybe<OverrideMetadataString>;
};

export type PrerequisiteAnd = {
  __typename?: 'PrerequisiteAnd';
  and: Array<Prerequisites>;
};

export type PrerequisiteKey = {
  __typename?: 'PrerequisiteKey';
  key: Scalars['String'];
};

export type PrerequisiteOr = {
  __typename?: 'PrerequisiteOr';
  or: Array<Prerequisites>;
};

export type Prerequisites = PrerequisiteAnd | PrerequisiteKey | PrerequisiteOr;

export type PrintCheckResultEntryV2 = {
  __typename?: 'PrintCheckResultEntryV2';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  transactionId: Scalars['ID'];
};

export type PrintChecksInput = {
  orderId: Scalars['ID'];
  transactionIds: Array<Scalars['ID']>;
};

export type PrintChecksRequestV2Input = {
  orderId: Scalars['ID'];
  /** @minItems 1 */
  transactionIds: Array<Scalars['String']>;
};

export type PrintChecksResponseV2 = {
  __typename?: 'PrintChecksResponseV2';
  results: Array<PrintCheckResultEntryV2>;
  subscriptionId: Scalars['ID'];
};

export type PrintChecksResult = {
  __typename?: 'PrintChecksResult';
  results: Array<PrintChecksResultItemEntry>;
  subscriptionId?: Maybe<Scalars['String']>;
  successFullyPrintedAllChecks: Scalars['Boolean'];
};

export type PrintChecksResultItemEntry = {
  __typename?: 'PrintChecksResultItemEntry';
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  transaction?: Maybe<Transaction>;
  transactionId: Scalars['ID'];
};

export type PrintChecksResultTest = {
  __typename?: 'PrintChecksResultTest';
  subscriptionId?: Maybe<Scalars['String']>;
};

export type PrintDocumentsAsyncResponse = {
  __typename?: 'PrintDocumentsAsyncResponse';
  subscriptionId?: Maybe<Scalars['String']>;
};

export type PrintDocumentsRequestV2Input = {
  /** @minItems 1 */
  documentIds: Array<Scalars['String']>;
  orderId: Scalars['ID'];
};

export type ProjectedPayments = {
  __typename?: 'ProjectedPayments';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  orderId?: Maybe<Scalars['String']>;
  terms?: Maybe<Array<Maybe<ProjectedPaymentsTerm>>>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type ProjectedPaymentsInput = {
  orderId: Scalars['String'];
  terms: Array<InputMaybe<ProjectedPaymentsTermInput>>;
  updatedTimestamp: Scalars['DateTime'];
};

export type ProjectedPaymentsTerm = {
  __typename?: 'ProjectedPaymentsTerm';
  endYear: Scalars['Float'];
  estimatedEscrow?: Maybe<Scalars['Float']>;
  estimatedEscrowOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  estimatedTotalMonthlyPayments?: Maybe<Scalars['Float']>;
  mortgageInsurance?: Maybe<Scalars['Float']>;
  principalAndInterest?: Maybe<Scalars['Float']>;
  startYear: Scalars['Float'];
};

export type ProjectedPaymentsTermInput = {
  endYear: Scalars['Float'];
  estimatedEscrow?: InputMaybe<Scalars['Float']>;
  mortgageInsurance?: InputMaybe<Scalars['Float']>;
  principalAndInterest?: InputMaybe<Scalars['Float']>;
  startYear: Scalars['Float'];
};

export type PropertyTaxEscrowFeeAdditionalData = {
  __typename?: 'PropertyTaxEscrowFeeAdditionalData';
  amountPerMonth?: Maybe<Scalars['Float']>;
  amountPerMonthOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type PropertyTaxFeeAdditionalData = {
  __typename?: 'PropertyTaxFeeAdditionalData';
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type ProrationCharge = {
  __typename?: 'ProrationCharge';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  frequencyDisplayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lineItem?: Maybe<ProrationChargeLineItem>;
  orderId: Scalars['ID'];
  payee?: Maybe<OrderParty>;
  payeePartyId?: Maybe<Scalars['String']>;
  prorationChargeSubtype?: Maybe<Scalars['String']>;
  prorationChargeType?: Maybe<Scalars['String']>;
  prorationDetails?: Maybe<ProrationDetails>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type ProrationChargeLineItem = {
  __typename?: 'ProrationChargeLineItem';
  amountDue?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['String']>;
  payment?: Maybe<ProrationChargeLineItemPayment>;
};

export type ProrationChargeLineItemInput = {
  amountDue?: InputMaybe<Scalars['Float']>;
  dueDate?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<ProrationChargeLineItemPaymentInput>;
};

export type ProrationChargeLineItemPayment = {
  __typename?: 'ProrationChargeLineItemPayment';
  amountPaid?: Maybe<Scalars['Float']>;
  discountAmount?: Maybe<Scalars['Float']>;
  penaltyInterestAmountDue?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type ProrationChargeLineItemPaymentInput = {
  amountPaid?: InputMaybe<Scalars['Float']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  penaltyInterestAmountDue?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ProrationDetails = {
  __typename?: 'ProrationDetails';
  daysInYear?: Maybe<Scalars['String']>;
  fromDate?: Maybe<Scalars['String']>;
  fromDateOverrideMetadata?: Maybe<OverrideMetadataString>;
  includeIn1099?: Maybe<Scalars['Boolean']>;
  includeProrateDate?: Maybe<Scalars['Boolean']>;
  perDiem?: Maybe<Scalars['Float']>;
  perDiemOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  prorateAmount?: Maybe<Scalars['Float']>;
  prorateAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  prorateDate?: Maybe<Scalars['String']>;
  prorateDateOverrideMetadata?: Maybe<OverrideMetadataString>;
  prorateDays?: Maybe<Scalars['Float']>;
  prorateDaysOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  taxAmount?: Maybe<Scalars['Float']>;
  taxAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  toDate?: Maybe<Scalars['String']>;
  toDateOverrideMetadata?: Maybe<OverrideMetadataString>;
};

export type ProrationDetailsInput = {
  daysInYear?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['String']>;
  includeIn1099?: InputMaybe<Scalars['Boolean']>;
  includeProrateDate?: InputMaybe<Scalars['Boolean']>;
  perDiem?: InputMaybe<Scalars['Float']>;
  prorateAmount?: InputMaybe<Scalars['Float']>;
  prorateDate?: InputMaybe<Scalars['String']>;
  prorateDays?: InputMaybe<Scalars['Float']>;
  taxAmount?: InputMaybe<Scalars['Float']>;
  toDate?: InputMaybe<Scalars['String']>;
};

export type ProtectedRecipientAccountNumber = {
  __typename?: 'ProtectedRecipientAccountNumber';
  recipientAccountNumberProtected?: Maybe<Scalars['String']>;
};

export type ProtectedTaxId = {
  __typename?: 'ProtectedTaxId';
  taxIdProtected?: Maybe<Scalars['String']>;
};

export type PusherConfiguration = {
  __typename?: 'PusherConfiguration';
  apiKey?: Maybe<Scalars['String']>;
  cluster?: Maybe<Scalars['String']>;
};

export type PutOrderCommissionBasisOverrideInput = {
  value?: InputMaybe<Scalars['Float']>;
};

export type PutOrderCommissionsInput = {
  commissionBasisOverride?: InputMaybe<PutOrderCommissionBasisOverrideInput>;
  distributionMethod: Scalars['String'];
  lineItems: Array<PutUserEnteredCommissionsLineItemInput>;
  sellerPaidPercentage?: InputMaybe<Scalars['Float']>;
  totalCommissionAmount: PutTotalCommissionAmountInput;
};

export type PutOrderCommissionsMetadata = {
  orderId: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
};

export type PutOrderDepositsInput = {
  lineItems: Array<OrderDepositLineItemInput>;
  updatedTimestamp: Scalars['String'];
};

export type PutRecordingFeeTransferTaxInput = {
  orderId: Scalars['String'];
  recordingFees: RecordingFeesInput;
  transferTaxes: TransferTaxesInput;
  updatedTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type PutTenantChildImageInput = {
  id: Scalars['ID'];
  profileImage?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type PutTotalCommissionAmountInput = {
  calculatedValue?: InputMaybe<Scalars['Float']>;
  calculationMethod: Scalars['String'];
  value?: InputMaybe<Scalars['Float']>;
};

export type PutUserEnteredCommissionsLineItemInput = {
  agentType: Scalars['String'];
  calculatedValue?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  partyId: Scalars['String'];
  value?: InputMaybe<Scalars['Float']>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']>;
  admin: AdminDomain;
  clauseTemplates?: Maybe<ClauseTemplateConnection>;
  configuration?: Maybe<Configuration>;
  dashboard?: Maybe<Array<Maybe<Dashboard>>>;
  defaults: UserDefaults;
  directoryCompanies?: Maybe<Array<Maybe<CompanySummary>>>;
  directoryContacts?: Maybe<Array<ContactSummary>>;
  directoryDetail?: Maybe<CompanyContact>;
  documentByOrderIdAndDocumentId: Document;
  documentListByOrderId: Array<Document>;
  downloadTemplatesV2: DownloadTemplateDocResultV2;
  feeLineTypes?: Maybe<Array<Scalars['String']>>;
  fees?: Maybe<Array<Fee>>;
  fluentClauseTemplates?: Maybe<ClauseTemplateConnection>;
  getActivityLogOrders?: Maybe<ActivityLogOrderConnection>;
  getAdjustmentStatementSectionTotals?: Maybe<SectionSummariesTotals>;
  getAdjustments: Array<Adjustment>;
  getAdminMilestone: AdminMilestone;
  getAdminMilestones: Array<AdminMilestone>;
  getAdminTask: AdminTask;
  getAdminTasks: Array<AdminTask>;
  getAdminWorkflow: AdminWorkflow;
  getAdminWorkflows: Array<AdminWorkflow>;
  getAgentNetAdminOffices: AgentNetAdminOfficesResponse;
  getAgentNetAdminStatus: AdminCredentialAgentNetStatus;
  getAgentNetUserStatus: UserCredentialAgentNetStatus;
  getAllTransactions?: Maybe<Array<Maybe<Transaction>>>;
  getAuthorizedSignatoryUsers?: Maybe<Array<Maybe<AuthorizedSignatoryUser>>>;
  getAutocompleteResults: Array<PlacesSuggestion>;
  getAvailableWorkflows?: Maybe<Array<Maybe<AvailableWorkflow>>>;
  getBuyerSpouseTaxId: ProtectedTaxId;
  getBuyerTaxId: ProtectedTaxId;
  getCalculatingCashToClose: CalculatingCashToClose;
  getChangelogOrders?: Maybe<Array<Maybe<OrderChangelog>>>;
  getClausePackages: WrappedClausePackageResponse;
  getClauseTemplates: WrappedClauseTemplateResponse;
  getClosingCosts: ClosingCosts;
  getClosingInformation: ClosingInformation;
  getClosingQuestions: ClosingQuestions;
  getCompanyTypes?: Maybe<CompanyTypes>;
  getCurrentTenant: Tenant;
  getDcAdjustments: GetAdjustmentsResponse;
  getDepartment: Department;
  getDepartments: Array<Department>;
  getDirectoryCompanyTaxId?: Maybe<CompanyTaxId>;
  getDirectoryContactSummaries?: Maybe<Array<Maybe<ContactWithCompanySummary>>>;
  getDirectoryRecipientAccountNumber?: Maybe<CompanyRecipientAccountNumber>;
  getDocumentV2: OrderDocumentV2;
  getDocumentsForOrderV2: Array<Maybe<OrderDocumentV2>>;
  getEffectiveOrderCommissions?: Maybe<EffectiveOrderCommissions>;
  getEmailStatus: SendEmailItem;
  getEscrowAccount?: Maybe<EscrowAccount>;
  getEscrowAccountNumberAlternateProtected?: Maybe<EscrowAccountNumberAlternateProtected>;
  getEscrowAccountNumberProtected?: Maybe<EscrowAccountNumberProtected>;
  getEscrowAccounts?: Maybe<Array<Maybe<EscrowAccount>>>;
  getEstimatedTaxesInsuranceAssessments: EstimatedTaxesInsuranceAssessments;
  getFilteredTenantCompanies?: Maybe<FilteredTenantCompanies>;
  getFinalizedReconciliationBookBalanceTransactions?: Maybe<Array<Maybe<BookBalanceTransaction>>>;
  getFinalizedReconciliationEscrowTrialBalanceTransactions?: Maybe<Array<Maybe<EscrowTrialEntry>>>;
  getFinalizedReconciliationReconciledBankBalanceTransactions?: Maybe<Array<Maybe<ReconciledBankBalanceTransaction>>>;
  getFinalizedReconciliationSummary?: Maybe<ReconciliationSummary>;
  getFund?: Maybe<Fund>;
  getGfeCharges: Array<GfeCharge>;
  getHUDBorrowerCalculations: HudBorrowerCalculations;
  getInProgressReconciliationBookBalanceTransactions?: Maybe<Array<Maybe<BookBalanceTransaction>>>;
  getInProgressReconciliationEscrowTrialBalanceTransactions?: Maybe<Array<Maybe<EscrowTrialEntry>>>;
  getInProgressReconciliationReconciledBankBalanceTransactions?: Maybe<Array<Maybe<ReconciledBankBalanceTransaction>>>;
  getInProgressReconciliationSummary?: Maybe<ReconciliationSummary>;
  getInsights: Array<ReportingDashboardCategory>;
  getJacket: Jacket;
  getL3RecipientAccountNumber?: Maybe<ProtectedRecipientAccountNumber>;
  getLoanCalculationsDisclosures: LoanCalculationsDisclosures;
  getLoanDisclosures: LoanDisclosures;
  getMasterOrders: MasterOrderResponseObject;
  getMergeFieldsV2: GetMergeFieldsResponseV2;
  getNotes?: Maybe<Array<Maybe<Note>>>;
  getOrderBuyer: Buyer;
  getOrderCommissions?: Maybe<OrderCommissionsV2>;
  getOrderDeposits: OrderDeposits;
  getOrderFundsHeldByName: Scalars['String'];
  getOrderLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  getOrderMilestone?: Maybe<Milestone>;
  getOrderMilestones?: Maybe<Array<Maybe<Milestone>>>;
  getOrderPartyTaxId: ProtectedTaxId;
  getOrderSeller: Seller;
  getOrderSummaries?: Maybe<OrderSummaryConnection>;
  getOrderSummariesForL1Search?: Maybe<OrderSummaryConnection>;
  getOrderSummariesV2?: Maybe<OrderSummaryConnection>;
  getOrderTaskById?: Maybe<Task>;
  getOrderTasks?: Maybe<Array<Maybe<Task>>>;
  getOrderWorkflow?: Maybe<Workflow>;
  getPaginatedDirectoryCompanies?: Maybe<CompanySummaryConnection>;
  getPaginatedDirectoryContacts?: Maybe<ContactWithCompanySummaryConnection>;
  getPayoffs: WrappedPayoff;
  getPositivePaySubmissions?: Maybe<Array<Maybe<PositivePaySubmission>>>;
  getProductsEligibleForRemittance?: Maybe<Array<Maybe<TitleRemittableProduct>>>;
  getProjectedPayments: ProjectedPayments;
  getProrationCharge: ProrationCharge;
  getProrationCharges: Array<ProrationCharge>;
  getRFTTCities: Array<RfttCity>;
  getRFTTCounties: Array<RfttCounty>;
  getRFTTDocuments?: Maybe<Array<Maybe<RfttDocument>>>;
  getRFTTFees?: Maybe<RfttFee>;
  getRFTTPropertyTypes: Array<RfttPropertyType>;
  getRFTTQuestions?: Maybe<Array<Maybe<RfttQuestion>>>;
  getRFTTTransactionTypes: Array<RfttTransactionType>;
  getRateValidation?: Maybe<GetRateValidation>;
  getReconciliation?: Maybe<Reconciliation>;
  getReconciliationTransactions?: Maybe<Array<Maybe<Transaction>>>;
  getReconciliationTransactionsAvailable?: Maybe<Array<Maybe<Transaction>>>;
  getReconciliationTransactionsFinalized?: Maybe<Array<Maybe<Transaction>>>;
  getReconciliations?: Maybe<Array<Maybe<Reconciliation>>>;
  getRecordingFeeTransferTaxCalc: RecordingFeeTransferTaxCalc;
  getRemittanceReport: Array<TitleRemittanceReportEntry>;
  getSectionSummaryTotals: SectionSummaryTotals;
  getSecurityGroups?: Maybe<Array<SecurityGroup>>;
  getSellerSpouseTaxId: ProtectedTaxId;
  getSellerTaxId: ProtectedTaxId;
  getSequence?: Maybe<Sequence>;
  getSequences?: Maybe<Array<Maybe<Sequence>>>;
  getStaffRoles: Array<Maybe<StaffRole>>;
  getStateWithholding?: Maybe<StateWithholding>;
  getTemplateBlocks: DocumentsConnection;
  getTemplateByNameAndType: Array<Document>;
  getTemplateByNameV2: Array<Maybe<TemplateDocV2>>;
  getTemplateV2: TemplateDocV2;
  getTemplates: DocumentsConnection;
  getTemplatesV2: PaginatedTemplatesV2;
  getTenant: Tenant;
  getTenantChild: TenantChildNode;
  getTenantChildProfileImage: TenantChildProfileImage;
  getTenantChildTaxId?: Maybe<ProtectedTaxId>;
  getTenantProfileImage: TenantProfileImage;
  getTenantTaxId?: Maybe<ProtectedTaxId>;
  getTenantUnderwriters: GetTenantUnderwritersResponse;
  getTitleFees?: Maybe<TitleFees>;
  getTransaction?: Maybe<Transaction>;
  getTransactionLineDetail?: Maybe<LineDetail>;
  getTransactionLineDetailTransferTargets?: Maybe<Array<Maybe<TransactionLineDetailTransferTarget>>>;
  getTransactionLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  getTransactions?: Maybe<Array<Maybe<Transaction>>>;
  getUnderwriter: Underwriter;
  getUser: User;
  getUserNotifications?: Maybe<Array<Maybe<Notification>>>;
  getUserProfileImage: UserProfileImage;
  getUserSignatureImage: UserSignatureImage;
  getUsers?: Maybe<Array<User>>;
  getWireManagement?: Maybe<Array<Maybe<WireManagement>>>;
  mergeData: MergeData;
  mergeDataSchema?: Maybe<Scalars['JSONObject']>;
  mergeFieldsByOrgId: MergeFieldsResponse;
  order: Order;
  /** @deprecated Use getOrderSummaries */
  orderList: Array<BaseOrder>;
  orderParties: Array<OrderParty>;
  pasteConversion?: Maybe<PasteConversionResponse>;
  payeesForPBODrawer?: Maybe<Array<PartySelection>>;
  policyMetadata: PolicyMetadata;
  searchLegacyOrders?: Maybe<Array<Maybe<QuerySearchLegacyOrdersResponse>>>;
  searchOrders?: Maybe<Array<BaseOrder>>;
  searchRepositoryTemplates: RepositoryTemplateConnection;
  statementMappings?: Maybe<Array<LineTypeMapping>>;
  templateByOrgIdAndDocumentId: Document;
  titleCpls: Array<Maybe<TitleCpl>>;
  titleExceptions: TitleExceptions;
  titleGeneral: TitleGeneral;
  titlePremium: TitlePremium;
  titleRequirements: TitleRequirements;
  transactionType: TransactionType;
  transactionTypeList: Array<TransactionType>;
  underwriterList: Array<Underwriter>;
  uploadRecordingFeesDocument: UploadRecordingFeesDocumentResponse;
  verifyAddress: VerifiedAddress;
  viewer: User;
};


export type QueryClauseTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ClauseTemplateFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryDirectoryCompaniesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyIdOnOrder?: InputMaybe<Scalars['String']>;
  companyNameContains?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Scalars['String']>;
};


export type QueryDirectoryContactsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  directoryCompanyId: Scalars['String'];
};


export type QueryDirectoryDetailArgs = {
  directoryCompanyId: Scalars['ID'];
  directoryContactId?: InputMaybe<Scalars['ID']>;
};


export type QueryDocumentByOrderIdAndDocumentIdArgs = {
  documentId: Scalars['String'];
  orderId: Scalars['String'];
};


export type QueryDocumentListByOrderIdArgs = {
  id: Scalars['String'];
};


export type QueryDownloadTemplatesV2Args = {
  input: DownloadTemplateDocRequestV2Input;
};


export type QueryFeesArgs = {
  orderId: Scalars['String'];
  statementSection?: InputMaybe<Scalars['String']>;
  statementType: Scalars['String'];
};


export type QueryFluentClauseTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ClauseTemplateFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetActivityLogOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<QueryFilter>>>;
  first?: InputMaybe<Scalars['Int']>;
  orderId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetAdjustmentStatementSectionTotalsArgs = {
  orderId: Scalars['String'];
  statementSections: Array<Scalars['String']>;
  statementType: Scalars['String'];
};


export type QueryGetAdjustmentsArgs = {
  orderId: Scalars['String'];
  statementSections?: InputMaybe<Array<Scalars['String']>>;
  statementType: Scalars['String'];
};


export type QueryGetAdminMilestoneArgs = {
  includeTasks?: InputMaybe<Scalars['Boolean']>;
  milestoneId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type QueryGetAdminMilestonesArgs = {
  workflowId: Scalars['ID'];
};


export type QueryGetAdminTaskArgs = {
  milestoneId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type QueryGetAdminTasksArgs = {
  milestoneId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type QueryGetAdminWorkflowArgs = {
  workflowId: Scalars['ID'];
};


export type QueryGetAllTransactionsArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetAutocompleteResultsArgs = {
  input: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};


export type QueryGetAvailableWorkflowsArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetBuyerSpouseTaxIdArgs = {
  buyerId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryGetBuyerTaxIdArgs = {
  buyerId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryGetCalculatingCashToCloseArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetChangelogOrdersArgs = {
  orderId: Scalars['String'];
};


export type QueryGetClausePackagesArgs = {
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetClauseTemplatesArgs = {
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetClosingCostsArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetClosingInformationArgs = {
  orderId: Scalars['String'];
};


export type QueryGetClosingQuestionsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetDcAdjustmentsArgs = {
  orderId: Scalars['String'];
  statementSections?: InputMaybe<Array<Scalars['String']>>;
  statementType: Scalars['String'];
};


export type QueryGetDepartmentArgs = {
  departmentId: Scalars['ID'];
};


export type QueryGetDirectoryCompanyTaxIdArgs = {
  directoryCompanyId: Scalars['ID'];
};


export type QueryGetDirectoryRecipientAccountNumberArgs = {
  directoryCompanyId: Scalars['ID'];
};


export type QueryGetDocumentV2Args = {
  input: GetOrderDocumentV2Input;
};


export type QueryGetDocumentsForOrderV2Args = {
  input: OrderIdV2Input;
};


export type QueryGetEffectiveOrderCommissionsArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetEmailStatusArgs = {
  id: Scalars['String'];
};


export type QueryGetEscrowAccountArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetEscrowAccountNumberAlternateProtectedArgs = {
  escrowAccountId: Scalars['ID'];
};


export type QueryGetEscrowAccountNumberProtectedArgs = {
  escrowAccountId: Scalars['ID'];
};


export type QueryGetEstimatedTaxesInsuranceAssessmentsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetFilteredTenantCompaniesArgs = {
  tenantId: Scalars['ID'];
};


export type QueryGetFinalizedReconciliationBookBalanceTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetFinalizedReconciliationEscrowTrialBalanceTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetFinalizedReconciliationReconciledBankBalanceTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetFinalizedReconciliationSummaryArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetFundArgs = {
  orderId: Scalars['String'];
};


export type QueryGetGfeChargesArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetHudBorrowerCalculationsArgs = {
  orderId: Scalars['ID'];
  statementType: Scalars['String'];
};


export type QueryGetInProgressReconciliationBookBalanceTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetInProgressReconciliationEscrowTrialBalanceTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetInProgressReconciliationReconciledBankBalanceTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetInProgressReconciliationSummaryArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetJacketArgs = {
  jacketInput: JacketInput;
};


export type QueryGetL3RecipientAccountNumberArgs = {
  itemId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QueryGetLoanCalculationsDisclosuresArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetLoanDisclosuresArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetMasterOrdersArgs = {
  companyId: Scalars['ID'];
};


export type QueryGetNotesArgs = {
  appliesToId?: InputMaybe<Scalars['String']>;
  entityId: Scalars['String'];
  type: NoteEntityType;
};


export type QueryGetOrderBuyerArgs = {
  buyerId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryGetOrderCommissionsArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetOrderDepositsArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetOrderFundsHeldByNameArgs = {
  fundsHeldBy: Scalars['String'];
  orderId: Scalars['ID'];
};


export type QueryGetOrderLineDetailsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetOrderMilestoneArgs = {
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryGetOrderMilestonesArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetOrderPartyTaxIdArgs = {
  orderId: Scalars['ID'];
  partyId: Scalars['ID'];
};


export type QueryGetOrderSellerArgs = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
};


export type QueryGetOrderSummariesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<OrderSummaryFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetOrderSummariesForL1SearchArgs = {
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  useV2?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetOrderSummariesV2Args = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<OrderSummaryFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetOrderTaskByIdArgs = {
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type QueryGetOrderTasksArgs = {
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type QueryGetOrderWorkflowArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetPaginatedDirectoryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<QueryFilter>>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaginatedDirectoryContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<QueryFilter>>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetPayoffsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetPositivePaySubmissionsArgs = {
  escrowAccountId: Scalars['ID'];
};


export type QueryGetProductsEligibleForRemittanceArgs = {
  underwriterId: Scalars['String'];
};


export type QueryGetProjectedPaymentsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetProrationChargeArgs = {
  orderId: Scalars['String'];
  prorationChargeId: Scalars['String'];
};


export type QueryGetProrationChargesArgs = {
  orderId: Scalars['String'];
  prorationChargeType?: InputMaybe<Scalars['String']>;
};


export type QueryGetRfttCitiesArgs = {
  county: Scalars['String'];
  settlementDate: Scalars['String'];
  state: Scalars['String'];
};


export type QueryGetRfttCountiesArgs = {
  state: Scalars['String'];
};


export type QueryGetRfttDocumentsArgs = {
  input: GetRfttDocumentsInput;
};


export type QueryGetRfttFeesArgs = {
  input: GetRfttFeesInput;
};


export type QueryGetRfttPropertyTypesArgs = {
  settlementDate: Scalars['String'];
  state: Scalars['String'];
};


export type QueryGetRfttQuestionsArgs = {
  input: GetRfttQuestionsInput;
};


export type QueryGetRfttTransactionTypesArgs = {
  propertyType: Scalars['String'];
  settlementDate: Scalars['String'];
  state: Scalars['String'];
};


export type QueryGetRateValidationArgs = {
  orderId: Scalars['String'];
  premiumType: Scalars['String'];
};


export type QueryGetReconciliationArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetReconciliationTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetReconciliationTransactionsAvailableArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetReconciliationTransactionsFinalizedArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetReconciliationsArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetRecordingFeeTransferTaxCalcArgs = {
  orderId: Scalars['String'];
};


export type QueryGetRemittanceReportArgs = {
  remittanceDateFrom: Scalars['String'];
  remittanceDateTo: Scalars['String'];
  underwriterId: Scalars['String'];
};


export type QueryGetSectionSummaryTotalsArgs = {
  orderId: Scalars['String'];
  statementSections: Array<Scalars['String']>;
  statementType: Scalars['String'];
};


export type QueryGetSellerSpouseTaxIdArgs = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
};


export type QueryGetSellerTaxIdArgs = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
};


export type QueryGetSequenceArgs = {
  sequenceId: Scalars['ID'];
};


export type QueryGetSequencesArgs = {
  orgId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetStateWithholdingArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetTemplateBlocksArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<QueryFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetTemplateByNameAndTypeArgs = {
  fileType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  templateType: TemplateDocType;
};


export type QueryGetTemplateByNameV2Args = {
  input: GetTemplatesByNameAndFileTypeV2Input;
};


export type QueryGetTemplateV2Args = {
  input: TemplateDocTypeAndIdV2Input;
};


export type QueryGetTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<QueryFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetTemplatesV2Args = {
  input: PaginatedTemplatesQueryV2Input;
};


export type QueryGetTenantArgs = {
  id: Scalars['String'];
  permissionFilter?: InputMaybe<Scalars['String']>;
};


export type QueryGetTenantChildArgs = {
  itemId?: InputMaybe<Scalars['String']>;
};


export type QueryGetTenantChildProfileImageArgs = {
  itemId: Scalars['ID'];
};


export type QueryGetTenantChildTaxIdArgs = {
  itemId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QueryGetTenantProfileImageArgs = {
  tenantId: Scalars['ID'];
};


export type QueryGetTenantTaxIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetTitleFeesArgs = {
  orderId: Scalars['String'];
};


export type QueryGetTransactionArgs = {
  escrowAccountId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type QueryGetTransactionLineDetailArgs = {
  escrowAccountId: Scalars['String'];
  lineDetailId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type QueryGetTransactionLineDetailTransferTargetsArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetTransactionLineDetailsArgs = {
  escrowAccountId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type QueryGetTransactionsArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetUnderwriterArgs = {
  underwriterId: Scalars['ID'];
};


export type QueryGetUserArgs = {
  id: Scalars['String'];
};


export type QueryGetUserNotificationsArgs = {
  status?: InputMaybe<ReadStatus>;
};


export type QueryGetUserProfileImageArgs = {
  id: Scalars['String'];
};


export type QueryGetUserSignatureImageArgs = {
  id: Scalars['String'];
};


export type QueryGetUsersArgs = {
  l3Id?: InputMaybe<Scalars['String']>;
};


export type QueryGetWireManagementArgs = {
  escrowAccountId: Scalars['ID'];
};


export type QueryMergeDataArgs = {
  orderId: Scalars['ID'];
};


export type QueryMergeFieldsByOrgIdArgs = {
  orgId?: InputMaybe<Scalars['String']>;
};


export type QueryOrderArgs = {
  id: Scalars['ID'];
  retrieveAllParties?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOrderPartiesArgs = {
  id: Scalars['ID'];
  retrieveAllParties?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPasteConversionArgs = {
  content: Scalars['String'];
  type: Scalars['String'];
};


export type QueryPayeesForPboDrawerArgs = {
  orderId: Scalars['String'];
};


export type QueryPolicyMetadataArgs = {
  id: Scalars['ID'];
};


export type QuerySearchLegacyOrdersArgs = {
  input?: InputMaybe<QuerySearchLegacyOrdersInput>;
};


export type QuerySearchOrdersArgs = {
  orderNumber: Scalars['String'];
};


export type QuerySearchRepositoryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<QueryFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryTemplateByOrgIdAndDocumentIdArgs = {
  documentId: Scalars['String'];
  orgId?: InputMaybe<Scalars['String']>;
};


export type QueryTitleCplsArgs = {
  orderId: Scalars['ID'];
};


export type QueryTitleExceptionsArgs = {
  id: Scalars['ID'];
};


export type QueryTitleGeneralArgs = {
  id: Scalars['ID'];
};


export type QueryTitlePremiumArgs = {
  id: Scalars['ID'];
  premiumType: Scalars['String'];
};


export type QueryTitleRequirementsArgs = {
  id: Scalars['ID'];
};


export type QueryTransactionTypeArgs = {
  id: Scalars['String'];
};


export type QueryUnderwriterListArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
};


export type QueryUploadRecordingFeesDocumentArgs = {
  input: UploadRecordingFeesDocumentInput;
};


export type QueryVerifyAddressArgs = {
  formattedAddress: Scalars['String'];
};

export type QueryFilter = {
  field: Scalars['String'];
  operator: ApiFilterOperator;
  shouldFilterEmpty?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type QuerySearchLegacyOrdersInput = {
  address1?: InputMaybe<Scalars['String']>;
  parcelId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type QuerySearchLegacyOrdersResponse = {
  __typename?: 'QuerySearchLegacyOrdersResponse';
  address?: Maybe<SearchLegacyAddress>;
  buyers?: Maybe<Scalars['String']>;
  legacyOrderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  parcelIdsDisplay?: Maybe<Scalars['String']>;
  sellers?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
};

export type RfttAnswerInput = {
  value?: InputMaybe<Scalars['String']>;
};

export type RfttCity = {
  __typename?: 'RFTTCity';
  description: Scalars['String'];
  id: Scalars['String'];
};

export type RfttCounty = {
  __typename?: 'RFTTCounty';
  description: Scalars['String'];
  id: Scalars['String'];
};

export type RfttDocument = {
  __typename?: 'RFTTDocument';
  considerationAmount?: Maybe<Scalars['Float']>;
  documentName: Scalars['String'];
  documentType: Scalars['String'];
  isDefault: Scalars['Boolean'];
  numberOfPages?: Maybe<Scalars['Float']>;
};

export type RfttFee = {
  __typename?: 'RFTTFee';
  recordingFees: RfttRecordingFees;
  transferTaxes: RfttTransferTaxes;
};

export type RfttPropertyType = {
  __typename?: 'RFTTPropertyType';
  description: Scalars['String'];
  id: Scalars['String'];
};

export type RfttQuestion = {
  __typename?: 'RFTTQuestion';
  defaultAnswer?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  options?: Maybe<Array<RfttQuestionOption>>;
  providerMetadata: RfttQuestionProviderMetadata;
  questionText?: Maybe<Scalars['String']>;
  shouldPrompt: Scalars['Boolean'];
  valueType?: Maybe<Scalars['String']>;
};

export type RfttQuestionOption = {
  __typename?: 'RFTTQuestionOption';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type RfttQuestionOptionInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type RfttQuestionProviderMetadata = {
  __typename?: 'RFTTQuestionProviderMetadata';
  lvis: RfttQuestionProviderMetadataLvis;
};

export type RfttQuestionProviderMetadataInput = {
  lvis: RfttQuestionProviderMetadataLvisInput;
};

export type RfttQuestionProviderMetadataLvis = {
  __typename?: 'RFTTQuestionProviderMetadataLVIS';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type RfttQuestionProviderMetadataLvisInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type RfttRecordingFeeItem = {
  __typename?: 'RFTTRecordingFeeItem';
  buyerAmount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  sellerAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type RfttRecordingFees = {
  __typename?: 'RFTTRecordingFees';
  items: Array<RfttRecordingFeeItem>;
  payee?: Maybe<Scalars['String']>;
};

export type RfttTransactionType = {
  __typename?: 'RFTTTransactionType';
  description: Scalars['String'];
  id: Scalars['String'];
};

export type RfttTransferTaxItem = {
  __typename?: 'RFTTTransferTaxItem';
  buyerAmount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  payee?: Maybe<Scalars['String']>;
  sellerAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type RfttTransferTaxes = {
  __typename?: 'RFTTTransferTaxes';
  items: Array<RfttTransferTaxItem>;
};

export type RateValidation = {
  missingFields: Array<Scalars['String']>;
  orderId: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type RateValidationRequest = {
  lenderPolicy?: InputMaybe<PolicyRateValidationRequest>;
  ownerPolicy?: InputMaybe<PolicyRateValidationRequest>;
  priorPolicyAmount?: InputMaybe<Scalars['Float']>;
  priorPolicyCoverageType?: InputMaybe<Scalars['String']>;
  simultaneousIssue?: InputMaybe<Scalars['Boolean']>;
};

export enum ReadStatus {
  Read = 'read',
  Unread = 'unread'
}

export type ReceivingBankInput = {
  address?: InputMaybe<AddressInput>;
  bankIdNumber?: InputMaybe<Scalars['String']>;
  bankIdType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  obiLine1?: InputMaybe<Scalars['String']>;
  obiLine2?: InputMaybe<Scalars['String']>;
  obiLine3?: InputMaybe<Scalars['String']>;
  obiLine4?: InputMaybe<Scalars['String']>;
};

export type ReceivingBankSchema = {
  __typename?: 'ReceivingBankSchema';
  address?: Maybe<Address>;
  bankIdNumber?: Maybe<Scalars['String']>;
  bankIdType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  obiLine1?: Maybe<Scalars['String']>;
  obiLine2?: Maybe<Scalars['String']>;
  obiLine3?: Maybe<Scalars['String']>;
  obiLine4?: Maybe<Scalars['String']>;
};

export type ReconciledBankBalanceTransaction = {
  __typename?: 'ReconciledBankBalanceTransaction';
  amount?: Maybe<Scalars['Float']>;
  orderNumber?: Maybe<Scalars['String']>;
  payorPayeeId?: Maybe<Scalars['String']>;
  payorPayeeName?: Maybe<Scalars['String']>;
  transactionCategory?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  typeOfFunds?: Maybe<Scalars['String']>;
};

export type Reconciliation = {
  __typename?: 'Reconciliation';
  bankName?: Maybe<Scalars['String']>;
  beginningBalance?: Maybe<Scalars['Float']>;
  clearedBalance?: Maybe<Scalars['Float']>;
  completedAt?: Maybe<Scalars['String']>;
  completedByDisplayName?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  createdTimestamp?: Maybe<Scalars['String']>;
  difference?: Maybe<Scalars['Float']>;
  eligibleTransactions?: Maybe<Array<Maybe<Transaction>>>;
  endingDate?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  escrowAccountName?: Maybe<Scalars['String']>;
  escrowAcctName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  statementEndingBalance?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<ReconciliationSummary>;
  transactionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedBy?: Maybe<User>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export enum ReconciliationStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type ReconciliationSummary = {
  __typename?: 'ReconciliationSummary';
  bankEndingBalance: Scalars['Float'];
  bookBalanceTotal: Scalars['Float'];
  escrowTrialBalanceTotal: Scalars['Float'];
  previousReconciliationEndingBalance: Scalars['Float'];
  reconciledBankBalanceTotal: Scalars['Float'];
  reconciliationId: Scalars['String'];
  totalDisbursements: Scalars['Float'];
  totalOutstandingDisbursements: Scalars['Float'];
  totalOutstandingReceipts: Scalars['Float'];
  totalReceipts: Scalars['Float'];
};

export type RecordingFeeAdditionalData = {
  __typename?: 'RecordingFeeAdditionalData';
  externalCalculatorLineItemId?: Maybe<Scalars['String']>;
  providerType?: Maybe<Scalars['String']>;
  rfttFeeLineType?: Maybe<Scalars['String']>;
};

export type RecordingFeeCalculatorLineItem = {
  __typename?: 'RecordingFeeCalculatorLineItem';
  amount?: Maybe<Scalars['Float']>;
  amountFallback?: Maybe<Scalars['Float']>;
  buyerAmount?: Maybe<Scalars['Float']>;
  buyerAmountFallback?: Maybe<Scalars['Float']>;
  buyerPercentage?: Maybe<Scalars['Float']>;
  default?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameFallback?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  sellerAmount?: Maybe<Scalars['Float']>;
  sellerPercentage?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type RecordingFeeCalculatorLineItemInput = {
  amount?: InputMaybe<Scalars['Float']>;
  buyerPercentage?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type RecordingFeeLineItem = {
  __typename?: 'RecordingFeeLineItem';
  recordingDocumentAmount?: Maybe<Scalars['Float']>;
  recordingDocumentBuyerPaysAmount?: Maybe<Scalars['Float']>;
  recordingDocumentBuyerPaysPercent?: Maybe<Scalars['Float']>;
  recordingDocumentName?: Maybe<Scalars['String']>;
  recordingDocumentSellerPaysAmount?: Maybe<Scalars['Float']>;
  recordingDocumentSellerPaysPercent?: Maybe<Scalars['Float']>;
};

export type RecordingFeeTransferTax = {
  __typename?: 'RecordingFeeTransferTax';
  recordingFeeLineItems?: Maybe<Array<Maybe<RecordingFeeLineItem>>>;
  recordingFeesPayee?: Maybe<RecordingFeesPayee>;
  recordingFeesTotalAmount?: Maybe<Scalars['Float']>;
  recordingFeesTotalBuyerAmount?: Maybe<Scalars['Float']>;
  recordingFeesTotalPboAmount?: Maybe<Scalars['Float']>;
  recordingFeesTotalSellerAmount?: Maybe<Scalars['Float']>;
};

export type RecordingFeeTransferTaxCalc = {
  __typename?: 'RecordingFeeTransferTaxCalc';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<IntegratedRfttDocument>>>;
  documentsParams?: Maybe<IntegratedRfttDocumentsParams>;
  providerType?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<IntegratedRfttQuestion>>>;
  recordingFees: RecordingFees;
  transferTaxes: TransferTaxes;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type RecordingFees = {
  __typename?: 'RecordingFees';
  lineItems: Array<RecordingFeeCalculatorLineItem>;
  payeeId?: Maybe<Scalars['String']>;
  payeeSuggested?: Maybe<Scalars['String']>;
};

export type RecordingFeesInput = {
  lineItems?: InputMaybe<Array<InputMaybe<RecordingFeeCalculatorLineItemInput>>>;
  payeeId?: InputMaybe<Scalars['String']>;
};

export type RecordingFeesPayee = {
  __typename?: 'RecordingFeesPayee';
  payeeAddress?: Maybe<Scalars['String']>;
  payeeCityStateZip?: Maybe<Scalars['String']>;
  payeeDirectoryCompanyReferenceId?: Maybe<Scalars['String']>;
  payeeEmailAddress?: Maybe<Scalars['String']>;
  payeeId?: Maybe<Scalars['String']>;
  payeeName?: Maybe<Scalars['String']>;
  payeePhone?: Maybe<Scalars['String']>;
  payeeRoleId?: Maybe<Scalars['String']>;
  payeeTaxId?: Maybe<Scalars['String']>;
  payeeTaxIdType?: Maybe<Scalars['String']>;
};

export type RefMetaData = {
  __typename?: 'RefMetaData';
  refItemAmount?: Maybe<Scalars['Float']>;
  refItemId?: Maybe<Scalars['String']>;
  refItemType?: Maybe<Scalars['String']>;
  refItemUpdatedTimestamp?: Maybe<Scalars['String']>;
};

export type RefMetaDataInput = {
  refItemAmount?: InputMaybe<Scalars['Float']>;
  refItemId?: InputMaybe<Scalars['String']>;
  refItemType?: InputMaybe<Scalars['String']>;
  refItemUpdatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type RefreshCommissionsInput = {
  orderId: Scalars['String'];
  statementSection: Scalars['String'];
  statementType: Scalars['String'];
};

export type RefreshDepositsForAdjustmentsInput = {
  orderId: Scalars['String'];
  statementSections?: InputMaybe<Array<Scalars['String']>>;
  statementType: Scalars['String'];
};

export type RefreshDepositsForFeesInput = {
  orderId: Scalars['String'];
  statementSection: Scalars['String'];
  statementType: Scalars['String'];
};

export type RefreshPremiumsAndFeesInput = {
  orderId: Scalars['String'];
  statementSection: Scalars['String'];
  statementType: Scalars['String'];
};

/** These fields are required to update the OrderParty, but their values will not be included in the update. - deprecated (Use UpdateOrderPartyInput instead) */
export type ReplacePartyCompanyAndContactMetadata = {
  isSettlementUseOnly?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['ID'];
  partyId: Scalars['ID'];
  /** This field is required to correctly identify the OrderParty. It will be removed once an OrderParty can be identified by its ID alone. */
  refSectionId?: InputMaybe<Scalars['String']>;
  /** This field is required to correctly identify the OrderParty. It will be removed once an OrderParty can be identified by its ID alone. */
  refSectionLabel?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

/** These are the only properties that will be updated on the OrderParty - deprecated (Use CreateOrderPartyInput or UpdateOrderPartyInput instead) */
export type ReplacePartyCompanyAndContactPayload = {
  directoryCompanyId?: InputMaybe<Scalars['String']>;
  directoryContactId?: InputMaybe<Scalars['String']>;
};

export type ReplacePartyCompanyAndContactResult = {
  __typename?: 'ReplacePartyCompanyAndContactResult';
  party?: Maybe<OrderParty>;
};

export type ReportingDashboard = {
  __typename?: 'ReportingDashboard';
  exploId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  sortIndex: Scalars['Int'];
  type: Scalars['String'];
};

export type ReportingDashboardCategory = {
  __typename?: 'ReportingDashboardCategory';
  dashboards: Array<ReportingDashboard>;
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  sortIndex: Scalars['Int'];
};

export type RepositoryTemplate = Node & {
  __typename?: 'RepositoryTemplate';
  bucket: Scalars['String'];
  categories: Array<Scalars['String']>;
  createdTimestamp: Scalars['DateTime'];
  description: Scalars['String'];
  filePath?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  fileVersionId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importedBlocks: Array<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  states: Array<Scalars['String']>;
  templateType: Scalars['String'];
  underwriters: Array<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type RepositoryTemplateConnection = Connection & {
  __typename?: 'RepositoryTemplateConnection';
  edges: Array<RepositoryTemplateEdge>;
  pageInfo: PageInfo;
};

export type RepositoryTemplateEdge = Edge & {
  __typename?: 'RepositoryTemplateEdge';
  node: RepositoryTemplate;
};

export type Requirement = {
  __typename?: 'Requirement';
  bodyContent?: Maybe<Scalars['String']>;
  bodyTemplate: Scalars['String'];
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  id: Scalars['String'];
  libraryId?: Maybe<Scalars['String']>;
  mergeFields?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  requirementFamilyMergeable?: Maybe<Scalars['String']>;
  requirementMergeable?: Maybe<Scalars['String']>;
  requirements?: Maybe<Array<Maybe<Requirement>>>;
  title: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type RequirementReference = {
  requirementId: Scalars['String'];
  requirements?: InputMaybe<Array<InputMaybe<RequirementReference>>>;
};

export type Restriction = {
  __typename?: 'Restriction';
  domain: Scalars['String'];
  reasonCode: Scalars['String'];
  resourceId: Scalars['String'];
  restrictionType: Scalars['String'];
};

export enum SdnRecordType {
  Buyer = 'buyer',
  BuyerEntity = 'buyerEntity',
  BuyerRepresentative = 'buyerRepresentative',
  BuyerSpouse = 'buyerSpouse',
  Seller = 'seller',
  SellerEntity = 'sellerEntity',
  SellerRepresentative = 'sellerRepresentative',
  SellerSpouse = 'sellerSpouse'
}

export type SdnStatusDetails = {
  __typename?: 'SdnStatusDetails';
  additionalDetails?: Maybe<Scalars['String']>;
  dateSearched: Scalars['DateTime'];
  nameSearched: Scalars['String'];
  sdnSearchResult: Scalars['String'];
};

export type SearchLegacyAddress = {
  __typename?: 'SearchLegacyAddress';
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type SecondaryParty = {
  __typename?: 'SecondaryParty';
  address: Scalars['String'];
  city: Scalars['String'];
  county: Scalars['String'];
  secondaryId: Scalars['String'];
  secondaryName: Scalars['String'];
  secondaryRoleType: Scalars['String'];
  state: Scalars['String'];
  underwriterId: Scalars['ID'];
  zip: Scalars['String'];
};

export type SectionMapping = {
  __typename?: 'SectionMapping';
  altaSection?: Maybe<Scalars['String']>;
  cdSection?: Maybe<Scalars['String']>;
  hud1986Section?: Maybe<Scalars['String']>;
  hud2010Section?: Maybe<Scalars['String']>;
};

export type SectionMappingInput = {
  altaSection?: InputMaybe<Scalars['String']>;
  cdSection?: InputMaybe<Scalars['String']>;
  hud1986Section?: InputMaybe<Scalars['String']>;
  hud2010Section?: InputMaybe<Scalars['String']>;
};

export type SectionSummariesTotals = AltaSectionSummaryTotals | SectionSummariesTotalsWithSeller | SectionSummariesTotalsWithoutSeller;

export type SectionSummariesTotalsWithSeller = {
  __typename?: 'SectionSummariesTotalsWithSeller';
  borrowerCalcTotal: Scalars['Float'];
  sellerCalcTotal: Scalars['Float'];
  totalDueFromBorrower: Scalars['Float'];
  totalDueFromSeller: Scalars['Float'];
  totalDueToSeller: Scalars['Float'];
  totalPaidByBorrower: Scalars['Float'];
};

export type SectionSummariesTotalsWithoutSeller = {
  __typename?: 'SectionSummariesTotalsWithoutSeller';
  borrowerCalcTotal: Scalars['Float'];
  totalDueFromBorrower: Scalars['Float'];
  totalPaidByBorrower: Scalars['Float'];
};

export type SectionSummaryDebitsAndCredits = {
  __typename?: 'SectionSummaryDebitsAndCredits';
  section?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

export type SectionSummaryDebitsAndCreditsInput = {
  orderId: Scalars['String'];
  statementSections?: InputMaybe<Array<Scalars['String']>>;
  statementType: Scalars['String'];
};

export type SectionSummaryTotals = {
  __typename?: 'SectionSummaryTotals';
  borrowerPaidAt?: Maybe<Scalars['Float']>;
  borrowerPaidBefore?: Maybe<Scalars['Float']>;
  pboBorrowerAmount?: Maybe<Scalars['Float']>;
  pboSellerAmount?: Maybe<Scalars['Float']>;
  pboTotal?: Maybe<Scalars['Float']>;
  sellerPaidAt?: Maybe<Scalars['Float']>;
  sellerPaidBefore?: Maybe<Scalars['Float']>;
};

export type SecurityGroup = {
  __typename?: 'SecurityGroup';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isDeleteRestricted: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Scalars['JSONObject']>;
  type?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type SecurityGroupAssignment = {
  __typename?: 'SecurityGroupAssignment';
  orgIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  securityGroupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  securityGroups?: Maybe<Array<Maybe<SecurityGroup>>>;
};

export type SecurityGroupAssignments = {
  __typename?: 'SecurityGroupAssignments';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  securityAssignments?: Maybe<Array<Maybe<SecurityGroupAssignment>>>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type SecurityGroupV2Assignment = {
  __typename?: 'SecurityGroupV2Assignment';
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  permissions?: Maybe<Scalars['String']>;
  securityGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SecurityGroupV2Assignments = {
  __typename?: 'SecurityGroupV2Assignments';
  adminPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  applicationPermissions?: Maybe<Scalars['JSONObject']>;
};

export type SecurityGroupV2AssignmentsInput = {
  adminPermissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applicationPermissions?: InputMaybe<Scalars['JSONObject']>;
};

export type Seller = OrderBuyerSeller & {
  __typename?: 'Seller';
  address?: Maybe<Address>;
  alias?: Maybe<Scalars['String']>;
  allFullNames?: Maybe<Scalars['String']>;
  buyerSellerId?: Maybe<Scalars['ID']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayNameMetadata?: Maybe<OverrideMetadataString>;
  emailAddresses?: Maybe<Array<Maybe<BuyerSellerEmailAddress>>>;
  entityDateOfAgreement?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  entityStateOfAgreement?: Maybe<Scalars['String']>;
  excludeFromLoan?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  forwardingAddress?: Maybe<Address>;
  forwardingAddressSameAsCurrentAddress?: Maybe<Scalars['Boolean']>;
  forwardingAddressSameAsPropertyAddress?: Maybe<Scalars['Boolean']>;
  forwardingRegion?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasPowerOfAttorney?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isForeignAddress?: Maybe<Scalars['Boolean']>;
  isForeignForwardingAddress?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  ownershipPercentage?: Maybe<Scalars['Float']>;
  ownershipPercentageMetadata?: Maybe<OverrideMetadataNumber>;
  phoneNumbers?: Maybe<Array<Maybe<BuyerSellerPhoneNumber>>>;
  powerOfAttorney?: Maybe<PowerOfAttorney>;
  recordName?: Maybe<BuyerSellerRecordName>;
  representatives?: Maybe<Array<OrderBuyerSellerSoRep>>;
  representativesAllNames?: Maybe<Scalars['String']>;
  representativesAllNamesWithCapacity?: Maybe<Scalars['String']>;
  sdnStatus?: Maybe<Scalars['String']>;
  sdnStatusDetails?: Maybe<SdnStatusDetails>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  signingName?: Maybe<Scalars['String']>;
  signingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  spouse?: Maybe<OrderBuyerSellerSoRep>;
  suffix?: Maybe<Scalars['String']>;
  taxIdFormatted?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  ten99?: Maybe<Ten99SellerRecord>;
  title?: Maybe<Scalars['String']>;
  typeOfBuyerSeller?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type SendEmailAddress = {
  address: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type SendEmailAttachment = {
  contentType?: InputMaybe<Scalars['String']>;
  contentUri: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type SendEmailItem = Node & {
  __typename?: 'SendEmailItem';
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status?: Maybe<SendEmailStatus>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type SendEmailItemBody = {
  content: Scalars['String'];
  contentType?: InputMaybe<Scalars['String']>;
};

export type SendEmailRecipient = {
  emailAddress: SendEmailAddress;
};

export type SendEmailRequest = {
  attachments?: InputMaybe<Array<SendEmailAttachment>>;
  bccRecipients?: InputMaybe<Array<SendEmailRecipient>>;
  body: SendEmailItemBody;
  bodyPreview?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  ccRecipients?: InputMaybe<Array<SendEmailRecipient>>;
  subject: Scalars['String'];
  toRecipients?: InputMaybe<Array<SendEmailRecipient>>;
};

export type SendEmailRequestInput = {
  attachments?: InputMaybe<Array<SendEmailAttachment>>;
  bccRecipients?: InputMaybe<Array<SendEmailRecipient>>;
  body: SendEmailItemBody;
  bodyPreview?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  ccRecipients?: InputMaybe<Array<SendEmailRecipient>>;
  from?: InputMaybe<SendEmailRecipient>;
  replyTo?: InputMaybe<Array<SendEmailRecipient>>;
  sender?: InputMaybe<SendEmailRecipient>;
  subject: Scalars['String'];
  toRecipients?: InputMaybe<Array<SendEmailRecipient>>;
};

export enum SendEmailStatus {
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type Sequence = {
  __typename?: 'Sequence';
  availableIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  currentSequenceNumber?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  numberOfDigitsInSequence?: Maybe<Scalars['Int']>;
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  sequenceName?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type SmartyStreetConfiguration = {
  __typename?: 'SmartyStreetConfiguration';
  apiKey?: Maybe<Scalars['String']>;
};

export type SplitConfiguration = {
  __typename?: 'SplitConfiguration';
  cpl: BuyerSellerSplitConfiguration;
  lenderPolicy: BuyerSellerSplitConfiguration;
  ownerPolicy: BuyerSellerSplitConfiguration;
  sellerCpl?: Maybe<BuyerSellerSplitConfiguration>;
};

export type SplitConfigurationSchema = {
  cpl: BuyerSellerSplitValueInput;
  lenderPolicy: BuyerSellerSplitValueInput;
  ownerPolicy: BuyerSellerSplitValueInput;
  sellerCpl?: InputMaybe<BuyerSellerSplitValueInput>;
};

export type SplitTransactionDetailsResponse = {
  __typename?: 'SplitTransactionDetailsResponse';
  escrowAccountId?: Maybe<Scalars['String']>;
  originLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  originTransaction?: Maybe<Transaction>;
  targetLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  targetTransaction?: Maybe<Transaction>;
};

export type SplitTransactionInput = {
  escrowAccountId: Scalars['String'];
  originLineDetails?: InputMaybe<Array<InputMaybe<UpdateLineDetailInput>>>;
  originTransaction?: InputMaybe<UpdateTransactionTransferInput>;
  targetLineDetails?: InputMaybe<Array<InputMaybe<UpdateLineDetailInput>>>;
};

export type StaffRole = {
  __typename?: 'StaffRole';
  active: Scalars['Boolean'];
  canToggleActive: Scalars['Boolean'];
  id: Scalars['ID'];
  prioritySorted: Scalars['Boolean'];
  role: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type StaffRolePatchInput = {
  active: Scalars['Boolean'];
  updatedTimestamp: Scalars['String'];
};

export type StandardEscrowFeeAdditionalData = {
  __typename?: 'StandardEscrowFeeAdditionalData';
  amountPerMonth?: Maybe<Scalars['Float']>;
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type StateDetail = {
  __typename?: 'StateDetail';
  abbreviation?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type StateDetailInput = {
  abbreviation?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type StateObjectV2 = {
  __typename?: 'StateObjectV2';
  abbreviation: Scalars['String'];
  name: Scalars['String'];
};

export type StateObjectV2Input = {
  abbreviation: Scalars['String'];
  name: Scalars['String'];
};

export type StateSplitConfiguration = {
  __typename?: 'StateSplitConfiguration';
  AK: SplitConfiguration;
  AL: SplitConfiguration;
  AR: SplitConfiguration;
  AZ: SplitConfiguration;
  CA: SplitConfiguration;
  CO: SplitConfiguration;
  CT: SplitConfiguration;
  DC: SplitConfiguration;
  DE: SplitConfiguration;
  FL: SplitConfiguration;
  GA: SplitConfiguration;
  HI: SplitConfiguration;
  IA: SplitConfiguration;
  ID: SplitConfiguration;
  IL: SplitConfiguration;
  IN: SplitConfiguration;
  KS: SplitConfiguration;
  KY: SplitConfiguration;
  LA: SplitConfiguration;
  MA: SplitConfiguration;
  MD: SplitConfiguration;
  ME: SplitConfiguration;
  MI: SplitConfiguration;
  MN: SplitConfiguration;
  MO: SplitConfiguration;
  MS: SplitConfiguration;
  MT: SplitConfiguration;
  NC: SplitConfiguration;
  ND: SplitConfiguration;
  NE: SplitConfiguration;
  NH: SplitConfiguration;
  NJ: SplitConfiguration;
  NM: SplitConfiguration;
  NV: SplitConfiguration;
  NY: SplitConfiguration;
  OH: SplitConfiguration;
  OK: SplitConfiguration;
  OR: SplitConfiguration;
  PA: SplitConfiguration;
  RI: SplitConfiguration;
  SC: SplitConfiguration;
  SD: SplitConfiguration;
  TN: SplitConfiguration;
  TX: SplitConfiguration;
  UT: SplitConfiguration;
  VA: SplitConfiguration;
  VT: SplitConfiguration;
  WA: SplitConfiguration;
  WI: SplitConfiguration;
  WV: SplitConfiguration;
  WY: SplitConfiguration;
};

export type StateSplitInput = {
  AK: SplitConfigurationSchema;
  AL: SplitConfigurationSchema;
  AR: SplitConfigurationSchema;
  AZ: SplitConfigurationSchema;
  CA: SplitConfigurationSchema;
  CO: SplitConfigurationSchema;
  CT: SplitConfigurationSchema;
  DC: SplitConfigurationSchema;
  DE: SplitConfigurationSchema;
  FL: SplitConfigurationSchema;
  GA: SplitConfigurationSchema;
  HI: SplitConfigurationSchema;
  IA: SplitConfigurationSchema;
  ID: SplitConfigurationSchema;
  IL: SplitConfigurationSchema;
  IN: SplitConfigurationSchema;
  KS: SplitConfigurationSchema;
  KY: SplitConfigurationSchema;
  LA: SplitConfigurationSchema;
  MA: SplitConfigurationSchema;
  MD: SplitConfigurationSchema;
  ME: SplitConfigurationSchema;
  MI: SplitConfigurationSchema;
  MN: SplitConfigurationSchema;
  MO: SplitConfigurationSchema;
  MS: SplitConfigurationSchema;
  MT: SplitConfigurationSchema;
  NC: SplitConfigurationSchema;
  ND: SplitConfigurationSchema;
  NE: SplitConfigurationSchema;
  NH: SplitConfigurationSchema;
  NJ: SplitConfigurationSchema;
  NM: SplitConfigurationSchema;
  NV: SplitConfigurationSchema;
  NY: SplitConfigurationSchema;
  OH: SplitConfigurationSchema;
  OK: SplitConfigurationSchema;
  OR: SplitConfigurationSchema;
  PA: SplitConfigurationSchema;
  RI: SplitConfigurationSchema;
  SC: SplitConfigurationSchema;
  SD: SplitConfigurationSchema;
  TN: SplitConfigurationSchema;
  TX: SplitConfigurationSchema;
  UT: SplitConfigurationSchema;
  VA: SplitConfigurationSchema;
  VT: SplitConfigurationSchema;
  WA: SplitConfigurationSchema;
  WI: SplitConfigurationSchema;
  WV: SplitConfigurationSchema;
  WY: SplitConfigurationSchema;
};

export type StateWithholding = {
  __typename?: 'StateWithholding';
  closingCostsAmount?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  oTotalWithholdingBasis?: Maybe<Scalars['Float']>;
  payoffsAmount?: Maybe<Scalars['Float']>;
  payorPayeeId?: Maybe<Scalars['String']>;
  personalPropertyAmount?: Maybe<Scalars['Float']>;
  salesPriceAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<StateWithholdingSellerValues>>>;
  totalWithholdingBasis?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type StateWithholdingSellerValues = {
  __typename?: 'StateWithholdingSellerValues';
  amountDue?: Maybe<Scalars['Float']>;
  displayName?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  sellerRefId: Scalars['String'];
  withholdingBasis?: Maybe<Scalars['Float']>;
};

export type StateWithholdingSellerValuesInput = {
  sellerRefId: Scalars['String'];
};

export type StatementClosingInformation = {
  __typename?: 'StatementClosingInformation';
  closingDate?: Maybe<Scalars['String']>;
  dateIssued?: Maybe<Scalars['String']>;
  disbursementDate?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyCityStateZip?: Maybe<Scalars['String']>;
  salePrice?: Maybe<Scalars['Float']>;
  salePriceLabel?: Maybe<Scalars['String']>;
  settlementAgentCompanyName?: Maybe<Scalars['String']>;
};

export type StatementLineItemAdjustmentRow = {
  __typename?: 'StatementLineItemAdjustmentRow';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['String']>;
  subheader?: Maybe<Scalars['String']>;
};

export type StatementLineItemAdjustmentSection = {
  __typename?: 'StatementLineItemAdjustmentSection';
  items?: Maybe<Array<Maybe<StatementLineItemAdjustmentRow>>>;
  total?: Maybe<Scalars['Float']>;
};

export type StatementLineItemAmountFee = {
  __typename?: 'StatementLineItemAmountFee';
  bpa?: Maybe<Scalars['Float']>;
  bpb?: Maybe<Scalars['Float']>;
  pbo?: Maybe<Scalars['Float']>;
  spa?: Maybe<Scalars['Float']>;
  spb?: Maybe<Scalars['Float']>;
};

export type StatementLineItemFee = {
  __typename?: 'StatementLineItemFee';
  bpa?: Maybe<Scalars['Float']>;
  bpb?: Maybe<Scalars['Float']>;
  descriptionAndPayee?: Maybe<Scalars['String']>;
  pbKey?: Maybe<Scalars['String']>;
  pbo?: Maybe<Scalars['Float']>;
  rowNumber?: Maybe<Scalars['String']>;
  spa?: Maybe<Scalars['Float']>;
  spb?: Maybe<Scalars['Float']>;
};

export type StatementLineItemSection = {
  __typename?: 'StatementLineItemSection';
  items?: Maybe<Array<Maybe<StatementLineItemFee>>>;
  total?: Maybe<Scalars['Float']>;
};

export type StatementLoanInformation = {
  __typename?: 'StatementLoanInformation';
  loanNumber?: Maybe<Scalars['String']>;
  loanTerm?: Maybe<Scalars['String']>;
  loanType?: Maybe<Scalars['String']>;
  loanTypeIsOther?: Maybe<Scalars['Boolean']>;
  micNumber?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
};

export type StatementLoanTerms = {
  __typename?: 'StatementLoanTerms';
  balloonPayment?: Maybe<StatementLoanTermsBalloonPayment>;
  interestRate?: Maybe<StatementLoanTermsInterestRate>;
  loanAmount?: Maybe<StatementLoanTermsLoanAmount>;
  monthlyPrincipalAndInterest?: Maybe<StatementLoanTermsMonthlyPrincipalAndInterest>;
  prepaymentPenalty?: Maybe<StatementLoanTermsPrepaymentPenalty>;
};

export type StatementLoanTermsBalloonPayment = {
  __typename?: 'StatementLoanTermsBalloonPayment';
  response?: Maybe<Scalars['Boolean']>;
  sentences?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StatementLoanTermsInterestRate = {
  __typename?: 'StatementLoanTermsInterestRate';
  response?: Maybe<Scalars['Boolean']>;
  sentences?: Maybe<Array<Maybe<Scalars['String']>>>;
  value?: Maybe<Scalars['Float']>;
};

export type StatementLoanTermsLoanAmount = {
  __typename?: 'StatementLoanTermsLoanAmount';
  response?: Maybe<Scalars['Boolean']>;
  sentences?: Maybe<Array<Maybe<Scalars['String']>>>;
  value?: Maybe<Scalars['Float']>;
};

export type StatementLoanTermsMonthlyPrincipalAndInterest = {
  __typename?: 'StatementLoanTermsMonthlyPrincipalAndInterest';
  response?: Maybe<Scalars['Boolean']>;
  sentences?: Maybe<Array<Maybe<Scalars['String']>>>;
  value?: Maybe<Scalars['Float']>;
};

export type StatementLoanTermsPrepaymentPenalty = {
  __typename?: 'StatementLoanTermsPrepaymentPenalty';
  response?: Maybe<Scalars['Boolean']>;
  sentences?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StatementSections = {
  __typename?: 'StatementSections';
  sections?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StatementTransactionInformation = {
  __typename?: 'StatementTransactionInformation';
  borrowerAddress?: Maybe<Scalars['String']>;
  borrowerCityStateZip?: Maybe<Scalars['String']>;
  borrowerNames?: Maybe<Scalars['String']>;
  lenderCompanyName?: Maybe<Scalars['String']>;
  sellerAddress?: Maybe<Scalars['String']>;
  sellerCityStateZip?: Maybe<Scalars['String']>;
  sellerNames?: Maybe<Scalars['String']>;
};

export type SwitchRecordingFeeTransferTaxCalculatorInput = {
  orderId: Scalars['String'];
  providerType: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type System = {
  __typename?: 'System';
  user?: Maybe<User>;
};

export type Task = {
  __typename?: 'Task';
  active?: Maybe<Scalars['Boolean']>;
  assignedTo?: Maybe<Scalars['String']>;
  assignedToMetadata?: Maybe<TaskMetadata>;
  assignment?: Maybe<TaskAssignment>;
  completedBy?: Maybe<User>;
  completedById?: Maybe<Scalars['ID']>;
  completedTimestamp?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  due?: Maybe<TaskDue>;
  dueDate?: Maybe<Scalars['String']>;
  dueDateMetadata?: Maybe<TaskMetadata>;
  id?: Maybe<Scalars['String']>;
  milestoneId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  recordType?: Maybe<Scalars['String']>;
  sortIndex: Scalars['Int'];
  start?: Maybe<TaskStart>;
  startDate?: Maybe<Scalars['String']>;
  startDateMetadata?: Maybe<TaskMetadata>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type TaskAssignment = {
  __typename?: 'TaskAssignment';
  personReference?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  typeReference: Scalars['String'];
};

export type TaskAssignmentInput = {
  personReference?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  typeReference: Scalars['String'];
};

export type TaskDue = {
  __typename?: 'TaskDue';
  basis: Scalars['String'];
  days: Scalars['Int'];
  type: Scalars['String'];
};

export type TaskDueInput = {
  basis: Scalars['String'];
  days: Scalars['Int'];
  type: Scalars['String'];
};

export type TaskMetadata = {
  __typename?: 'TaskMetadata';
  effectiveValue?: Maybe<Scalars['String']>;
  fallbackValue?: Maybe<Scalars['String']>;
  overridden?: Maybe<Scalars['Boolean']>;
  overrideValue?: Maybe<Scalars['String']>;
};

export type TaskStart = {
  __typename?: 'TaskStart';
  reference?: Maybe<Scalars['String']>;
  when: Scalars['String'];
};

export type TaskStartInput = {
  reference?: InputMaybe<Scalars['String']>;
  when: Scalars['String'];
};

export type TemplateAttributes = {
  __typename?: 'TemplateAttributes';
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  states?: Maybe<Array<Maybe<StateDetail>>>;
  underwriters?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TemplateAttributesInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  states?: InputMaybe<Array<InputMaybe<StateDetailInput>>>;
  underwriters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateAttributesV2 = {
  __typename?: 'TemplateAttributesV2';
  categories?: Maybe<Array<Scalars['String']>>;
  orgIds?: Maybe<Array<Scalars['String']>>;
  states?: Maybe<Array<StateObjectV2>>;
  underwriters?: Maybe<Array<Scalars['String']>>;
};

export type TemplateAttributesV2Input = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  orgIds?: InputMaybe<Array<Scalars['String']>>;
  states?: InputMaybe<Array<StateObjectV2Input>>;
  underwriters?: InputMaybe<Array<Scalars['String']>>;
};

export type TemplateDocIdV2Input = {
  documentId: Scalars['ID'];
};

export enum TemplateDocType {
  Block = 'Block',
  Template = 'Template'
}

export type TemplateDocTypeAndIdV2Input = {
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
};

export enum TemplateDocTypeV2 {
  Block = 'Block',
  Template = 'Template'
}

export type TemplateDocV2 = {
  __typename?: 'TemplateDocV2';
  attributes: TemplateAttributesV2;
  createdBy: UserDisplayNameV2;
  createdTimestamp: Scalars['String'];
  description: Scalars['String'];
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
  fileSrc?: Maybe<FileUrlSourceV2>;
  fileType: Scalars['String'];
  id: Scalars['ID'];
  isReadOnly: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  query?: Maybe<Scalars['String']>;
  sourceTemplateId?: Maybe<Scalars['ID']>;
  updatedBy: UserDisplayNameV2;
  updatedTimestamp: Scalars['String'];
  uploadStatus: UploadStatusV2;
  wellKnownTemplateType?: Maybe<Scalars['String']>;
};

export type Ten99 = {
  __typename?: 'Ten99';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orderEligible?: Maybe<Scalars['Boolean']>;
  ten99SellerRecords?: Maybe<Array<Maybe<Ten99SellerRecord>>>;
  totalBuyersTaxAmount?: Maybe<Scalars['Float']>;
  totalProceeds?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type Ten99Form = {
  __typename?: 'Ten99Form';
  accountNumber?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyCityStateZip?: Maybe<Scalars['String']>;
  sellers?: Maybe<Array<Maybe<Ten99FormSellers>>>;
  settlementAgentAddress?: Maybe<Scalars['String']>;
  settlementAgentCityStateZip?: Maybe<Scalars['String']>;
  settlementAgentName?: Maybe<Scalars['String']>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  settlementAgentTaxIdNumber?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type Ten99FormSellers = {
  __typename?: 'Ten99FormSellers';
  address?: Maybe<Scalars['String']>;
  addressCityStateZip?: Maybe<Scalars['String']>;
  buyerTaxAmount?: Maybe<Scalars['Float']>;
  foreignPersonEntity?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  propertyOrServicesIndicator?: Maybe<Scalars['Boolean']>;
  sellerType?: Maybe<Scalars['String']>;
  sellersAllocatedProceeds?: Maybe<Scalars['Float']>;
  spouseName?: Maybe<Scalars['String']>;
  spouseTaxIdNumber?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
};

export type Ten99Input = {
  id: Scalars['ID'];
  ten99SellerRecords?: InputMaybe<Array<InputMaybe<Ten99SellerRecordInput>>>;
};

export type Ten99Response = {
  ten99: Ten99;
};

export type Ten99SellerRecord = {
  __typename?: 'Ten99SellerRecord';
  buyerTaxAmount?: Maybe<Scalars['Float']>;
  buyerTaxAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  foreignPersonEntity?: Maybe<Scalars['Boolean']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  propertyOrServicesIndicator?: Maybe<Scalars['Boolean']>;
  sellerId: Scalars['ID'];
  sellersAllocatedProceeds?: Maybe<Scalars['Float']>;
  sellersAllocatedProceedsOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  spouseTaxReportingName?: Maybe<Scalars['String']>;
  spouseTaxReportingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  taxReportingName?: Maybe<Scalars['String']>;
  taxReportingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type Ten99SellerRecordInput = {
  buyerTaxAmount?: InputMaybe<Scalars['Float']>;
  foreignPersonEntity?: InputMaybe<Scalars['Boolean']>;
  ownershipPercentage?: InputMaybe<Scalars['Float']>;
  propertyOrServicesIndicator?: InputMaybe<Scalars['Boolean']>;
  sellerId: Scalars['String'];
  sellersAllocatedProceeds?: InputMaybe<Scalars['Float']>;
  spouseTaxReportingName?: InputMaybe<Scalars['String']>;
  taxReportingName?: InputMaybe<Scalars['String']>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  abbreviation: Scalars['String'];
  address?: Maybe<Address>;
  altaId?: Maybe<Scalars['ID']>;
  billingContact: TenantBillingContact;
  /** @deprecated use billingContact object */
  billingContactEmail: Scalars['EmailAddress'];
  /** @deprecated use billingContact object */
  billingContactFirstName: Scalars['String'];
  /** @deprecated use billingContact object */
  billingContactLastName: Scalars['String'];
  /** @deprecated use billingContact object */
  billingContactMiddleName?: Maybe<Scalars['String']>;
  /** @deprecated use billingContact object */
  billingContactPhone: Scalars['String'];
  /** @deprecated use billingContact object */
  billingContactPhoneExtension?: Maybe<Scalars['String']>;
  /** @deprecated use billingContact object */
  billingContactPhoneType?: Maybe<Scalars['String']>;
  businessContact: TenantContact;
  /** @deprecated use businessContact object */
  businessContactEmail?: Maybe<Scalars['EmailAddress']>;
  /** @deprecated use businessContact object */
  businessContactFirstName?: Maybe<Scalars['String']>;
  /** @deprecated use businessContact object */
  businessContactLastName?: Maybe<Scalars['String']>;
  /** @deprecated use businessContact object */
  businessContactMiddleName?: Maybe<Scalars['String']>;
  /** @deprecated use businessContact object */
  businessContactPhone?: Maybe<Scalars['String']>;
  /** @deprecated use businessContact object */
  businessContactPhoneExtension?: Maybe<Scalars['String']>;
  /** @deprecated use businessContact object */
  businessContactPhoneType?: Maybe<Scalars['String']>;
  childNodes?: Maybe<Array<Maybe<TenantChildNode>>>;
  /** @deprecated use address object */
  city?: Maybe<Scalars['String']>;
  /** @deprecated use address object */
  county?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  itemId: Scalars['String'];
  labelL1?: Maybe<Scalars['String']>;
  labelL2?: Maybe<Scalars['String']>;
  labelL3?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  profileImage?: Maybe<TenantProfileImage>;
  /** @deprecated use address object */
  state?: Maybe<Scalars['String']>;
  /** @deprecated use address object */
  streetAddress?: Maybe<Scalars['String']>;
  /** @deprecated use address object */
  streetAddress2?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['ID']>;
  taxIdType?: Maybe<Scalars['String']>;
  technicalContact: TenantContact;
  /** @deprecated use technicalContact object */
  technicalContactEmail?: Maybe<Scalars['EmailAddress']>;
  /** @deprecated use technicalContact object */
  technicalContactFirstName?: Maybe<Scalars['String']>;
  /** @deprecated use technicalContact object */
  technicalContactLastName?: Maybe<Scalars['String']>;
  /** @deprecated use technicalContact object */
  technicalContactMiddleName?: Maybe<Scalars['String']>;
  /** @deprecated use technicalContact object */
  technicalContactPhone?: Maybe<Scalars['String']>;
  /** @deprecated use technicalContact object */
  technicalContactPhoneExtension?: Maybe<Scalars['String']>;
  /** @deprecated use technicalContact object */
  technicalContactPhoneType?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  /** @deprecated use address object */
  zip?: Maybe<Scalars['String']>;
};

export type TenantBillingContact = {
  __typename?: 'TenantBillingContact';
  email: Scalars['EmailAddress'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneExtension?: Maybe<Scalars['String']>;
  phoneType?: Maybe<Scalars['String']>;
};

export type TenantChildImage = {
  __typename?: 'TenantChildImage';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp: Scalars['String'];
  profileImage?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type TenantChildNode = {
  __typename?: 'TenantChildNode';
  abbreviation: Scalars['String'];
  address?: Maybe<Address>;
  altaId?: Maybe<Scalars['String']>;
  childNodes?: Maybe<Array<Maybe<TenantChildNode>>>;
  city?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactFirstName?: Maybe<Scalars['String']>;
  contactLastName?: Maybe<Scalars['String']>;
  contactMiddleName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  contactPhoneExtension?: Maybe<Scalars['String']>;
  contactPhoneType?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Maybe<EmailAddressSchema>>>;
  id: Scalars['ID'];
  itemId: Scalars['String'];
  licenses?: Maybe<Array<Maybe<License>>>;
  name: Scalars['String'];
  nmlsId?: Maybe<Scalars['String']>;
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  parentItemId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  profileImage?: Maybe<TenantChildProfileImage>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  website?: Maybe<Scalars['String']>;
  wireInstructions?: Maybe<WireSchema>;
  zip?: Maybe<Scalars['String']>;
};

export type TenantChildProfileImage = {
  __typename?: 'TenantChildProfileImage';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  profileImage?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type TenantContact = {
  __typename?: 'TenantContact';
  email?: Maybe<Scalars['EmailAddress']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneExtension?: Maybe<Scalars['String']>;
  phoneType?: Maybe<Scalars['String']>;
};

export type TenantProfileImage = {
  __typename?: 'TenantProfileImage';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  profileImage?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type TenantUnderwriter = {
  __typename?: 'TenantUnderwriter';
  active: Scalars['Boolean'];
  companyIds: Array<Scalars['String']>;
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  splitConfiguration: TenantUnderwriterSplitConfiguration;
  underwriter?: Maybe<Underwriter>;
  underwriterId: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type TenantUnderwriterAgentUnderwriterSplit = {
  __typename?: 'TenantUnderwriterAgentUnderwriterSplit';
  agent: Scalars['Int'];
  underwriter: Scalars['Int'];
};

export type TenantUnderwriterAgentUnderwriterSplitInput = {
  agent: Scalars['Int'];
  underwriter: Scalars['Int'];
};

export type TenantUnderwriterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  displayName: Scalars['String'];
  splitConfiguration: TenantUnderwriterSplitConfigurationInput;
  underwriterId: Scalars['String'];
};

export type TenantUnderwriterResponse = {
  tenantUnderwriters: Array<TenantUnderwriter>;
};


export type TenantUnderwriterResponseTenantUnderwritersArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};

export type TenantUnderwriterSplitConfiguration = {
  __typename?: 'TenantUnderwriterSplitConfiguration';
  global: TenantUnderwriterSplitInfo;
  state?: Maybe<Scalars['JSONObject']>;
};

export type TenantUnderwriterSplitConfigurationInput = {
  global: TenantUnderwriterSplitInfoInput;
  state?: InputMaybe<Scalars['JSONObject']>;
};

export type TenantUnderwriterSplitInfo = {
  __typename?: 'TenantUnderwriterSplitInfo';
  endorsementFlat: TenantUnderwriterAgentUnderwriterSplit;
  endorsementPercent: TenantUnderwriterAgentUnderwriterSplit;
  policy: TenantUnderwriterAgentUnderwriterSplit;
};

export type TenantUnderwriterSplitInfoInput = {
  endorsementFlat: TenantUnderwriterAgentUnderwriterSplitInput;
  endorsementPercent: TenantUnderwriterAgentUnderwriterSplitInput;
  policy: TenantUnderwriterAgentUnderwriterSplitInput;
};

export type TitleConfiguration = {
  __typename?: 'TitleConfiguration';
  /** State specific buyer/seller split. TODO: make state argument required once callers have been updated */
  buyerSellerSplits?: Maybe<SplitConfiguration>;
  /**
   * (deprecated) Temporary state storage while transitioning buyerSellerSplits state argument
   * @deprecated Remove this after changing callers to pass state into buyerSellerSplits
   */
  state?: Maybe<Scalars['String']>;
  /** Underwriter configuration values */
  underwriter?: Maybe<UnderwriterConfiguration>;
};


export type TitleConfigurationBuyerSellerSplitsArgs = {
  state?: InputMaybe<Scalars['String']>;
};


export type TitleConfigurationUnderwriterArgs = {
  underwriterId: Scalars['String'];
};

export type TitleCpl = {
  __typename?: 'TitleCpl';
  address?: Maybe<Address>;
  /** @deprecated Use agentRetainedV2 instead for dollar/percentage values */
  agentRetained?: Maybe<Scalars['Float']>;
  agentRetainedV2?: Maybe<DollarsPercent>;
  amount?: Maybe<Scalars['Float']>;
  approvedAttorney?: Maybe<Scalars['String']>;
  buyerPays?: Maybe<Scalars['Float']>;
  coveredParty?: Maybe<Scalars['String']>;
  cplNumber?: Maybe<Scalars['String']>;
  displayOnSettlement?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lender?: Maybe<OrderParty>;
  lenderId?: Maybe<Scalars['String']>;
  letterType?: Maybe<Scalars['String']>;
  loanNumber?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  product?: Maybe<CplProduct>;
  proposedLoanInsured?: Maybe<Scalars['String']>;
  remittanceDate?: Maybe<Scalars['String']>;
  secondaryPartyId?: Maybe<Scalars['String']>;
  secondaryPartyRoleType?: Maybe<Scalars['String']>;
  sellerPays?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  /** @deprecated Use underwriterRemittedV2 instead for dollar/percentage values */
  underwriterRemitted?: Maybe<Scalars['Float']>;
  underwriterRemittedV2?: Maybe<DollarsPercent>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  useLenderAddress?: Maybe<Scalars['Boolean']>;
};

export type TitleCplItem = {
  address?: InputMaybe<AddressInput>;
  agentRetained?: InputMaybe<Scalars['Float']>;
  amount?: InputMaybe<Scalars['Float']>;
  approvedAttorney?: InputMaybe<Scalars['String']>;
  buyerPays?: InputMaybe<Scalars['Float']>;
  coveredParty?: InputMaybe<Scalars['String']>;
  cplNumber?: InputMaybe<Scalars['String']>;
  displayOnSettlement?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lenderAddress?: InputMaybe<AddressInput>;
  lenderId?: InputMaybe<Scalars['String']>;
  letterType?: InputMaybe<Scalars['String']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  proposedLoanInsured?: InputMaybe<Scalars['String']>;
  remittanceDate?: InputMaybe<Scalars['String']>;
  secondaryPartyId?: InputMaybe<Scalars['String']>;
  secondaryPartyRoleType?: InputMaybe<Scalars['String']>;
  sellerPays?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  underwriterRemitted?: InputMaybe<Scalars['Float']>;
  useLenderAddress?: InputMaybe<Scalars['Boolean']>;
};

export type TitleCpls = {
  __typename?: 'TitleCpls';
  approvedAttorneys: Array<ApprovedAttorney>;
  cpls: Array<TitleCpl>;
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  policyDetails: Array<PolicyDetails>;
  proposedLoanInsured?: Maybe<Scalars['String']>;
  secondaryParties: Array<SecondaryParty>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
  validation?: Maybe<ParameterValidation>;
};

export type TitleDomain = {
  __typename?: 'TitleDomain';
  branchId: Scalars['ID'];
  /** TODO: remove state argument once callers have been updated */
  configuration?: Maybe<TitleConfiguration>;
  cpl?: Maybe<TitleCpls>;
  exceptions?: Maybe<Array<Maybe<TitleException>>>;
  general?: Maybe<TitleGeneral>;
  orderId: Scalars['ID'];
  policies?: Maybe<TitlePolicies>;
  policyMetadata?: Maybe<PolicyMetadata>;
  premium?: Maybe<TitlePremium>;
  requirements?: Maybe<Array<Maybe<Requirement>>>;
  titleExceptions?: Maybe<TitleExceptions>;
  titleFees?: Maybe<TitleFees>;
  titleRequirements?: Maybe<TitleRequirements>;
};


export type TitleDomainConfigurationArgs = {
  state?: InputMaybe<Scalars['String']>;
};


export type TitleDomainCplArgs = {
  state: Scalars['String'];
  underwriterId: Scalars['String'];
};


export type TitleDomainPremiumArgs = {
  premiumType: Scalars['String'];
};

export type TitleException = {
  __typename?: 'TitleException';
  applyToPolicy?: Maybe<Scalars['String']>;
  bodyContent?: Maybe<Scalars['String']>;
  bodyTemplate: Scalars['String'];
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  exceptionFamilyMergeable?: Maybe<Scalars['String']>;
  exceptionMergeable?: Maybe<Scalars['String']>;
  exceptions?: Maybe<Array<Maybe<TitleException>>>;
  id: Scalars['ID'];
  isAffirmativeCoverage?: Maybe<Scalars['Boolean']>;
  isSubordinateMatter?: Maybe<Scalars['Boolean']>;
  libraryId?: Maybe<Scalars['String']>;
  mergeFields?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  title: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type TitleExceptions = {
  __typename?: 'TitleExceptions';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  exceptions: Array<Maybe<TitleException>>;
  /** id format is {orderId}#EXCEPTIONS */
  id: Scalars['ID'];
  orderId: Scalars['ID'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type TitleFeeAdditionalData = {
  __typename?: 'TitleFeeAdditionalData';
  externalCalculatorId?: Maybe<Scalars['String']>;
  sourceBorrowerPaidAt?: Maybe<Scalars['Float']>;
  sourceSellerPaidAt?: Maybe<Scalars['Float']>;
};

export type TitleFees = {
  __typename?: 'TitleFees';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  defaultPayeeId?: Maybe<Scalars['String']>;
  fees?: Maybe<Array<Maybe<FeeItem>>>;
  id: Scalars['ID'];
  orderId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type TitleFields = {
  __typename?: 'TitleFields';
  orderId?: Maybe<Scalars['ID']>;
  policyMetadata?: Maybe<PolicyMetadata>;
};

export type TitleGeneral = {
  __typename?: 'TitleGeneral';
  amountMortgageInsured?: Maybe<Scalars['Float']>;
  amountMortgageInsuredMetadata?: Maybe<OverrideMetadataNumber>;
  amountOwnerInsured?: Maybe<Scalars['Float']>;
  amountOwnerInsuredMetadata?: Maybe<OverrideMetadataNumber>;
  authorizedSignatory?: Maybe<Scalars['String']>;
  authorizedSignatoryUser?: Maybe<User>;
  commitmentExpiration?: Maybe<Scalars['String']>;
  commitmentExpirationDuration?: Maybe<Scalars['Float']>;
  commitmentExpirationMetadata?: Maybe<OverrideMetadataNumber>;
  commitmentExpirationTerm?: Maybe<Scalars['String']>;
  commitmentNumber?: Maybe<Scalars['String']>;
  commitmentNumberMetadata?: Maybe<OverrideMetadataString>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use currentTitleHolderMetadata.currentTitleHolder */
  currentTitleHolder?: Maybe<Scalars['String']>;
  currentTitleHolderMergeable?: Maybe<Scalars['String']>;
  currentTitleHolderMetadata?: Maybe<CurrentTitleHolderMetadata>;
  dateEffective?: Maybe<Scalars['DateTime']>;
  /** ID Format: orderId#GENERAL */
  id: Scalars['ID'];
  includeMaritalStatus?: Maybe<Scalars['Boolean']>;
  insuredLanguageType?: Maybe<Scalars['String']>;
  interestInLand?: Maybe<Scalars['String']>;
  /** @deprecated Use OverrideMetadata */
  isCommitmentNumberOverridden?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use order */
  legalDescriptionBrief?: Maybe<Scalars['String']>;
  /** @deprecated Use order */
  legalDescriptionFull?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  orderId: Scalars['String'];
  /** @deprecated Use order */
  piqUpdatedTimestamp?: Maybe<Scalars['String']>;
  proposedLoanInsured?: Maybe<Scalars['String']>;
  proposedLoanInsuredMetadata?: Maybe<OverrideMetadataString>;
  seeExhibitA?: Maybe<Scalars['Boolean']>;
  shouldDisplayMaritalStatus?: Maybe<Scalars['Boolean']>;
  timeEffective?: Maybe<Scalars['String']>;
  /** @deprecated Use currentTitleHolderMetadata.titleHolderType */
  titleHolderType?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  vestingClause?: Maybe<Scalars['String']>;
  vestingClauseMetadata?: Maybe<OverrideMetadataString>;
};

export type TitlePolicies = {
  __typename?: 'TitlePolicies';
  lender?: Maybe<TitlePremium>;
  owner?: Maybe<TitlePremium>;
};

export type TitlePremium = {
  __typename?: 'TitlePremium';
  additionalQuestions?: Maybe<Array<AdditionalQuestion>>;
  /** @deprecated Use agentRetainedV2 instead for dollar/percentage values */
  agentRetained?: Maybe<Scalars['Float']>;
  agentRetainedV2?: Maybe<DollarsPercent>;
  buyerPays?: Maybe<Scalars['Float']>;
  cdSection?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  disclosedAmount?: Maybe<Scalars['Float']>;
  disclosedAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  displayOnSettlement?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['String']>;
  /** @deprecated use effectiveDateOverrideMetadata */
  effectiveDateMetadata?: Maybe<OverrideMetadataString>;
  effectiveDateOverrideMetadata?: Maybe<OverrideMetadataString>;
  endorsements?: Maybe<Array<Maybe<TitlePremiumEndorsement>>>;
  /** ID Format: {orderId}#{premiumType} */
  id: Scalars['ID'];
  liabilityAmount?: Maybe<Scalars['Float']>;
  orderId: Scalars['ID'];
  payee?: Maybe<OrderParty>;
  payeeId?: Maybe<Scalars['String']>;
  payeeIdOverrideMetadata?: Maybe<OverrideMetadataString>;
  /** @deprecated use payeeIdOverrideMetadata */
  payeeMetadata?: Maybe<OverrideMetadataString>;
  policyAmount?: Maybe<Scalars['Float']>;
  policyAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  policyType?: Maybe<Scalars['String']>;
  policyTypes?: Maybe<Array<Maybe<PolicyType>>>;
  premiumType?: Maybe<Scalars['String']>;
  priorPolicy?: Maybe<Scalars['Boolean']>;
  priorPolicyAmount?: Maybe<Scalars['Float']>;
  priorPolicyCoverageType?: Maybe<Scalars['String']>;
  priorPolicyDate?: Maybe<Scalars['String']>;
  priorPolicyDiscountApplied?: Maybe<Scalars['Float']>;
  priorPolicyNumber?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  rate?: Maybe<TitleRate>;
  /** @deprecated use rate */
  rateDetails?: Maybe<TitleRateDetails>;
  rateId?: Maybe<Scalars['String']>;
  rateType?: Maybe<Scalars['String']>;
  sellerPays?: Maybe<Scalars['Float']>;
  simultaneousIssue?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  statementType?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
  /** @deprecated use underwriterObject */
  underwriter?: Maybe<Scalars['String']>;
  underwriterObject?: Maybe<Underwriter>;
  /** @deprecated Use underwriterRemittedV2 instead for dollar/percentage values */
  underwriterRemitted?: Maybe<Scalars['Float']>;
  underwriterRemittedV2?: Maybe<DollarsPercent>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type TitlePremiumEndorsement = {
  __typename?: 'TitlePremiumEndorsement';
  additionalQuestions?: Maybe<Array<AdditionalQuestion>>;
  /** @deprecated Use agentRetainedV2 instead for dollar/percentage values */
  agentRetained?: Maybe<Scalars['Float']>;
  agentRetainedV2?: Maybe<DollarsPercent>;
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  isDefaultEndorsement?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  /** @deprecated Use underwriterRemittedV2 instead for dollar/percentage values */
  underwriterRemitted?: Maybe<Scalars['Float']>;
  underwriterRemittedV2?: Maybe<DollarsPercent>;
};

export type TitlePremiumEndorsementInput = {
  additionalQuestions?: InputMaybe<Array<AdditionalQuestionInput>>;
  agentRetained?: InputMaybe<Scalars['Float']>;
  amount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  underwriterRemitted?: InputMaybe<Scalars['Float']>;
};

export type TitlePremiums = {
  __typename?: 'TitlePremiums';
  id: Scalars['String'];
  lender?: Maybe<TitlePremium>;
  owner?: Maybe<TitlePremium>;
};

export type TitleRate = {
  __typename?: 'TitleRate';
  actual?: Maybe<Scalars['Float']>;
  disclosed?: Maybe<Scalars['Float']>;
  discountApplied?: Maybe<Scalars['Float']>;
};

export type TitleRateCalculation = {
  __typename?: 'TitleRateCalculation';
  actual?: Maybe<OverrideMetadataNumber>;
  disclosed?: Maybe<OverrideMetadataNumber>;
};

export type TitleRateDetails = {
  __typename?: 'TitleRateDetails';
  lender?: Maybe<TitleRateCalculation>;
  owner?: Maybe<TitleRateCalculation>;
};

export type TitleRateInput = {
  actual?: InputMaybe<Scalars['Float']>;
  disclosed?: InputMaybe<Scalars['Float']>;
  discountApplied?: InputMaybe<Scalars['Float']>;
};

export type TitleRemittableProduct = {
  __typename?: 'TitleRemittableProduct';
  agentPremium?: Maybe<Scalars['Float']>;
  branch: Scalars['String'];
  branchId: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  company: Scalars['String'];
  companyId: Scalars['String'];
  countyFips?: Maybe<Scalars['String']>;
  countyName?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['Float']>;
  dateSettlement?: Maybe<Scalars['String']>;
  grossPremium?: Maybe<Scalars['Float']>;
  liabilityAmount?: Maybe<Scalars['Float']>;
  orderId: Scalars['String'];
  orderNumber: Scalars['String'];
  policyEffectiveDate?: Maybe<Scalars['String']>;
  priorPolicyAmount?: Maybe<Scalars['Float']>;
  priorPolicyType?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
  productIndex: Scalars['Int'];
  productNumber?: Maybe<Scalars['String']>;
  productStatus?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  rateType?: Maybe<Scalars['String']>;
  remittanceDate?: Maybe<Scalars['String']>;
  simultaneousIssue?: Maybe<Scalars['Boolean']>;
  stateOrProvince?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  underwriterId: Scalars['String'];
  uwPremium?: Maybe<Scalars['Float']>;
};

export type TitleRemittanceReportEntry = {
  __typename?: 'TitleRemittanceReportEntry';
  agentPremium?: Maybe<Scalars['Float']>;
  branch?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  countyFips?: Maybe<Scalars['String']>;
  countyName?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['Float']>;
  dateSettlement?: Maybe<Scalars['String']>;
  grossPremium?: Maybe<Scalars['Float']>;
  liabilityAmount?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  policyEffectiveDate?: Maybe<Scalars['String']>;
  priorPolicyAmount?: Maybe<Scalars['Float']>;
  priorPolicyType?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  productNumber?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  rateType?: Maybe<Scalars['String']>;
  remittanceDate?: Maybe<Scalars['String']>;
  simultaneousIssue?: Maybe<Scalars['Boolean']>;
  stateOrProvince?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  underwriterId?: Maybe<Scalars['String']>;
  uwPremium?: Maybe<Scalars['Float']>;
};

export type TitleRequirements = {
  __typename?: 'TitleRequirements';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  /** id format is {orderId}#REQUIREMENTS */
  id: Scalars['ID'];
  orderId: Scalars['ID'];
  requirements: Array<Maybe<Requirement>>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type ToggleTen99Input = {
  orderEligible: Scalars['Boolean'];
  orderId: Scalars['ID'];
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type ToggleTen99Response = OrderResponse & Ten99Response & {
  __typename?: 'ToggleTen99Response';
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
  ten99: Ten99;
};

export type TotalCommissionAmountValue = {
  __typename?: 'TotalCommissionAmountValue';
  calculatedValue?: Maybe<Scalars['Float']>;
  calculationMethod: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  finalizedPayorPayeeData?: Maybe<FinalizedPayorPayeeData>;
  fundingTransactionType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isClear?: Maybe<Scalars['Boolean']>;
  isCleared?: Maybe<Scalars['Boolean']>;
  isUserCreated?: Maybe<Scalars['Boolean']>;
  lastActivityDate?: Maybe<Scalars['String']>;
  lineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  memo?: Maybe<Scalars['String']>;
  oPayeeAddress?: Maybe<Address>;
  oPayorPayeeId?: Maybe<Scalars['String']>;
  oTaxId?: Maybe<FundingTaxId>;
  oWireTransfer?: Maybe<WireSchema>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  payee?: Maybe<OrderParty>;
  payorPayeeDisplayName?: Maybe<Scalars['String']>;
  payorPayeeId?: Maybe<Scalars['String']>;
  payorPayeeName?: Maybe<Scalars['String']>;
  payorPayeeString_sk?: Maybe<Scalars['String']>;
  payorPayeeType?: Maybe<Scalars['String']>;
  positivePayDate?: Maybe<Scalars['String']>;
  reconcileDate?: Maybe<Scalars['String']>;
  refNumber?: Maybe<Scalars['String']>;
  searchData?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusReason?: Maybe<Scalars['String']>;
  transactionCategory?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  transferredOrderId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedByName?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  wireExpectedDate?: Maybe<Scalars['String']>;
};

export type TransactionCategoryStatus = {
  __typename?: 'TransactionCategoryStatus';
  cleared: TransactionCategoryStatusTotal;
  unmatched: TransactionCategoryStatusTotal;
};

export type TransactionCategoryStatusTotal = {
  __typename?: 'TransactionCategoryStatusTotal';
  amount: Scalars['Float'];
  items: Scalars['Int'];
};

export type TransactionLineDetailTransferTarget = {
  __typename?: 'TransactionLineDetailTransferTarget';
  escrowAccountId?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type TransactionType = {
  __typename?: 'TransactionType';
  createdTimestamp?: Maybe<Scalars['String']>;
  enableDrawFields?: Maybe<Scalars['Boolean']>;
  enableLoanFields?: Maybe<Scalars['Boolean']>;
  enableSaleFields?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isCustom?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type TransferTaxCalculatorLineItem = {
  __typename?: 'TransferTaxCalculatorLineItem';
  amount?: Maybe<Scalars['Float']>;
  amountFallback?: Maybe<Scalars['Float']>;
  buyerAmount?: Maybe<Scalars['Float']>;
  buyerAmountFallback?: Maybe<Scalars['Float']>;
  buyerPercentage?: Maybe<Scalars['Float']>;
  default?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  nameFallback?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  payeeId?: Maybe<Scalars['String']>;
  payeeSuggested?: Maybe<Scalars['String']>;
  sellerAmount?: Maybe<Scalars['Float']>;
  sellerPercentage?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type TransferTaxCalculatorLineItemInput = {
  amount?: InputMaybe<Scalars['Float']>;
  buyerPercentage?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  payeeId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type TransferTaxFeeAdditionalData = {
  __typename?: 'TransferTaxFeeAdditionalData';
  externalCalculatorLineItemId?: Maybe<Scalars['String']>;
  providerType?: Maybe<Scalars['String']>;
  rfttFeeLineType?: Maybe<Scalars['String']>;
};

export type TransferTaxes = {
  __typename?: 'TransferTaxes';
  lineItems: Array<TransferTaxCalculatorLineItem>;
};

export type TransferTaxesInput = {
  lineItems?: InputMaybe<Array<InputMaybe<TransferTaxCalculatorLineItemInput>>>;
};

export type TransferTransactionDetailsInput = {
  escrowAccountId: Scalars['String'];
  originLineDetails?: InputMaybe<Array<InputMaybe<UpdateLineDetailInput>>>;
  originTransaction?: InputMaybe<UpdateTransactionTransferInput>;
  targetOrder: Scalars['String'];
  targetOrderParty: Scalars['String'];
};

export type TransferTransactionDetailsResponse = {
  __typename?: 'TransferTransactionDetailsResponse';
  escrowAccountId?: Maybe<Scalars['String']>;
  originLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  originTransaction?: Maybe<Transaction>;
  targetLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  targetTransaction?: Maybe<Transaction>;
};

export type Underwriter = {
  __typename?: 'Underwriter';
  abbreviation: Scalars['String'];
  activeDate?: Maybe<Scalars['String']>;
  address: UnderwriterAddress;
  friendlyName: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  integration?: Maybe<Integration>;
  integrationType?: Maybe<Scalars['JSONObject']>;
  itemId: Scalars['ID'];
  name: Scalars['String'];
  phone: Phone;
  state: Scalars['String'];
  website: Scalars['String'];
};

export type UnderwriterAddress = {
  __typename?: 'UnderwriterAddress';
  mailing?: Maybe<Address>;
  overnight?: Maybe<Address>;
  primary: Address;
};

export type UnderwriterConfiguration = {
  __typename?: 'UnderwriterConfiguration';
  /** Map of allowed approved attorney types for each state */
  approvedAttorneyMap?: Maybe<Scalars['JSONObject']>;
  /** Underwriter id */
  underwriterId: Scalars['String'];
};

export type UnderwriterDisclosureFeeAdditionalData = {
  __typename?: 'UnderwriterDisclosureFeeAdditionalData';
  externalLenderPremiumId?: Maybe<Scalars['String']>;
  externalOwnerPremiumId?: Maybe<Scalars['String']>;
  overallUnderwriterRemittedAmount?: Maybe<Scalars['Float']>;
};

export type UpdateAdjustmentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  id: Scalars['String'];
  isDebitCredit?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  payeePayorId?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateAdminMilestoneInput = {
  name?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateAdminMilestoneResponse = {
  __typename?: 'UpdateAdminMilestoneResponse';
  existingMilestoneName?: Maybe<Scalars['String']>;
  milestone?: Maybe<AdminMilestone>;
};

export type UpdateAdminTaskInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignment?: InputMaybe<TaskAssignmentInput>;
  departmentDependency?: InputMaybe<Scalars['String']>;
  due?: InputMaybe<TaskDueInput>;
  name?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<TaskStartInput>;
  type?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateAdminTaskResponse = {
  __typename?: 'UpdateAdminTaskResponse';
  existingTaskName?: Maybe<Scalars['String']>;
  task?: Maybe<AdminTask>;
};

export type UpdateAdminWorkflowInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionPurpose?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateAdminWorkflowResponse = {
  __typename?: 'UpdateAdminWorkflowResponse';
  existingWorkflowName?: Maybe<Scalars['String']>;
  workflow?: Maybe<AdminWorkflow>;
};

export type UpdateDcAdjustmentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  dcAddendumLineNumber?: InputMaybe<Scalars['Int']>;
  dcLineNumber?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  id: Scalars['String'];
  isDebitCredit?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  payeePayorId?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateDepartmentInput = {
  name: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
  users?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateDirectoryCompanyInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addresses?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  altaId?: InputMaybe<Scalars['String']>;
  alternateSearchName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  id: Scalars['ID'];
  lenderLanguage?: InputMaybe<Scalars['String']>;
  lenderLanguageDefaultType?: InputMaybe<Scalars['String']>;
  lenderLanguageOptions?: InputMaybe<LenderLanguageOptionsInput>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  nmlsId?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  tenantOrgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedTimestamp: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
  wireInstructions?: InputMaybe<WireInput>;
};

export type UpdateDirectoryContactInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  nmlsId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  suffix?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  useCompanyAddress?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDocumentInput = {
  customSortOrder?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  documentType: DocumentType;
  listMergeChoices?: InputMaybe<Scalars['String']>;
  mergeFieldData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  path?: InputMaybe<Scalars['String']>;
  skipClone?: InputMaybe<Scalars['Boolean']>;
  updatedTimestamp: Scalars['DateTime'];
  uploadStatus?: InputMaybe<UploadStatus>;
};

export type UpdateDocumentsInput = {
  documents: Array<UpdateDocumentInput>;
};

export type UpdateEscrowAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  accountNumberAlternate?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Array<InputMaybe<EscrowAccountAddressInput>>>;
  bankName?: InputMaybe<Scalars['String']>;
  checkPrinting?: InputMaybe<CheckPrintingInput>;
  description?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  escrowAccountName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  positivePay?: InputMaybe<PositivePayInput>;
  routingNumber?: InputMaybe<Scalars['String']>;
  routingNumberDeposit?: InputMaybe<Scalars['String']>;
  routingNumberFractional?: InputMaybe<Scalars['String']>;
  routingNumberWire?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateExceptionInput = {
  applyToPolicy?: InputMaybe<Scalars['String']>;
  bodyTemplate?: InputMaybe<Scalars['String']>;
  exceptionId: Scalars['String'];
  isAffirmativeCoverage?: InputMaybe<Scalars['Boolean']>;
  isSubordinateMatter?: InputMaybe<Scalars['Boolean']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateExceptionItemInput = {
  applyToPolicy?: InputMaybe<Scalars['String']>;
  bodyTemplate?: InputMaybe<Scalars['String']>;
  exceptionId: Scalars['String'];
  isAffirmativeCoverage?: InputMaybe<Scalars['Boolean']>;
  isSubordinateMatter?: InputMaybe<Scalars['Boolean']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateExceptionsHeaderInput = {
  exceptions?: InputMaybe<Array<InputMaybe<ExceptionReference>>>;
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateExceptionsInput = {
  exceptions: Array<InputMaybe<UpdateExceptionItemInput>>;
  orderId: Scalars['String'];
};

export type UpdateFeeInput = {
  borrowerPaidAt?: InputMaybe<Scalars['Float']>;
  borrowerPaidBefore?: InputMaybe<Scalars['Float']>;
  description: Scalars['String'];
  feeLineType: Scalars['String'];
  feeTypeAdditionalData?: InputMaybe<FeeTypeAdditionalDataInput>;
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  funding: Scalars['String'];
  gfeLineNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  orderId: Scalars['String'];
  payeeId?: InputMaybe<Scalars['String']>;
  pboBorrowerAmount?: InputMaybe<Scalars['Float']>;
  pboBorrowerPaidById?: InputMaybe<Scalars['String']>;
  pboSellerAmount?: InputMaybe<Scalars['Float']>;
  pboSellerPaidById?: InputMaybe<Scalars['String']>;
  sectionMapping?: InputMaybe<SectionMappingInput>;
  sellerPaidAt?: InputMaybe<Scalars['Float']>;
  sellerPaidBefore?: InputMaybe<Scalars['Float']>;
  statementPayeeDisplayName?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateFundInput = {
  escrowAccountId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type UpdateFundingForFeesInput = {
  feesToUpdate: Array<FeeToUpdateInput>;
  orderId: Scalars['String'];
  statementSection: Scalars['String'];
  statementType: Scalars['String'];
  updatedFunding: Scalars['String'];
};

export type UpdateGfeChargeInput = {
  gfeCharge: UpdateGfeChargeItemInput;
  orderId: Scalars['String'];
};

export type UpdateGfeChargeItemInput = {
  comparisonCategory?: InputMaybe<Scalars['String']>;
  gfeAmount?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateGfeChargesInput = {
  gfeCharges: Array<UpdateGfeChargeItemInput>;
  orderId: Scalars['String'];
};

export type UpdateIsSetAsCdLastLineInput = {
  fromStatementSection: Scalars['String'];
  id: Scalars['String'];
  isSetAsCDLastLine: Scalars['Boolean'];
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateLineDetailInput = {
  amount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
  lineNumber?: InputMaybe<Scalars['String']>;
  oAmount?: InputMaybe<Scalars['Float']>;
  oDescription?: InputMaybe<Scalars['String']>;
  oLineNumber?: InputMaybe<Scalars['String']>;
  refMetadata?: InputMaybe<RefMetaDataInput>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type UpdateLineDetailsInput = {
  escrowAccountId: Scalars['String'];
  lineDetails?: InputMaybe<Array<InputMaybe<UpdateLineDetailInput>>>;
  transactionId: Scalars['String'];
};

export type UpdateLoanDisclosuresInput = {
  adjustableInterestRateTable?: InputMaybe<AdjustableInterestRateTableInput>;
  adjustablePaymentsTable?: InputMaybe<AdjustablePaymentsTableInput>;
  escrowAccount?: InputMaybe<Scalars['String']>;
  escrowWaiverFee?: InputMaybe<Scalars['Float']>;
  escrowWaiverFeeDescription?: InputMaybe<Scalars['String']>;
  escrowedCostsFirstYear?: InputMaybe<Scalars['Float']>;
  escrowedCostsListing?: InputMaybe<Scalars['String']>;
  estimatedCostsOverFirstYear?: InputMaybe<Scalars['Float']>;
  initialEscrowPayment?: InputMaybe<Scalars['Float']>;
  latePaymentDays?: InputMaybe<Scalars['Int']>;
  latePaymentFeeDescription?: InputMaybe<Scalars['String']>;
  loanAssumptionPermitted?: InputMaybe<Scalars['String']>;
  loanHasDemandFeature?: InputMaybe<Scalars['String']>;
  monthlyEscrowAmount?: InputMaybe<Scalars['Float']>;
  negativeAmortization?: InputMaybe<Scalars['String']>;
  nonEscrowedCostFirstYear?: InputMaybe<Scalars['Float']>;
  nonEscrowedCostsListing?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  partialPayments?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateMergeFieldInput = {
  category: Scalars['String'];
  dataType: Scalars['String'];
  defaultFormat: Scalars['String'];
  domain: Scalars['String'];
  label: Scalars['String'];
  mergeKey: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateMergeTemplateData = {
  bodyTemplate?: InputMaybe<Scalars['String']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateNoteInput = {
  appliesTo?: InputMaybe<AppliesTo>;
  appliesToId?: InputMaybe<Scalars['String']>;
  attributions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  body: Scalars['String'];
  entityId: Scalars['String'];
  entityType: NoteEntityType;
  noteId: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type UpdateNotificationsInput = {
  notifications?: InputMaybe<Array<InputMaybe<NotificationInput>>>;
};

export type UpdateOrderBuyerSellerInput = {
  address?: InputMaybe<AddressInput>;
  alias?: InputMaybe<Scalars['String']>;
  buyerSellerId?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<BuyerSellerEmailAddressInput>>>;
  entityDateOfAgreement?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  entityStateOfAgreement?: InputMaybe<Scalars['String']>;
  excludeFromLoan?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  forwardingAddress?: InputMaybe<AddressInput>;
  forwardingAddressSameAsCurrentAddress?: InputMaybe<Scalars['Boolean']>;
  forwardingAddressSameAsPropertyAddress?: InputMaybe<Scalars['Boolean']>;
  gender?: InputMaybe<Scalars['String']>;
  hasPowerOfAttorney?: InputMaybe<Scalars['Boolean']>;
  isForeignAddress?: InputMaybe<Scalars['Boolean']>;
  isForeignForwardingAddress?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<BuyerSellerPhoneNumberInput>>>;
  powerOfAttorney?: InputMaybe<PowerOfAttorneyInput>;
  sdnStatus?: InputMaybe<Scalars['String']>;
  signingName?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  taxIdNumber?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  typeOfBuyerSeller?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  vesting?: InputMaybe<Scalars['String']>;
};

export type UpdateOrderBuyerSellerSoRepInput = {
  alias?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<BuyerSellerEmailAddressInput>>>;
  excludeFromLoan?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  hasPowerOfAttorney?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<BuyerSellerPhoneNumberInput>>>;
  powerOfAttorney?: InputMaybe<PowerOfAttorneyInput>;
  refBuyerSellerId?: InputMaybe<Scalars['String']>;
  referencedAs?: InputMaybe<Scalars['String']>;
  representativeCapacity?: InputMaybe<Scalars['String']>;
  sdnStatus?: InputMaybe<Scalars['String']>;
  signingName?: InputMaybe<Scalars['String']>;
  soRepId?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  taxIdNumber?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateOrderDocumentV2Input = {
  description?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  documentType: OrderDocumentTypeV2;
  listMergeChoices?: InputMaybe<Scalars['String']>;
  mergeFieldData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  rawMergeData?: InputMaybe<Scalars['String']>;
  skipClone?: InputMaybe<Scalars['Boolean']>;
  updatedTimestamp: Scalars['String'];
  uploadStatus?: InputMaybe<UploadStatusV2>;
};

export type UpdateOrderDocumentsItemV2Input = {
  description?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  documentType: OrderDocumentTypeV2;
  listMergeChoices?: InputMaybe<Scalars['String']>;
  mergeFieldData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rawMergeData?: InputMaybe<Scalars['String']>;
  skipClone?: InputMaybe<Scalars['Boolean']>;
  updatedTimestamp: Scalars['String'];
  uploadStatus?: InputMaybe<UploadStatusV2>;
};

export type UpdateOrderDocumentsV2Input = {
  documents: Array<UpdateOrderDocumentsItemV2Input>;
  orderId: Scalars['ID'];
};

export type UpdateOrderHeaderInput = {
  branch?: InputMaybe<Scalars['String']>;
  businessSource?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  dateCancelled?: InputMaybe<Scalars['String']>;
  dateClosed?: InputMaybe<Scalars['String']>;
  dateOnHold?: InputMaybe<Scalars['String']>;
  isMasterOrder?: InputMaybe<Scalars['Boolean']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  propertyState?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  statementType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  transactionTypeId?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateOrderInput = {
  buyer?: InputMaybe<UpdateOrderBuyerSellerInput>;
  buyerReps?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
  buyerSpouse?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
  commissions?: InputMaybe<OrderCommissionsInput>;
  header?: InputMaybe<UpdateOrderHeaderInput>;
  loan?: InputMaybe<OrderLoanInput>;
  main?: InputMaybe<UpdateOrderMainInput>;
  orderId: Scalars['ID'];
  party?: InputMaybe<OrderPartyInput>;
  piq?: InputMaybe<OrderPiqInput>;
  seller?: InputMaybe<UpdateOrderBuyerSellerInput>;
  sellerReps?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
  sellerSpouse?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
};

export type UpdateOrderMainInput = {
  amountInitialDraw?: InputMaybe<Scalars['Float']>;
  amountLoan?: InputMaybe<Scalars['Float']>;
  amountSale?: InputMaybe<Scalars['Float']>;
  closingLocation?: InputMaybe<AddressInput>;
  dateDisbursement?: InputMaybe<Scalars['String']>;
  dateFunding?: InputMaybe<Scalars['String']>;
  dateRecission?: InputMaybe<Scalars['String']>;
  dateSettlement?: InputMaybe<Scalars['String']>;
  otherReferenceNumber?: InputMaybe<Scalars['String']>;
  staff?: InputMaybe<Array<InputMaybe<OrderStaffInput>>>;
  timeSettlement?: InputMaybe<Scalars['String']>;
  underwriterId?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateOrderMilestoneInput = {
  name?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  updatedTimestamp: Scalars['DateTime'];
};

/** This is an input structure for updating an OrderParty with either Directory IDs or complete PartyCompany/PartyContact data */
export type UpdateOrderPartyInput = {
  /** When directoryCompanyId is specified, then the company field is ignored */
  company?: InputMaybe<PartyCompanyInput>;
  /** When directoryContactId is specified, then the contact field is ignored */
  contact?: InputMaybe<PartyContactInput>;
  /** Specify the ID of a DirectoryCompany to be copied into the PartyCompany. */
  directoryCompanyReferenceId?: InputMaybe<Scalars['String']>;
  /** Specify the ID of a DirectoryContact to be copied into the PartyContact. */
  directoryContactReferenceId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isSettlementUseOnly?: InputMaybe<Scalars['Boolean']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateOrderTaskInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignment?: InputMaybe<TaskAssignmentInput>;
  completedBy?: InputMaybe<Scalars['String']>;
  completedTimestamp?: InputMaybe<Scalars['String']>;
  departmentDependency?: InputMaybe<Scalars['String']>;
  due?: InputMaybe<TaskDueInput>;
  dueDate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<TaskStartInput>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateOrderTaskResponse = {
  __typename?: 'UpdateOrderTaskResponse';
  existingTaskName?: Maybe<Scalars['String']>;
  task?: Maybe<Task>;
};

export type UpdatePayoffAdditionalFee = {
  amount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
};

export type UpdatePayoffInput = {
  additionalDaysAfterDisbursement?: InputMaybe<Scalars['Int']>;
  additionalFees?: InputMaybe<Array<InputMaybe<UpdatePayoffAdditionalFee>>>;
  appendedDescription?: InputMaybe<Scalars['String']>;
  asOfDate?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lenderPartyId?: InputMaybe<Scalars['String']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  paidBy?: InputMaybe<Scalars['String']>;
  perDiemInterestAmount?: InputMaybe<Scalars['Float']>;
  principalBalance?: InputMaybe<Scalars['Float']>;
  totalAdditionalInterest?: InputMaybe<Scalars['Float']>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type UpdatePolicyMetadataInput = {
  createRecital?: InputMaybe<Scalars['Boolean']>;
  insuredVesting?: InputMaybe<UpdateMergeTemplateData>;
  loanPolicy?: InputMaybe<PolicyDataInput>;
  mortgageRecital?: InputMaybe<UpdateMergeTemplateData>;
  orderId: Scalars['ID'];
  ownerPolicy?: InputMaybe<PolicyDataInput>;
  updatedTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateProrationCharge = {
  frequency?: InputMaybe<Scalars['String']>;
  lineItem?: InputMaybe<ProrationChargeLineItemInput>;
  payeePartyId?: InputMaybe<Scalars['String']>;
  prorationChargeSubtype?: InputMaybe<Scalars['String']>;
  prorationChargeType?: InputMaybe<Scalars['String']>;
  prorationDetails?: InputMaybe<ProrationDetailsInput>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateReconciliationInput = {
  beginningBalance?: InputMaybe<Scalars['Float']>;
  clearedBalance?: InputMaybe<Scalars['Float']>;
  endingDate?: InputMaybe<Scalars['String']>;
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
  statementEndingBalance?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<ReconciliationStatus>;
  transactionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateRequirementInput = {
  bodyTemplate?: InputMaybe<Scalars['String']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  requirementId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateRequirementItemInput = {
  bodyTemplate?: InputMaybe<Scalars['String']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  requirementId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateRequirementsHeaderInput = {
  orderId: Scalars['String'];
  requirements?: InputMaybe<Array<InputMaybe<RequirementReference>>>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateRequirementsInput = {
  orderId: Scalars['String'];
  requirements: Array<InputMaybe<UpdateRequirementItemInput>>;
};

export type UpdateSecurityGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['JSONObject']>;
  type?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateSequenceInput = {
  currentSequenceNumber?: InputMaybe<Scalars['Int']>;
  numberOfDigitsInSequence?: InputMaybe<Scalars['Int']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sequenceId: Scalars['ID'];
  sequenceName?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateStateWithholdingInput = {
  description?: InputMaybe<Scalars['String']>;
  oTotalWithholdingBasis?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['ID'];
  payorPayeeId: Scalars['String'];
  sellers?: InputMaybe<Array<InputMaybe<StateWithholdingSellerValuesInput>>>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateTemplateDocV2Input = {
  attributes?: InputMaybe<TemplateAttributesV2Input>;
  description?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
  uploadStatus?: InputMaybe<UploadStatusV2>;
};

export type UpdateTemplateInput = {
  attributes?: InputMaybe<TemplateAttributesInput>;
  description?: InputMaybe<Scalars['String']>;
  documentType: DocumentType;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  showMergeFields?: InputMaybe<Scalars['Boolean']>;
  updatedTimestamp: Scalars['DateTime'];
  uploadStatus?: InputMaybe<UploadStatus>;
};

export type UpdateTen99Response = OrderResponse & Ten99Response & {
  __typename?: 'UpdateTen99Response';
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
  ten99: Ten99;
};

export type UpdateTenantChildInput = {
  abbreviation: Scalars['String'];
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactFirstName?: InputMaybe<Scalars['String']>;
  contactLastName?: InputMaybe<Scalars['String']>;
  contactMiddleName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  contactPhoneExtension?: InputMaybe<Scalars['String']>;
  contactPhoneType?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  id: Scalars['ID'];
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  name: Scalars['String'];
  nmlsId?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
  wireInstructions?: InputMaybe<WireInput>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateTenantInput = {
  abbreviation: Scalars['String'];
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  billingContactEmail?: InputMaybe<Scalars['String']>;
  billingContactFirstName?: InputMaybe<Scalars['String']>;
  billingContactLastName?: InputMaybe<Scalars['String']>;
  billingContactMiddleName?: InputMaybe<Scalars['String']>;
  billingContactPhone?: InputMaybe<Scalars['String']>;
  billingContactPhoneExtension?: InputMaybe<Scalars['String']>;
  billingContactPhoneType?: InputMaybe<Scalars['String']>;
  businessContactEmail?: InputMaybe<Scalars['String']>;
  businessContactFirstName?: InputMaybe<Scalars['String']>;
  businessContactLastName?: InputMaybe<Scalars['String']>;
  businessContactMiddleName?: InputMaybe<Scalars['String']>;
  businessContactPhone?: InputMaybe<Scalars['String']>;
  businessContactPhoneExtension?: InputMaybe<Scalars['String']>;
  businessContactPhoneType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  itemId?: InputMaybe<Scalars['ID']>;
  labelL1?: InputMaybe<Scalars['String']>;
  labelL2?: InputMaybe<Scalars['String']>;
  labelL3?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  technicalContactEmail?: InputMaybe<Scalars['String']>;
  technicalContactFirstName?: InputMaybe<Scalars['String']>;
  technicalContactLastName?: InputMaybe<Scalars['String']>;
  technicalContactMiddleName?: InputMaybe<Scalars['String']>;
  technicalContactPhone?: InputMaybe<Scalars['String']>;
  technicalContactPhoneExtension?: InputMaybe<Scalars['String']>;
  technicalContactPhoneType?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateTenantProfileImageInput = {
  id: Scalars['ID'];
  profileImage?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateTenantUnderwriterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  displayName?: InputMaybe<Scalars['String']>;
  splitConfiguration: TenantUnderwriterSplitConfigurationInput;
  underwriterId: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type UpdateTenantUnderwriterResponse = TenantUnderwriterResponse & {
  __typename?: 'UpdateTenantUnderwriterResponse';
  tenantUnderwriter: TenantUnderwriter;
  tenantUnderwriters: Array<TenantUnderwriter>;
};


export type UpdateTenantUnderwriterResponseTenantUnderwritersArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateTitleCplInput = {
  address?: InputMaybe<AddressInput>;
  agentRetained?: InputMaybe<Scalars['Float']>;
  amount?: InputMaybe<Scalars['Float']>;
  approvedAttorney?: InputMaybe<Scalars['String']>;
  buyerPays?: InputMaybe<Scalars['Float']>;
  coveredParty?: InputMaybe<Scalars['String']>;
  cplNumber?: InputMaybe<Scalars['String']>;
  displayOnSettlement?: InputMaybe<Scalars['String']>;
  lenderAddress?: InputMaybe<AddressInput>;
  lenderId?: InputMaybe<Scalars['String']>;
  letterType?: InputMaybe<Scalars['String']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  proposedLoanInsured?: InputMaybe<Scalars['String']>;
  remittanceDate?: InputMaybe<Scalars['String']>;
  secondaryPartyId?: InputMaybe<Scalars['String']>;
  secondaryPartyRoleType?: InputMaybe<Scalars['String']>;
  sellerPays?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  underwriterRemitted?: InputMaybe<Scalars['Float']>;
  updatedTimestamp: Scalars['String'];
  useLenderAddress?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateTitleCplsInput = {
  cpls: Array<TitleCplItem>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateTitleGeneralInput = {
  amountMortgageInsured?: InputMaybe<Scalars['Float']>;
  amountOwnerInsured?: InputMaybe<Scalars['Float']>;
  authorizedSignatory?: InputMaybe<Scalars['String']>;
  commitmentExpirationDuration?: InputMaybe<Scalars['Float']>;
  commitmentExpirationTerm?: InputMaybe<Scalars['String']>;
  commitmentNumber?: InputMaybe<Scalars['String']>;
  currentTitleHolder?: InputMaybe<Scalars['String']>;
  currentTitleHolderMergeFields?: InputMaybe<Scalars['String']>;
  dateEffective?: InputMaybe<Scalars['DateTime']>;
  includeMaritalStatus?: InputMaybe<Scalars['Boolean']>;
  insuredLanguageType?: InputMaybe<Scalars['String']>;
  interestInLand?: InputMaybe<Scalars['String']>;
  isCommitmentNumberOverridden?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  proposedLoanInsured?: InputMaybe<Scalars['String']>;
  seeExhibitA?: InputMaybe<Scalars['Boolean']>;
  timeEffective?: InputMaybe<Scalars['String']>;
  titleHolderType?: InputMaybe<Scalars['String']>;
  updatedTimestamp?: InputMaybe<Scalars['DateTime']>;
  vestingClause?: InputMaybe<Scalars['String']>;
};

export type UpdateTitlePremiumInput = {
  additionalQuestions?: InputMaybe<Array<AdditionalQuestionInput>>;
  agentRetained?: InputMaybe<Scalars['Float']>;
  buyerPays?: InputMaybe<Scalars['Float']>;
  cdSection?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  disclosedAmount?: InputMaybe<Scalars['Float']>;
  displayOnSettlement?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['String']>;
  endorsements?: InputMaybe<Array<TitlePremiumEndorsementInput>>;
  payeeId?: InputMaybe<Scalars['String']>;
  policyAmount?: InputMaybe<Scalars['Float']>;
  policyName?: InputMaybe<Scalars['String']>;
  policyType?: InputMaybe<Scalars['String']>;
  priorPolicy?: InputMaybe<Scalars['Boolean']>;
  priorPolicyAmount?: InputMaybe<Scalars['Float']>;
  priorPolicyCoverageType?: InputMaybe<Scalars['String']>;
  priorPolicyDate?: InputMaybe<Scalars['String']>;
  priorPolicyDiscountApplied?: InputMaybe<Scalars['Float']>;
  priorPolicyNumber?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<TitleRateInput>;
  rateId?: InputMaybe<Scalars['String']>;
  rateType?: InputMaybe<Scalars['String']>;
  sellerPays?: InputMaybe<Scalars['Float']>;
  simultaneousIssue?: InputMaybe<Scalars['Boolean']>;
  underwriterRemitted?: InputMaybe<Scalars['Float']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateTransactionInput = {
  escrowAccountId: Scalars['String'];
  fundingTransactionType?: InputMaybe<Scalars['String']>;
  isClear?: InputMaybe<Scalars['Boolean']>;
  isCleared?: InputMaybe<Scalars['Boolean']>;
  lastActivityDate?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  oPayeeAddress?: InputMaybe<AddressInput>;
  oPayorPayeeId?: InputMaybe<Scalars['String']>;
  oTaxId?: InputMaybe<FundingTaxIdInput>;
  oWireTransfer?: InputMaybe<WireInput>;
  orderNumber?: InputMaybe<Scalars['String']>;
  payeeAddress?: InputMaybe<AddressInput>;
  payorPayeeId?: InputMaybe<Scalars['String']>;
  positivePayDate?: InputMaybe<Scalars['String']>;
  reconcileDate?: InputMaybe<Scalars['String']>;
  refNumber?: InputMaybe<Scalars['String']>;
  searchData?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusReason?: InputMaybe<Scalars['String']>;
  transactionCategory: Scalars['String'];
  transactionDate?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
  transferredOrderId?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  wireExpectedDate?: InputMaybe<Scalars['String']>;
  wireTransfer?: InputMaybe<Scalars['String']>;
};

export type UpdateTransactionTransferInput = {
  fundingTransactionType?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isClear?: InputMaybe<Scalars['Boolean']>;
  isCleared?: InputMaybe<Scalars['Boolean']>;
  lastActivityDate?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  oPayeeAddress?: InputMaybe<AddressInput>;
  oPayorPayeeId?: InputMaybe<Scalars['String']>;
  oTaxId?: InputMaybe<FundingTaxIdInput>;
  oWireTransfer?: InputMaybe<WireInput>;
  orderNumber?: InputMaybe<Scalars['String']>;
  payeeAddress?: InputMaybe<AddressInput>;
  payorPayeeId?: InputMaybe<Scalars['String']>;
  positivePayDate?: InputMaybe<Scalars['String']>;
  reconcileDate?: InputMaybe<Scalars['String']>;
  refNumber?: InputMaybe<Scalars['String']>;
  searchData?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusReason?: InputMaybe<Scalars['String']>;
  transactionCategory: Scalars['String'];
  transactionDate?: InputMaybe<Scalars['String']>;
  transferredOrderId?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  wireExpectedDate?: InputMaybe<Scalars['String']>;
  wireTransfer?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['EmailAddress']>;
  firstName?: InputMaybe<Scalars['String']>;
  homeL2Id?: InputMaybe<Scalars['ID']>;
  homeL3Id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  initials?: InputMaybe<Scalars['String']>;
  isDisclosureSettlementAgent?: InputMaybe<Scalars['Boolean']>;
  isUnderwriterAuthorizedSignatory?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  middleName?: InputMaybe<Scalars['String']>;
  nameSuffix?: InputMaybe<Scalars['String']>;
  nmlsId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<UserPhoneNumberInput>>>;
  profileImage?: InputMaybe<Scalars['String']>;
  security?: InputMaybe<UserSecurityInput>;
  securityV2?: InputMaybe<SecurityGroupV2AssignmentsInput>;
  securityVersion?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateUserSignatureImageInput = {
  id: Scalars['ID'];
  signatureImage: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type UpdateUserStatusInput = {
  id: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
  userStatus: Scalars['String'];
};

export type UploadRecordingFeesDocumentInput = {
  orderId: Scalars['String'];
  rfttFees: GetRfttFeesInput;
};

export type UploadRecordingFeesDocumentResponse = {
  __typename?: 'UploadRecordingFeesDocumentResponse';
  status: Scalars['String'];
};

export enum UploadStatus {
  Complete = 'Complete',
  Error = 'Error',
  Pending = 'Pending',
  Requested = 'Requested'
}

export enum UploadStatusV2 {
  Complete = 'Complete',
  Error = 'Error',
  Generating = 'Generating',
  Pending = 'Pending',
  Requested = 'Requested'
}

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  altaId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  department?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  emailAddress: Scalars['EmailAddress'];
  firstName: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  homeL2Id?: Maybe<Scalars['ID']>;
  homeL3Id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  initials?: Maybe<Scalars['String']>;
  isDisclosureSettlementAgent?: Maybe<Scalars['Boolean']>;
  isUnderwriterAuthorizedSignatory?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  licenses?: Maybe<Array<Maybe<License>>>;
  loginInfo?: Maybe<LoginInfoItem>;
  middleName?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  nmlsId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<UserPhoneNumberType>>>;
  profileImage?: Maybe<Scalars['String']>;
  recentOrders?: Maybe<Array<Maybe<Order>>>;
  security?: Maybe<SecurityGroupAssignments>;
  securityV2?: Maybe<SecurityGroupV2Assignments>;
  securityVersion?: Maybe<Scalars['String']>;
  signatureImageMergeable?: Maybe<Image>;
  tenantId: Scalars['ID'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type UserCredentialAgentNetStatus = {
  __typename?: 'UserCredentialAgentNetStatus';
  active: Scalars['Boolean'];
  error: Scalars['Boolean'];
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type UserDefaults = {
  __typename?: 'UserDefaults';
  branch?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  propertyState?: Maybe<Scalars['String']>;
  sequenceId?: Maybe<Scalars['String']>;
  statementType?: Maybe<Scalars['String']>;
  transactionTypeId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type UserDisplayNameV2 = {
  __typename?: 'UserDisplayNameV2';
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export type UserEnteredCommissions = {
  __typename?: 'UserEnteredCommissions';
  commissionBasisOverride?: Maybe<CommissionBasisOverride>;
  distributionMethod: Scalars['String'];
  id: Scalars['ID'];
  lineItems: Array<UserEnteredCommissionsLineItem>;
  sellerPaidPercentage?: Maybe<Scalars['Float']>;
  totalCommissionAmount: TotalCommissionAmountValue;
};

export type UserEnteredCommissionsLineItem = BaseOrderCommissionsLineItem & {
  __typename?: 'UserEnteredCommissionsLineItem';
  agentType: Scalars['String'];
  calculatedValue?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  party?: Maybe<OrderParty>;
  partyId: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type UserPhoneNumberInput = {
  ext?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  phoneNumber: Scalars['PhoneNumber'];
  type?: InputMaybe<Scalars['String']>;
};

export type UserPhoneNumberType = {
  __typename?: 'UserPhoneNumberType';
  ext?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  phoneNumber: Scalars['PhoneNumber'];
  phoneNumberFull?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UserProfileImage = {
  __typename?: 'UserProfileImage';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type UserSecurityAssignmentsInput = {
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  securityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UserSecurityInput = {
  securityAssignments?: InputMaybe<Array<InputMaybe<UserSecurityAssignmentsInput>>>;
};

export type UserSetCredentialAgentNet = {
  personalAccessToken?: InputMaybe<Scalars['String']>;
};

export type UserSignatureImage = {
  __typename?: 'UserSignatureImage';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  signatureImage?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type Va2012R5PForm = {
  __typename?: 'Va2012R5PForm';
  buyers?: Maybe<Array<Maybe<Va2012R5PFormBuyers>>>;
  sellers?: Maybe<Array<Maybe<Va2012R5PFormSellers>>>;
};

export type Va2012R5PFormBuyers = {
  __typename?: 'Va2012R5PFormBuyers';
  address?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  representatives?: Maybe<Va2012R5PFormRepresentatives>;
};

export type Va2012R5PFormRepresentatives = {
  __typename?: 'Va2012R5PFormRepresentatives';
  fifth?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['String']>;
  fourth?: Maybe<Scalars['String']>;
  second?: Maybe<Scalars['String']>;
  sixth?: Maybe<Scalars['String']>;
  third?: Maybe<Scalars['String']>;
};

export type Va2012R5PFormSellers = {
  __typename?: 'Va2012R5PFormSellers';
  address?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  representatives?: Maybe<Va2012R5PFormRepresentatives>;
};

export type ValidateRate = RateValidation & {
  __typename?: 'ValidateRate';
  missingFields: Array<Scalars['String']>;
  orderId: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type ValidateSdnInput = {
  childId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
  parentId: Scalars['ID'];
  recordType: SdnRecordType;
};

export type ValidateSdnResponse = OrderResponse & {
  __typename?: 'ValidateSdnResponse';
  childId?: Maybe<Scalars['ID']>;
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
  parentId: Scalars['ID'];
  sdnStatusDetails: SdnStatusDetails;
};

export type VerifiedAddress = {
  __typename?: 'VerifiedAddress';
  uspsData?: Maybe<VerifiedAddressUspsData>;
};

export type VerifiedAddressUspsData = {
  __typename?: 'VerifiedAddressUSPSData';
  abbreviatedCity?: Maybe<Scalars['String']>;
  addressRecordType?: Maybe<Scalars['String']>;
  carrierRoute?: Maybe<Scalars['String']>;
  carrierRouteIndicator?: Maybe<Scalars['String']>;
  cassProcessed?: Maybe<Scalars['Boolean']>;
  county?: Maybe<Scalars['String']>;
  defaultAddress?: Maybe<Scalars['Boolean']>;
  deliveryPointCheckDigit?: Maybe<Scalars['String']>;
  deliveryPointCode?: Maybe<Scalars['String']>;
  dpvCmra?: Maybe<Scalars['String']>;
  dpvConfirmation?: Maybe<Scalars['String']>;
  dpvDoorNotAccessible?: Maybe<Scalars['String']>;
  dpvDrop?: Maybe<Scalars['String']>;
  dpvEnhancedDeliveryCode?: Maybe<Scalars['String']>;
  dpvFootnote?: Maybe<Scalars['String']>;
  dpvNoSecureLocation?: Maybe<Scalars['String']>;
  dpvNoStat?: Maybe<Scalars['String']>;
  dpvNoStatReasonCode?: Maybe<Scalars['Int']>;
  dpvNonDeliveryDays?: Maybe<Scalars['String']>;
  dpvNonDeliveryDaysValues?: Maybe<Scalars['Int']>;
  dpvPbsa?: Maybe<Scalars['String']>;
  dpvThrowback?: Maybe<Scalars['String']>;
  dpvVacant?: Maybe<Scalars['String']>;
  elotFlag?: Maybe<Scalars['String']>;
  elotNumber?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  ewsNoMatch?: Maybe<Scalars['Boolean']>;
  fipsCountyCode?: Maybe<Scalars['String']>;
  lacsLinkIndicator?: Maybe<Scalars['String']>;
  lacsLinkReturnCode?: Maybe<Scalars['String']>;
  pmbDesignator?: Maybe<Scalars['String']>;
  pmbNumber?: Maybe<Scalars['String']>;
  poBoxOnlyPostalCode?: Maybe<Scalars['Boolean']>;
  postOfficeCity?: Maybe<Scalars['String']>;
  postOfficeState?: Maybe<Scalars['String']>;
  standardizedAddress?: Maybe<VerifiedAddressUspsDataStandardizedAddress>;
  suitelinkFootnote?: Maybe<Scalars['String']>;
};

export type VerifiedAddressUspsDataStandardizedAddress = {
  __typename?: 'VerifiedAddressUSPSDataStandardizedAddress';
  city?: Maybe<Scalars['String']>;
  cityStateZipAddressLine?: Maybe<Scalars['String']>;
  firstAddressLine?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  zipCodeExtension?: Maybe<Scalars['String']>;
};

export type VoidTitleCplInput = {
  cplId: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type Warning = {
  __typename?: 'Warning';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type WireInput = {
  beneficiaryBank?: InputMaybe<BeneficiaryBankInput>;
  receivingBank?: InputMaybe<ReceivingBankInput>;
  recipientAccountNum?: InputMaybe<Scalars['String']>;
  recipientAddress?: InputMaybe<AddressInput>;
  recipientName?: InputMaybe<Scalars['String']>;
};

export type WireManagement = {
  __typename?: 'WireManagement';
  amount?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  dateFunding?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  escrowAccountName?: Maybe<Scalars['String']>;
  escrowAcctName?: Maybe<Scalars['String']>;
  finalizedPayorPayeeData?: Maybe<FinalizedPayorPayeeData>;
  fundingTransactionType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isClear?: Maybe<Scalars['Boolean']>;
  isCleared?: Maybe<Scalars['Boolean']>;
  isUserCreated?: Maybe<Scalars['Boolean']>;
  lastActivityDate?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  oPayeeAddress?: Maybe<Address>;
  oPayorPayeeId?: Maybe<Scalars['String']>;
  oTaxId?: Maybe<FundingTaxId>;
  oWireTransfer?: Maybe<WireSchema>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  payorPayeeDisplayName?: Maybe<Scalars['String']>;
  payorPayeeId?: Maybe<Scalars['String']>;
  payorPayeeString_sk?: Maybe<Scalars['String']>;
  payorPayeeType?: Maybe<Scalars['String']>;
  positivePayDate?: Maybe<Scalars['String']>;
  reconcileDate?: Maybe<Scalars['String']>;
  refNumber?: Maybe<Scalars['String']>;
  searchData?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusReason?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  transactionCategory?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transferredOrderId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  wireExpectedDate?: Maybe<Scalars['String']>;
};

export type WireSchema = {
  __typename?: 'WireSchema';
  beneficiaryBank?: Maybe<BeneficiaryBankSchema>;
  receivingBank?: Maybe<ReceivingBankSchema>;
  recipientAccountNum?: Maybe<Scalars['String']>;
  recipientAddress?: Maybe<Address>;
  recipientName?: Maybe<Scalars['String']>;
  unmaskedRecipientAccountNum?: Maybe<Scalars['String']>;
};

export type Workflow = {
  __typename?: 'Workflow';
  active?: Maybe<Scalars['Boolean']>;
  companies?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy?: Maybe<User>;
  createdById: Scalars['ID'];
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  milestones?: Maybe<Array<Maybe<Milestone>>>;
  name: Scalars['String'];
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  transactionPurpose?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type WrappedClausePackageResponse = {
  __typename?: 'WrappedClausePackageResponse';
  clausePackages: Array<Maybe<ClausePackage>>;
};

export type WrappedClauseTemplateResponse = {
  __typename?: 'WrappedClauseTemplateResponse';
  clauseTemplates: Array<Maybe<ClauseTemplate>>;
};

export type WrappedPayoff = {
  __typename?: 'WrappedPayoff';
  order?: Maybe<Order>;
  payoffs?: Maybe<Array<Maybe<Payoff>>>;
};

export type Unnamed_1_QueryVariables = Exact<{ [key: string]: never; }>;


export type Unnamed_1_Query = { __typename?: 'Query', configuration?: { __typename?: 'Configuration', contentful?: { __typename?: 'ContentfulConfiguration', contentDeliveryApiKey?: string | null | undefined, contentPreviewApiKey?: string | null | undefined, isPreview?: boolean | null | undefined, spaceId?: string | null | undefined } | null | undefined } | null | undefined };

export type AdjustmentFieldsFragment = { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } };

export type GetDcAdjustmentsQueryVariables = Exact<{
  orderId: Scalars['String'];
  statementType: Scalars['String'];
  statementSections?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetDcAdjustmentsQuery = { __typename?: 'Query', getDcAdjustments: { __typename?: 'GetAdjustmentsResponse', adjustments: Array<{ __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } }> } };

export type GetAdjustmentStatementSectionTotalsQueryVariables = Exact<{
  orderId: Scalars['String'];
  statementType: Scalars['String'];
  statementSections: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetAdjustmentStatementSectionTotalsQuery = { __typename?: 'Query', getAdjustmentStatementSectionTotals?: { __typename?: 'AltaSectionSummaryTotals', debitBorrower: number, creditBorrower: number, debitSeller?: number | null | undefined, creditSeller?: number | null | undefined, toFromBorrower: number, toFromSeller?: number | null | undefined, totalBorrowerDebit: number, totalBorrowerCredit: number, totalSellerDebit?: number | null | undefined, totalSellerCredit?: number | null | undefined } | { __typename?: 'SectionSummariesTotalsWithSeller', totalDueFromBorrower: number, totalPaidByBorrower: number, totalDueToSeller: number, totalDueFromSeller: number, borrowerCalcTotal: number, sellerCalcTotal: number } | { __typename?: 'SectionSummariesTotalsWithoutSeller', totalDueFromBorrower: number, totalPaidByBorrower: number, borrowerCalcTotal: number } | null | undefined };

export type CreateDcAdjustmentMutationVariables = Exact<{
  input: CreateDcAdjustmentInput;
}>;


export type CreateDcAdjustmentMutation = { __typename?: 'Mutation', createDcAdjustment: { __typename?: 'AdjustmentResponseWithMirror', adjustment: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } }, mirrorAdjustment?: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } } | null | undefined } };

export type UpdateDcAdjustmentMutationVariables = Exact<{
  input: UpdateDcAdjustmentInput;
}>;


export type UpdateDcAdjustmentMutation = { __typename?: 'Mutation', updateDcAdjustment: { __typename?: 'AdjustmentResponseWithMirror', adjustment: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } }, mirrorAdjustment?: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } } | null | undefined } };

export type DeleteDcAdjustmentMutationVariables = Exact<{
  input: DeleteDcAdjustmentInput;
}>;


export type DeleteDcAdjustmentMutation = { __typename?: 'Mutation', deleteDcAdjustment: { __typename?: 'AdjustmentResponseWithMirror', adjustment: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } }, mirrorAdjustment?: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } } | null | undefined } };

export type ClearDcAdjustmentMutationVariables = Exact<{
  input: ClearDcAdjustmentInput;
}>;


export type ClearDcAdjustmentMutation = { __typename?: 'Mutation', clearDcAdjustment: { __typename?: 'AdjustmentResponseWithMirror', adjustment: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } }, mirrorAdjustment?: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } } | null | undefined } };

export type OverrideMetadataNumberFieldsFragment = { __typename?: 'OverrideMetadataNumber', effectiveValue?: number | null | undefined, overrideValue?: number | null | undefined, fallbackValue?: number | null | undefined, overridden: boolean };

export type OverrideMetadataStringFieldsFragment = { __typename?: 'OverrideMetadataString', effectiveValue?: string | null | undefined, overrideValue?: string | null | undefined, fallbackValue?: string | null | undefined, overridden: boolean };

export const AdjustmentFieldsFragmentDoc = gql`
    fragment AdjustmentFields on Adjustment {
  id
  tenantId
  orderId
  lineType
  description
  isDebitCredit
  lineMapping {
    cd {
      lineNumber
      addendumLineNumber
    }
    alta {
      lineNumber
      addendumLineNumber
    }
    hud2010 {
      lineNumber
      addendumLineNumber
    }
    hud1986 {
      lineNumber
      addendumLineNumber
    }
  }
  sectionMapping {
    cd
    alta
    hud2010
    hud1986
  }
  dcLineMapping {
    cd {
      lineNumber
      addendumLineNumber
    }
    alta {
      lineNumber
      addendumLineNumber
    }
    hud2010 {
      lineNumber
      addendumLineNumber
    }
    hud1986 {
      lineNumber
      addendumLineNumber
    }
  }
  dcSectionMapping {
    cd
    alta
    hud2010
    hud1986
  }
  defaultLineMapping {
    cdAlta
    hud2010
    hud1986
  }
  payeePayorId
  amount
  externalItemId
  createdTimestamp
  updatedTimestamp
  createdBy
  updatedBy
}
    `;
export const OverrideMetadataNumberFieldsFragmentDoc = gql`
    fragment OverrideMetadataNumberFields on OverrideMetadataNumber {
  effectiveValue
  overrideValue
  fallbackValue
  overridden
}
    `;
export const OverrideMetadataStringFieldsFragmentDoc = gql`
    fragment OverrideMetadataStringFields on OverrideMetadataString {
  effectiveValue
  overrideValue
  fallbackValue
  overridden
}
    `;
export const Document = gql`
    {
  configuration {
    contentful {
      contentDeliveryApiKey
      contentPreviewApiKey
      isPreview
      spaceId
    }
  }
}
    `;
export const GetDcAdjustmentsDocument = gql`
    query GetDcAdjustments($orderId: String!, $statementType: String!, $statementSections: [String!]) {
  getDcAdjustments(
    orderId: $orderId
    statementType: $statementType
    statementSections: $statementSections
  ) {
    adjustments {
      ...AdjustmentFields
    }
  }
}
    ${AdjustmentFieldsFragmentDoc}`;

/**
 * __useGetDcAdjustmentsQuery__
 *
 * To run a query within a React component, call `useGetDcAdjustmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDcAdjustmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDcAdjustmentsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      statementType: // value for 'statementType'
 *      statementSections: // value for 'statementSections'
 *   },
 * });
 */
export function useGetDcAdjustmentsQuery(baseOptions: Apollo.QueryHookOptions<GetDcAdjustmentsQuery, GetDcAdjustmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDcAdjustmentsQuery, GetDcAdjustmentsQueryVariables>(GetDcAdjustmentsDocument, options);
      }
export function useGetDcAdjustmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDcAdjustmentsQuery, GetDcAdjustmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDcAdjustmentsQuery, GetDcAdjustmentsQueryVariables>(GetDcAdjustmentsDocument, options);
        }
export type GetDcAdjustmentsQueryHookResult = ReturnType<typeof useGetDcAdjustmentsQuery>;
export type GetDcAdjustmentsLazyQueryHookResult = ReturnType<typeof useGetDcAdjustmentsLazyQuery>;
export type GetDcAdjustmentsQueryResult = Apollo.QueryResult<GetDcAdjustmentsQuery, GetDcAdjustmentsQueryVariables>;
export const GetAdjustmentStatementSectionTotalsDocument = gql`
    query GetAdjustmentStatementSectionTotals($orderId: String!, $statementType: String!, $statementSections: [String!]!) {
  getAdjustmentStatementSectionTotals(
    orderId: $orderId
    statementType: $statementType
    statementSections: $statementSections
  ) {
    ... on SectionSummariesTotalsWithSeller {
      totalDueFromBorrower
      totalPaidByBorrower
      totalDueToSeller
      totalDueFromSeller
      borrowerCalcTotal
      sellerCalcTotal
    }
    ... on SectionSummariesTotalsWithoutSeller {
      totalDueFromBorrower
      totalPaidByBorrower
      borrowerCalcTotal
    }
    ... on AltaSectionSummaryTotals {
      debitBorrower
      creditBorrower
      debitSeller
      creditSeller
      toFromBorrower
      toFromSeller
      totalBorrowerDebit
      totalBorrowerCredit
      totalSellerDebit
      totalSellerCredit
    }
  }
}
    `;

/**
 * __useGetAdjustmentStatementSectionTotalsQuery__
 *
 * To run a query within a React component, call `useGetAdjustmentStatementSectionTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdjustmentStatementSectionTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdjustmentStatementSectionTotalsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      statementType: // value for 'statementType'
 *      statementSections: // value for 'statementSections'
 *   },
 * });
 */
export function useGetAdjustmentStatementSectionTotalsQuery(baseOptions: Apollo.QueryHookOptions<GetAdjustmentStatementSectionTotalsQuery, GetAdjustmentStatementSectionTotalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdjustmentStatementSectionTotalsQuery, GetAdjustmentStatementSectionTotalsQueryVariables>(GetAdjustmentStatementSectionTotalsDocument, options);
      }
export function useGetAdjustmentStatementSectionTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdjustmentStatementSectionTotalsQuery, GetAdjustmentStatementSectionTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdjustmentStatementSectionTotalsQuery, GetAdjustmentStatementSectionTotalsQueryVariables>(GetAdjustmentStatementSectionTotalsDocument, options);
        }
export type GetAdjustmentStatementSectionTotalsQueryHookResult = ReturnType<typeof useGetAdjustmentStatementSectionTotalsQuery>;
export type GetAdjustmentStatementSectionTotalsLazyQueryHookResult = ReturnType<typeof useGetAdjustmentStatementSectionTotalsLazyQuery>;
export type GetAdjustmentStatementSectionTotalsQueryResult = Apollo.QueryResult<GetAdjustmentStatementSectionTotalsQuery, GetAdjustmentStatementSectionTotalsQueryVariables>;
export const CreateDcAdjustmentDocument = gql`
    mutation CreateDcAdjustment($input: CreateDcAdjustmentInput!) {
  createDcAdjustment(input: $input) {
    adjustment {
      ...AdjustmentFields
    }
    mirrorAdjustment {
      ...AdjustmentFields
    }
  }
}
    ${AdjustmentFieldsFragmentDoc}`;
export type CreateDcAdjustmentMutationFn = Apollo.MutationFunction<CreateDcAdjustmentMutation, CreateDcAdjustmentMutationVariables>;

/**
 * __useCreateDcAdjustmentMutation__
 *
 * To run a mutation, you first call `useCreateDcAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDcAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDcAdjustmentMutation, { data, loading, error }] = useCreateDcAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDcAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDcAdjustmentMutation, CreateDcAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDcAdjustmentMutation, CreateDcAdjustmentMutationVariables>(CreateDcAdjustmentDocument, options);
      }
export type CreateDcAdjustmentMutationHookResult = ReturnType<typeof useCreateDcAdjustmentMutation>;
export type CreateDcAdjustmentMutationResult = Apollo.MutationResult<CreateDcAdjustmentMutation>;
export type CreateDcAdjustmentMutationOptions = Apollo.BaseMutationOptions<CreateDcAdjustmentMutation, CreateDcAdjustmentMutationVariables>;
export const UpdateDcAdjustmentDocument = gql`
    mutation UpdateDcAdjustment($input: UpdateDcAdjustmentInput!) {
  updateDcAdjustment(input: $input) {
    adjustment {
      ...AdjustmentFields
    }
    mirrorAdjustment {
      ...AdjustmentFields
    }
  }
}
    ${AdjustmentFieldsFragmentDoc}`;
export type UpdateDcAdjustmentMutationFn = Apollo.MutationFunction<UpdateDcAdjustmentMutation, UpdateDcAdjustmentMutationVariables>;

/**
 * __useUpdateDcAdjustmentMutation__
 *
 * To run a mutation, you first call `useUpdateDcAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDcAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDcAdjustmentMutation, { data, loading, error }] = useUpdateDcAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDcAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDcAdjustmentMutation, UpdateDcAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDcAdjustmentMutation, UpdateDcAdjustmentMutationVariables>(UpdateDcAdjustmentDocument, options);
      }
export type UpdateDcAdjustmentMutationHookResult = ReturnType<typeof useUpdateDcAdjustmentMutation>;
export type UpdateDcAdjustmentMutationResult = Apollo.MutationResult<UpdateDcAdjustmentMutation>;
export type UpdateDcAdjustmentMutationOptions = Apollo.BaseMutationOptions<UpdateDcAdjustmentMutation, UpdateDcAdjustmentMutationVariables>;
export const DeleteDcAdjustmentDocument = gql`
    mutation DeleteDcAdjustment($input: DeleteDcAdjustmentInput!) {
  deleteDcAdjustment(input: $input) {
    adjustment {
      ...AdjustmentFields
    }
    mirrorAdjustment {
      ...AdjustmentFields
    }
  }
}
    ${AdjustmentFieldsFragmentDoc}`;
export type DeleteDcAdjustmentMutationFn = Apollo.MutationFunction<DeleteDcAdjustmentMutation, DeleteDcAdjustmentMutationVariables>;

/**
 * __useDeleteDcAdjustmentMutation__
 *
 * To run a mutation, you first call `useDeleteDcAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDcAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDcAdjustmentMutation, { data, loading, error }] = useDeleteDcAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDcAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDcAdjustmentMutation, DeleteDcAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDcAdjustmentMutation, DeleteDcAdjustmentMutationVariables>(DeleteDcAdjustmentDocument, options);
      }
export type DeleteDcAdjustmentMutationHookResult = ReturnType<typeof useDeleteDcAdjustmentMutation>;
export type DeleteDcAdjustmentMutationResult = Apollo.MutationResult<DeleteDcAdjustmentMutation>;
export type DeleteDcAdjustmentMutationOptions = Apollo.BaseMutationOptions<DeleteDcAdjustmentMutation, DeleteDcAdjustmentMutationVariables>;
export const ClearDcAdjustmentDocument = gql`
    mutation ClearDcAdjustment($input: ClearDcAdjustmentInput!) {
  clearDcAdjustment(input: $input) {
    adjustment {
      ...AdjustmentFields
    }
    mirrorAdjustment {
      ...AdjustmentFields
    }
  }
}
    ${AdjustmentFieldsFragmentDoc}`;
export type ClearDcAdjustmentMutationFn = Apollo.MutationFunction<ClearDcAdjustmentMutation, ClearDcAdjustmentMutationVariables>;

/**
 * __useClearDcAdjustmentMutation__
 *
 * To run a mutation, you first call `useClearDcAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearDcAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearDcAdjustmentMutation, { data, loading, error }] = useClearDcAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearDcAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<ClearDcAdjustmentMutation, ClearDcAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearDcAdjustmentMutation, ClearDcAdjustmentMutationVariables>(ClearDcAdjustmentDocument, options);
      }
export type ClearDcAdjustmentMutationHookResult = ReturnType<typeof useClearDcAdjustmentMutation>;
export type ClearDcAdjustmentMutationResult = Apollo.MutationResult<ClearDcAdjustmentMutation>;
export type ClearDcAdjustmentMutationOptions = Apollo.BaseMutationOptions<ClearDcAdjustmentMutation, ClearDcAdjustmentMutationVariables>;
